<template>
    <div class="chat-page">
        <!-- <div class="chat-header">
            <div class="chat-title">智能客服</div>
        </div> -->

        <!-- 语言选择器（下拉） -->
        <!-- <div class="language-dropdown-wrapper">
            <button class="lang-icon-btn" @click="toggleLangDropdown">
                <img src="@/assets/language.png" class="lang-icon" alt="language" />
            </button>
            <div v-if="showLangDropdown" class="lang-dropdown-menu">
                <div class="lang-dropdown-item" :class="{ active: currentLang === 'zh' }"
                    @click="switchLanguage('zh'); showLangDropdown = false">中文</div>
                <div class="lang-dropdown-item" :class="{ active: currentLang === 'en' }"
                    @click="switchLanguage('en'); showLangDropdown = false">English</div>
            </div>
        </div> -->
        <!-- 语言选择器（扩展支持10种语言，保持现有变量名） -->
        <div class="language-dropdown-wrapper">
            <button class="lang-icon-btn" @click="toggleLangDropdown" :title="t('languageFeatureTitle')">
                <img src="@/assets/language.png" class="lang-icon" alt="language" />
            </button>
            <div v-if="showLangDropdown" class="lang-dropdown-menu">
                <div v-for="(lang, code) in LANGUAGE_CONFIG" 
                        :key="code"
                        class="lang-dropdown-item" 
                        :class="{ active: currentLang === code }"
                        @click="switchLanguage(code); showLangDropdown = false">
                    {{ lang.nativeName }}
                </div>
            </div>
        </div>

        <!-- 功能图标区域--> 
        <div class="feature-icons-wrapper" v-show="!showLangDropdown">
          <!--    <button class="feature-icon-btn" @click="toggleTTS" :title="t('ttsFeatureTitle')">
                <img src="@/assets/TTS.png" class="feature-icon-img" alt="TTS" />
            </button>--> 
            <button class="feature-icon-btn" @click="showTicketFeature" :title="t('ticketFeatureTitle')">
                <img src="@/assets/gd.png" class="feature-icon-img" alt="Bug提交" />
            </button>
              
              <button class="feature-icon-btn refresh-f5-btn" @click="showRefreshButtonClick" :title="t('refreshPage')">
                F5
            </button>
        </div>

        <!-- 介绍页面 -->
        <!-- <div v-if="chatState === 'intro'" class="intro-container">
            <div class="intro-content">
                <div class="intro-logo">
                    <div class="logo-circle">
                        <img src="@/assets/jc.png" class="logo-img" alt="捷昌驱动" />
                    </div>
                </div>
                <div class="intro-text">
                    <h2 class="intro-title">{{ t('introTitle') }}</h2>
                    <p class="intro-description">{{ t('introDescription') }}</p>
                </div>
            </div>
        </div> -->
        <!-- 改为动态 -->
         <!-- Intro页面 -->
        <div v-if="chatState === 'intro'" class="intro-container">
            <div class="intro-content">
                <div class="intro-logo">
                    <div class="logo-circle">
                        <!-- 使用动态配置的logo -->
                        <img :src="introConfig?.logo" class="logo-img" alt="捷昌驱动" />
                    </div>
                </div>
                <div class="intro-text">
                    <!-- 使用动态配置的标题和描述 -->
                    <h2 class="intro-title">{{ introConfig?.title }}</h2>
                    <p class="intro-description">{{ introConfig?.description }}</p>
                </div>
            </div>
        </div>

        <!-- 聊天容器 -->
        <div v-else class="chat-container" ref="chatContainer">
            <!-- 新增：加载更多历史消息的状态提示 -->
            <div v-if="isLoadingMore" class="loading-more-indicator">
                <span class="loading-dots">
                    <span>.</span><span>.</span><span>.</span>
                </span>
                加载更多历史消息...
            </div>
            
            <div v-if="chatState === 'welcome'" class="message bot">
                {{ t('welcomeMessage') }}
            </div>
            <div v-for="(message, index) in messages" :key="index"
                :class="['message', message.isUser ? 'user' : 'bot']">


                <template v-if="message.type === 'system' && message.action === 'refresh-required'">
                    <div class="system-message refresh-required">
                        <button @click="handleRefresh" class="refresh-button">
                            {{ currentLang === 'zh' ? '刷新' : 'Refresh' }}
                        </button>
                        <p class="refresh-text">{{ currentLang === 'zh' ? '会话丢失，请刷新' : 'Session lost, please refresh' }}</p>
                    </div>
                </template>
                <template v-else-if="message.type === 'text'">
                    <div 
                        class="message bot ai-text-separate markdown-body" 
                        :class="{ 'ai-message-content': !message.isUser }"
                        v-html="renderMarkdown(message.text)" 
                        @click="handleHtmlClick"
                    ></div>
                    <!-- 添加表情  反馈按钮 -->
        <!-- 仅在AI消息且已成功完成，并且不是当前正在流式返回的那条时显示评价按钮 -->
        <div class="ai-feedback-buttons" v-if="(!message.isUser) && message.userMessageId && message.isSuccess === 1 && !(isStreamingResponse && message.userMessageId === streamingMessageId)">
            <button class="feedback-btn like-btn" @click="handleFeedback(index, 'like')" :class="{ active: message.feedback === 'like' }" :key="`like-${index}-${message.feedback}`">
                <img :src="xiaoIcon" alt="like" class="feedback-icon" />
            </button>
            <button class="feedback-btn dislike-btn" @click="handleFeedback(index, 'dislike')" :class="{ active: message.feedback === 'dislike' }" :key="`dislike-${index}-${message.feedback}`">
                <img :src="kuIcon" alt="dislike" class="feedback-icon" />
            </button>
        <button class="feedback-btn tts-btn" @click="handlePlayTTS3(index, message.userMessageId)">
            <img :src="message.isPlayingTTS ? kaiIcon : guanIcon" alt="TTS" class="feedback-icon" />
        </button>
        <!-- <button class="feedback-btn more-btn" @click="showFeedbackDialog(index, message)">
            <span>⋯</span>
        </button> -->
        
        <!-- 点踩评价弹窗 -->
        <div 
            v-if="message.showDislikePopup"
            class="dislike-feedback-popup"
            :style="index === messages.length - 1 && messages.length!=2? { bottom: 'calc(100% + 8px)', top: 'auto' } : { top: 'calc(100% + 8px)', bottom: 'auto' }"
        >
            <div class="dislike-popup-content" @click.stop>
                <div class="dislike-popup-title">{{ t('dislikePopupTitle') }}</div>
                <div class="dislike-options">
                    <button 
                        v-for="(option, idx) in dislikeOptionLabels" 
                        :key="idx"
                        class="dislike-option-btn"
                        :class="{ active: message.dislikeOptions === idx + 1 }"
                        @click="message.dislikeOptions = idx + 1"
                    >
                        {{ option }}
                    </button>
                </div>
                <div class="dislike-textarea-wrapper">
                    <textarea 
                        v-model="message.dislikeReason"
                        :placeholder="t('dislikeReasonPlaceholder')"
                        class="dislike-textarea"
                        rows="3"
                        maxlength="300"
                    ></textarea>
                    <div class="dislike-textarea-counter">
                        {{ (message.dislikeReason || '').length }}/300
                    </div>
                </div>
                <div class="dislike-popup-footer">
                    <button class="dislike-cancel-btn" @click="closeAllDislikePopups()">{{ t('cancelButton') }}</button>
                    <button class="dislike-submit-btn" @click="submitDislikeFeedback(index, message)">{{ t('submitButton') }}</button>
                </div>
            </div>
        </div>
    </div>


    
    <!-- 显示当前AI消息的反馈信息（feedback / fk / suggest） -->
    <div v-if="!message.isUser && message.feedback" class="ai-feedback-meta">
        <span v-if="message.feedback === 1">{{ 'Like' }}</span>
        <span v-else-if="message.feedback === 2">{{'Dislike' }}</span>
        <!-- <span v-if="message.fk && message.fk > 0">｜{{ getFkText(message.fk) }}</span>
        <span v-if="message.suggest && message.suggest.trim()">｜{{ message.suggest }}</span> -->
    </div>
    <!-- 添加调试信息 -->
    <!-- <div v-if="!message.isUser" style="background: yellow; padding: 5px; margin: 5px;">
        调试信息: 
        userMessageId: {{ message.userMessageId }}, 
        isSuccess: {{ message.isSuccess }}, 
        feedback: {{ message.feedback }}
    </div> -->
                </template>
                <template v-else-if="message.type === 'image'">
                    <img :src="message.url" class="message-image" @click="previewImage(message.url)" />
                </template>
                <template v-else-if="message.type === 'voice'">
                    <!-- 客户提问的语音消息 -->
                    <div v-if="message.isUser" class="voice-message user-voice-simple">
                        <audio controls :src="message.url"></audio>
                    </div>
                    <!-- AI回复的语音消息 -->
                    <div v-else class="voice-message bot-voice" style="position: relative;">
                        <audio controls :src="message.url"></audio>
                        <template v-if="message.text">
                            <button class="expand-text-btn-float" @click="message.showText = !message.showText">
                                {{ message.showText ? t('collapseText') : t('expandText') }}
                            </button>
                        </template>
                    </div>
                    <template v-if="message.text && message.showText && !message.isUser">
                        <div class="message bot ai-text-separate markdown-body" v-html="renderMarkdown(message.text)"></div>
                        <!-- 语音消息也显示反馈按钮 -->
        <!-- 仅在AI消息且已成功完成，并且不是当前正在流式返回的那条时显示评价按钮（语音等分支） -->
        <div class="ai-feedback-buttons" v-if="(!message.isUser) && message.userMessageId && message.isSuccess === 1 && !(isStreamingResponse && message.userMessageId === streamingMessageId)">
            <button class="feedback-btn like-btn" @click="handleFeedback(index, 'like')" :class="{ active: message.feedback === 'like' }">
                <img :src="xiaoIcon" alt="like" class="feedback-icon" />
            </button>
            <button class="feedback-btn dislike-btn" @click="handleFeedback(index, 'dislike')" :class="{ active: message.feedback === 'dislike' }">
                <img :src="kuIcon" alt="dislike" class="feedback-icon" />
            </button>
            <button class="feedback-btn tts-btn" @click="handlePlayTTS(index, message.userMessageId)">
                <img :src="message.isPlayingTTS ? kaiIcon : guanIcon" alt="TTS" class="feedback-icon" />
            </button>
            <button class="feedback-btn more-btn" @click="showFeedbackDialog(index, message)">
                <span>⋯</span>
            </button>
        </div>
        <!-- 语音消息的反馈信息展示 -->
        <div v-if="!message.isUser && message.feedback" class="ai-feedback-meta">
            <span v-if="message.feedback === 1">{{ t('feedbackOptionLike') || 'Like' }}</span>
            <span v-else-if="message.feedback === 2">{{ t('feedbackOptionDislike') || 'Dislike' }}</span>
            <!-- <span v-if="message.fk && message.fk > 0">｜{{ getFkText(message.fk) }}</span>
            <span v-if="message.suggest && message.suggest.trim()">｜{{ message.suggest }}</span> -->
        </div>
                    </template>
                </template>
                <template v-else-if="message.type === 'mixed'">
                    <div class="mixed-message-text" v-if="message.text">{{ message.text }}</div>
                    <div class="mixed-message-images" v-if="message.images && message.images.length > 0">
                        <img v-for="(img, idx) in message.images" :key="img + '-' + idx" :src="img"
                            class="message-image" @click="previewImage(img, message.images)" />
                    </div>
                    <div class="mixed-message-videos" v-if="message.videos && message.videos.length > 0">
                        <video v-for="(video, idx) in message.videos" :key="video + '-' + idx" :src="video"
                            class="message-video" controls preload="metadata" />
                    </div>
                </template>
                <template v-else-if="message.type === 'loading'">
                    <span class="thinking-dots"><span>.</span><span>.</span><span>.</span></span>
                </template>
            </div>

            <div v-if="isTyping" class="typing-indicator">
                <div class="typing-dot"></div>
                <div class="typing-dot"></div>
                <div class="typing-dot"></div>
            </div>
        </div>

        <!-- 恢复经典分块式输入区 -->
        <div class="chat-input-container" :class="{ 'keyboard-open': isKeyboardOpen }">
            <div class="image-preview-bar" v-if="previewImages.length">
                <div class="image-preview-box" v-for="(img, idx) in previewImages" :key="img + '-' + idx">
                    <img :src="img" class="preview-image" />
                    <button class="remove-image" @click="removePreviewImage(idx)">
                        <el-icon>
                            <Close />
                        </el-icon>
                    </button>
                </div>
            </div>
            <div v-if="isUploadingImage" class="image-uploading-tip">
                {{ t('imageUploading') }}<span class="uploading-dots"><span>.</span><span>.</span><span>.</span></span>
            </div>
            <div class="chat-input-wrapper">
                <div class="input-actions">
                    <label class="action-button" :class="{ disabled: previewImages.length >= 1 || isUploadingImage || isAiResponding }">
                        <input ref="fileInputRef" type="file" accept="image/*" @change="handleImageUpload"
                            style="display: none" :disabled="previewImages.length >= 1 || isUploadingImage || isAiResponding">
                        <el-icon :style="{ opacity: isAiResponding ? '0.3' : '1' }">
                            <Picture />
                        </el-icon>
                    </label>
                    <button class="action-button" @click="checkMicrophonePermission" :disabled="previewImages.length > 0 || isUploadingImage || isAiResponding">
                        <el-icon :style="{ opacity: isAiResponding ? '0.3' : '1' }">
                            <Microphone />
                        </el-icon>
                    </button>
                </div>
                <div class="input-content">
                    <!-- <input ref="inputRef" type="text" class="chat-input" v-model="inputMessage"
                        @keyup.enter="sendMessage" @focus="handleInputFocus" @blur="handleInputBlur"
                        :placeholder="chatState === 'intro' ? t('introPlaceholder') : t('inputPlaceholder')" enterkeyhint="send"
                        :disabled="isAiResponding"> -->
                        <textarea 
                        ref="inputRef" 
                        type="text" 
                        class="chat-input" 
                        v-model="inputMessage"
                        @keyup.enter="sendMessage" 
                        @focus="handleInputFocus" 
                        @blur="handleInputBlur"
                        :placeholder="introConfig?.input_placeholder" 
                        enterkeyhint="send"
                        :disabled="isAiResponding">
                        </textarea>
                </div>
                <!-- 输入框 -->
                <button 
    class="send-button" 
    @click="isRequestCancellable ? cancelCurrentRequest() : sendMessage()"
    :disabled="(!canSend && !isRequestCancellable)|| isUploadingImage"
>
    <!-- 根据状态显示不同图标 -->
    <el-icon v-if="!isRequestCancellable" :style="{ color: '#fff', fontSize: '22px' }">
        <Promotion />
    </el-icon>
    <div v-else class="stop-square"></div>
</button>
                <!-- <button class="send-button" @click="sendMessage" :disabled="!canSend || isUploadingImage || isAiResponding">
                    <el-icon :style="{ color: isAiResponding ? '#ccc' : '#fff', fontSize: '22px' }">
                        <Promotion />
                    </el-icon>
                </button> -->
                <!-- <button 
    @click="isRequestCancellable ? cancelCurrentRequest() : sendMessage()"
    :disabled="!canSend && !isRequestCancellable"
    :class="isRequestCancellable ? 'stop-button' : 'send-button'"
>
    {{ isRequestCancellable ? '⏹️' : '发送' }}
</button> -->
            </div>
        </div>

        <!-- 现代化录音弹窗 -->
        <div v-if="showRecordModal" class="modern-recording-modal" @click.self="cancelRecording">
            <div class="recording-modal-content" @click.stop>
                <div class="recording-circle-btn" @click="handleRecordClick">
                    <div class="recording-mic">
                        <el-icon>
                            <Microphone />
                        </el-icon>
                    </div>
                </div>
                <div class="recording-status">
                    <span v-if="!isRecording">{{ t('clickToTalk') }}</span>
                    <span v-else>{{ t('speaking') }} {{ recordingTime }}s</span>
                </div>
            </div>
            
        </div>

         <!-- ✅ 在这里添加实时语音转文字显示框 -->
            <!-- <div v-if="isRecording" class="realtime-asr-text-display">
                    <div class="asr-text-container">
                        <p class="asr-text-label">实时识别：</p>
                        <div class="asr-text-content">{{ realTimeRecognizedText || '正在识别...' }}</div>
                    </div>
                </div> -->

        <el-image-viewer v-if="showImageViewer" :url-list="imageList" :initial-index="imageIndex"
            @close="showImageViewer = false" />

        <!-- 页面中间刷新按钮（点击WS按钮后显示） -->
        <div v-if="showRefreshButton" class="center-refresh-overlay" @click.self="showRefreshButton = false">
            <div class="center-refresh-container">
                <p class="center-refresh-tip">{{ t('refreshWarning') }}</p>
                <button @click="handleRefresh" class="center-refresh-button">
                    {{ t('refreshPage') }}
                </button>
                <button @click="showRefreshButton = false" class="center-refresh-close">×</button>
            </div>
        </div>

        
<el-dialog
    v-model="showPCDialog"
    :title="tb('bugDialogTitle')"
    :width="isMobile ? '84%' : '500px'"
    :before-close="handlePCDialogClose"
>
    <!-- PC端：使用日期时间选择器和富文本编辑器 -->
    <div v-if="!isMobile" class="pc-bug-form">
        <!-- 时间字段 -->
        <div class="time-fields">
            <el-date-picker
                v-model="pcBugData.date"
                type="date"
                :placeholder="tb('bugDatePlaceholder')"
                style="width: 48%;"
            />
            <el-time-picker
                v-model="pcBugData.time"
                :placeholder="tb('bugTimePlaceholder')"
                style="width: 48%;"
            />
        </div>
        
        <!-- 富文本编辑器 -->
        <div class="rich-editor">
            <div
                ref="richEditor"
                contenteditable="true"
                @paste="handleImagePaste"
                @input="handleRichTextInput"
                class="rich-text-area"
                :placeholder="tb('bugDescriptionPlaceholder')"
            ></div>
        </div>
    </div>
    
    <!-- 移动端：使用原生input和文件上传 -->
    <div v-else class="mobile-bug-form">
        <!-- 时间字段 -->
        <div class="time-fields">
            <label class="field-label">{{ tb('bugDateLabel') }}</label>
            <div class="time-inputs">
                <input 
                    type="date" 
                    v-model="mobileBugData.date"
                    class="date-input"
                />
                <input 
                    type="time" 
                    v-model="mobileBugData.time"
                    class="time-input"
                />
            </div>
        </div>
        
        <!-- 图片上传 -->
        <div class="screenshot-field">
            <label class="field-label">{{ tb('bugScreenshotLabel') }}</label>
            <input 
                type="file" 
                id="bugScreenshot"
                accept="image/*" 
                @change="handleMobileImageUpload"
                class="file-input"
            />
            <div v-if="mobileBugData.screenshotPreview" class="image-preview">
                <img :src="mobileBugData.screenshotPreview" alt="预览" />
                <button type="button" @click="removeMobileImage" class="remove-image-btn">×</button>
            </div>
        </div>
        
        <!-- 描述 -->
        <div class="description-field">
            <label class="field-label">{{ tb('bugDescriptionLabel') }}</label>
            <textarea 
                v-model="mobileBugData.description"
                :placeholder="tb('bugDescriptionPlaceholderMobile')"
                class="description-textarea"
                rows="5"
            ></textarea>
        </div>
    </div>
    
    <template #footer>
        <div class="dialog-footer">
            <el-button @click="handleCancel">{{ tb('bugCancelButton') }}</el-button>
            <el-button type="primary" @click="isMobile ? submitMobileBug() : submitPCBug()">{{ tb('bugSubmitButton') }}</el-button>
        </div>
    </template>
</el-dialog>

<!-- 反馈弹窗 -->
<el-dialog
    v-model="showFeedbackDialogVisible"
    :title="tb('feedbackDialogTitle')"
   
    :width="isMobile ? '300px' : '500px'" 
>
<!-- class="feedback-dialog" -->
    <div class="feedback-dialog-content">
        <div class="feedback-options">
            <button 
                v-for="(option, idx) in feedbackOptions" 
                :key="idx" 
                class="feedback-option-btn"
                @click="selectFeedbackOption(option)"
                :class="{ active: currentFeedbackOption === option }"
            >
                {{ option }}
            </button>
        </div>
        <div class="feedback-custom-input">
            <textarea 
                v-model="feedbackCustomText" 
                :placeholder="tb('feedbackCustomPlaceholder')"
                rows="3"
                class="feedback-textarea"
            ></textarea>
        </div>
    </div>
    <template #footer>
        <div class="dialog-footer">
            <el-button @click="cancelFeedbackDialog">{{ tb('cancelButton') }}</el-button>
            <el-button type="primary" @click="submitFeedback">{{ tb('submitButton') }}</el-button>
        </div>
    </template>
</el-dialog>
    </div>
</template>

<script>
import { ref, onMounted, nextTick, onUnmounted, computed, onBeforeUnmount } from 'vue'
import request from '@/utils/request'
import axios from 'axios'
import { ElMessage, ElImageViewer, ElMessageBox, ElDialog, ElDatePicker, ElTimePicker, ElButton } from 'element-plus'
import { Pause, VideoPlay, Document, Headphones ,Minus,Stop} from '@element-plus/icons-vue'
import MarkdownIt from 'markdown-it'
import 'github-markdown-css'
import xiaoIcon from '@/assets/xiao.png'
import kuIcon from '@/assets/ku.png'
import kaiIcon from '@/assets/kai.png'
import guanIcon from '@/assets/guan.png'


// 配置Markdown解析器
const md = new MarkdownIt({
  breaks: true,        // 支持换行
  linkify: true,       // 自动识别链接
  typographer: true,   // 启用语言中性的替换
  html: true          // 禁用HTML标签（安全）
})

export default {
    name: 'ChatView',
    props: {
        initialState: {
            type: String,
            default: 'intro'
        },
        historyMessages: {
            type: Array,
            default: () => []
        }
    },
    setup(props) {
        // 设备检测函数（需要在其他变量定义之前）
        const detectDevice = () => {
            const userAgent = navigator.userAgent.toLowerCase();
            const isMobileDevice = /android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
            const isTablet = /ipad|android(?!.*mobile)/i.test(userAgent);
           
            return {
                isMobile: isMobileDevice && !isTablet,
                isTablet: isTablet,
                isDesktop: !isMobileDevice && !isTablet,
                userAgent: userAgent
            };
        };
        
        const pcBugData = ref({
    date: new Date(),
    time: new Date(),
    content: ''
});

// 移动端Bug提交数据
const mobileBugData = ref({
    date: '',
    time: '',
    description: '',
    screenshot: null,
    screenshotPreview: null,
    screenshotUrl: null
});
const realTimeRecognizedText = ref('')  // 实时识别文本
const ws = ref(null)  // WebSocket连接 
// 1. 添加响应式变量
const isRequestCancellable = ref(false)
const currentAbortController = ref(null)
        const richEditor = ref(null);
        const showPCDialog = ref(false);
        const showRefreshButton = ref(false);  // 控制页面中间刷新按钮显示
        const introConfig = ref(null)
        const currentLanguage = ref('zh')
        // 使用公司LOGO作为页面 Favicon
        const setFavicon = (url) => {
            if (!url) return
            let link = document.querySelector('link[rel="icon"]')
            if (!link) {
                link = document.createElement('link')
                link.rel = 'icon'
                document.head.appendChild(link)
            }
            link.href = url
        }
        const messages = ref([])
        const inputMessage = ref('')
        const isTyping = ref(false)
        const chatContainer = ref(null)
        const isKeyboardOpen = ref(false)
        const isRecording = ref(false)
        const recordingTime = ref(0)
        const previewImages = ref([])
        const mediaRecorder = ref(null)
        const audioChunks = ref([])
        let recordingTimer = null
        let recordTimeout = null
        let recordingStartTime = 0
        const fileInputRef = ref(null)
        const inputRef = ref(null)
        const showRecordModal = ref(false)
        const showImageViewer = ref(false)
        const imageList = ref([])
        const imageIndex = ref(0)
        const audioRefs = ref([])
        const playingIndex = ref(null)
        let isCancelByUser = false
        const currentLang = ref('zh')
        const showLangDropdown = ref(false)
        const isUploadingImage = ref(false)
        const chatState = ref(props.initialState) // 使用传入的初始状态
        
        // 设备检测响应式变量
        const isMobile = ref(detectDevice().isMobile)

        console.log('=== Chat.vue 状态调试 ===')
        console.log('Chat.vue props.initialState:', props.initialState)
        console.log('Chat.vue props.historyMessages:', props.historyMessages)
        console.log('Chat.vue chatState.value:', chatState.value)
        console.log('========================')
        const useTTS = ref(false) // TTS标记：false代表文字，true代表TTS
        const isAiResponding = ref(false) // AI回答状态控制

        // 反馈弹窗相关变量
        const showFeedbackDialogVisible = ref(false)
        const currentFeedbackMessageIndex = ref(-1)
        const currentFeedbackMessage = ref(null)
        const currentFeedbackOption = ref('')
        const feedbackCustomText = ref('')
        const feedbackOptions = computed(() => [
            t('feedbackOption1'),
            t('feedbackOption2'),
            t('feedbackOption3'),
            t('feedbackOption4'),
            t('feedbackOption5'),
            t('feedbackOption6')
        ])

        // 显示反馈弹窗
        const showFeedbackDialog = (index, message) => {
            currentFeedbackMessageIndex.value = index
            currentFeedbackMessage.value = message
            
            // 恢复之前提交的反馈信息
            // 如果有fk（1-6），恢复对应的选项文本
            if (message.fk && message.fk > 0 && message.fk <= 6) {
                // fk是1-6的编号，对应feedbackOptions数组的索引（0-5）
                const optionIndex = message.fk - 1
                if (optionIndex >= 0 && optionIndex < feedbackOptions.value.length) {
                    currentFeedbackOption.value = feedbackOptions.value[optionIndex]
                } else {
                    currentFeedbackOption.value = ''
                }
            } else {
                currentFeedbackOption.value = ''
            }
            
            // 恢复之前提交的自定义文本
            feedbackCustomText.value = message.suggest || ''
            
            showFeedbackDialogVisible.value = true
        }

        // 选择反馈选项
        const selectFeedbackOption = (option) => {
            currentFeedbackOption.value = option
        }

        // 取消反馈弹窗
        const cancelFeedbackDialog = () => {
            showFeedbackDialogVisible.value = false
            currentFeedbackOption.value = ''
            feedbackCustomText.value = ''
        }

        // 提交反馈
        const submitFeedback = async () => {
            if (!currentFeedbackOption.value && !feedbackCustomText.value.trim()) {
                ElMessage.warning(t('feedbackRequired'))
                return
            }

            // 获取选项编号（1-6） -> 作为 fk 字段上报
            const optionIndex = feedbackOptions.value.findIndex(option => option === currentFeedbackOption.value) + 1

            // 更新消息的反馈状态（只更新建议内容和fk，不改变哭脸状态）
            if (currentFeedbackMessage.value) {
                // 保持原有的feedback状态不变，只更新suggest和fk
                currentFeedbackMessage.value.suggest = feedbackCustomText.value.trim()
                currentFeedbackMessage.value.fk = optionIndex || 0  // 保存选项编号（1-6）
            }

            // 发送反馈到后端被后端更新
            try {
                const response = await request.post('/feedback/suggest', {
                    userMessageId: currentFeedbackMessage.value?.userMessageId,      // 用户消息ID
                    feedback: currentFeedbackMessage.value?.feedbackValue || 0,      // 点赞/点踩（1/2），0=无
                    fk: optionIndex || 0,                                            // 1-6 选项编号（回答不准确/信息不完整/.../其他）
                    suggest: feedbackCustomText.value.trim(),                         // 自定义建议文本
                    language: getLanguageCode()                                       // 语言代码 0-9
                })
                console.log(response);
                
                // 检查会话失效
                if (response && response.type === 'system' && response.action === 'refresh-required') {
                    console.log('反馈请求：会话失效，需要刷新:', response.message);
                    
                    // 创建系统消息对象，显示刷新按钮
                    const systemMsg = {
                        type: 'system',
                        action: 'refresh-required',
                        text: response.message || (currentLang.value === 'zh' ? '会话检测失败请刷新' : 'Session validation failed, please refresh'),
                        isUser: false
                    };
                    
                    // 添加到消息列表
                    messages.value.push(systemMsg);
                    
                    // 滚动到底部
                    await nextTick();
                    forceScrollToBottom();
                    return;
                }
                
                // 后端返回成功后才显示提示
                if (response && response.success) {
                    // 只有非空消息才显示提示，取消反馈时不显示
                    if (response.message && response.message.trim()) {
                        ElMessage.success(response.message);  // 显示后端返回的语言提示
                    }
                } else {
                    ElMessage.error(response?.message || '反馈提交失败');  // 显示后端返回的错误消息
                }
            } catch (e) {
                console.log('发送反馈请求:', {
                    userMessageId: currentFeedbackMessage.value?.userMessageId,
                    feedback: currentFeedbackMessage.value?.feedbackValue || 0,
                    fk: optionIndex || 0,
                    suggest: feedbackCustomText.value.trim(),
                    language: getLanguageCode()
                });
                console.error('反馈提交失败:', e)
                ElMessage.error('网络错误，请稍后重试');  // 网络错误使用前端固定提示
            }

            // 关闭弹窗
            showFeedbackDialogVisible.value = false
        }

        // 新增：动态加载历史消息相关变量
        const hasMoreHistory = ref(false)
        const nextQueryTimestamp = ref(null)
        const isLoadingMore = ref(false)
        const enableDynamicLoading = ref(false)

        console.log('Chat.vue 初始化状态:', props.initialState)
        console.log('Chat.vue 历史消息:', props.historyMessages)
        // 新增：语言配置常量
        const LANGUAGE_CONFIG = {
            zh: { name: '中文', nativeName: '中文', code: 'zh' },
            en: { name: 'English', nativeName: 'English', code: 'en' },
            de: { name: 'Deutsch', nativeName: 'Deutsch', code: 'de' },
            fr: { name: 'Français', nativeName: 'Français', code: 'fr' },
            ja: { name: '日本語', nativeName: '日本語', code: 'ja' },
            it: { name: 'Italiano', nativeName: 'Italiano', code: 'it' },
            pt: { name: 'Português', nativeName: 'Português', code: 'pt' },
            ko: { name: '한국어', nativeName: '한국어', code: 'ko' },
            es: { name: 'Español', nativeName: 'Español', code: 'es' },
            ru: { name: 'Русский', nativeName: 'Русский', code: 'ru' }
        };
        // 多语言文本
        const translations = {
            zh: {
                welcomeMessage: '你好！我是捷昌驱动智能客服，欢迎来到捷昌。我可以为您提供产品咨询、技术支持、售后服务和最新产品资讯等帮助，有任何问题都可以随时告诉我！',
                inputPlaceholder: '输入消息...',
                clickToTalk: '点击对话',
                speaking: '说话中…',
                aiReplyFailed: '网络连接失败,请稍后再试。',
                recordingTooShort: '说话时间太短',
                recordingFailed: '录音失败，请重试',
                uploadFailed: '上传失败',
                uploadRequestFailed: '上传请求失败',
                imageUploadLimit: '只能上传一张图片',
                imageUploading: '图片上传中',
                imageFileTypeError: '只能上传图片文件',
                imageFileSizeError: '图片大小不能超过20M',
                microphonePermissionDenied: '麦克风权限被拒绝,请在浏览器设置中开启麦克风权限',
                microphoneAuthRequired: '需要获取麦克风权限才能录音,是否现在授权？',
                microphoneAuthFailed: '麦克风授权失败,请检查浏览器设置',
                audioPlayFailed: '音频播放失败',
                recordingCanceled: '已取消录音',
                languageFeatureTitle: '语言选择',
                ttsFeatureTitle: '语音回答',
                ttsFeatureInDevelopment: '语音功能暂未开放,敬请期待！',
                ttsEnableConfirm: '开启语音回答,导致无法预览图片、视频.是否开启语音回答？',
                ttsDisableConfirm: '是否关闭语音回答？',
                ttsEnabled: '语音功能已开启',
                ttsDisabled: '语音功能已关闭',
                ticketFeatureTitle: 'Bug提交',
                ticketFeatureInDevelopment: '工单提交功能暂未开放，敬请期待！',
                bugDialogTitle: 'Bug提交',
                bugDateLabel: '时间：',
                bugDatePlaceholder: '选择日期',
                bugTimePlaceholder: '选择时间',
                bugScreenshotLabel: '截图：',
                bugDescriptionLabel: '描述：',
                bugDescriptionPlaceholder: '请描述Bug详情，支持粘贴图片...',
                bugDescriptionPlaceholderMobile: '详尽的描述可以帮助工程师更快解决问题',
                bugSubmitButton: '提交',
                bugCancelButton: '取消',
                bugSubmitSuccess: 'Bug提交成功',
                bugSubmitFailed: 'Bug提交失败',
                bugUploadSuccess: '图片上传成功',
                bugUploadFailed: '图片上传失败',
                introTitle: '我是捷昌驱动智能客服,很高兴见到你！',
                introDescription: '捷昌驱动,科技驱动智慧生活。我可以为您提供产品咨询、技术支持、售后服务等帮助，请把您的问题告诉我吧～',
                introPlaceholder: '给捷昌客服发送消息',
                expandText: '展开文字',
                collapseText: '收起文字',
                feedbackDialogTitle: '反馈意见',
                feedbackCustomPlaceholder: '请输入您的反馈意见...',
                feedbackRequired: '请选择反馈选项或输入反馈意见',
                feedbackSubmitted: '感谢你的建议',
                cancelButton: '取消',
                submitButton: '提交',
                refreshPage: '刷新',
                refreshWarning: '此次刷新将清除历史记录',
                ttsRequestFailed: '语音生成失败，请稍后再试',
                feedbackOption1: '回答不准确',
                feedbackOption2: '信息不完整',
                feedbackOption3: '内容过时',
                feedbackOption4: '表达不清晰',
                feedbackOption5: '未找到相关答案',
                feedbackOption6: '其他',
                feedbackLikeSubmitted: '感谢您的满意！我们会继续努力提供更好的服务。',
                feedbackDislikeSubmitted: '感谢您的反馈！我们会认真改进服务。',
                feedbackLikeMessage: '谢谢你的评价',
                feedbackDislikeMessage: '我们会改进服务',
                dislikePopupTitle: '我们想了解您不满意的原因',
                dislikeOption1: '回答不准确',
                dislikeOption2: '没有帮助',
                dislikeOption3: '联系我们',
                dislikeOption4: '其他',
                dislikeReasonPlaceholder: '我们想了解您不满意的原因',
                dislikeValidationMessage: '请选择原因或填写具体意见',
            },
            en: {
                welcomeMessage: 'Hello! I am Jiecang Drive intelligent customer service assistant, welcome to Jiecang. I can provide you with product consultation, technical support, after-sales service and latest product information. Feel free to ask me any questions!',
                inputPlaceholder: 'Enter message...',
                clickToTalk: 'Click to talk',
                speaking: 'Speaking…',
                aiReplyFailed: 'reply failed, please try again later.',
                recordingTooShort: 'Speaking time too short',
                recordingFailed: 'Recording failed, please try again',
                uploadFailed: 'Upload failed',
                uploadRequestFailed: 'Upload request failed',
                imageUploadLimit: 'Only one image can be uploaded',
                imageUploading: 'Uploading image',
                imageFileTypeError: 'Only image files can be uploaded',
                imageFileSizeError: 'Image size cannot exceed 20M',
                microphonePermissionDenied: 'Microphone permission denied, please enable microphone permission in browser settings',
                microphoneAuthRequired: 'Microphone permission is required for recording, authorize now?',
                microphoneAuthFailed: 'Microphone authorization failed, please check browser settings',
                audioPlayFailed: 'Audio playback failed',
                recordingCanceled: 'Recording canceled',
                languageFeatureTitle: 'Language Selection',
                ttsFeatureTitle: 'Voice Reply',
                ttsFeatureInDevelopment: 'Voice Reply is not yet available, coming soon!',
                ttsEnableConfirm: 'Enabling voice reply will prevent previewing images and videos. Enable voice reply?',
                ttsDisableConfirm: 'Disable voice reply?',
                ttsEnabled: 'Voice reply enabled',
                ttsDisabled: 'Voice reply disabled',
                ticketFeatureTitle: 'Bug Submission',
                ticketFeatureInDevelopment: 'Ticket submission feature is not yet available, coming soon!',
                bugDialogTitle: 'Bug Submission',
                bugDateLabel: 'Time:',
                bugDatePlaceholder: 'Select Date',
                bugTimePlaceholder: 'Select Time',
                bugScreenshotLabel: 'Screenshot:',
                bugDescriptionLabel: 'Description:',
                bugDescriptionPlaceholder: 'Please describe the Bug details, supports pasting images...',
                bugDescriptionPlaceholderMobile: 'Detailed description helps engineers solve problems faster',
                bugSubmitButton: 'Submit',
                bugCancelButton: 'Cancel',
                bugSubmitSuccess: 'Bug submitted successfully',
                bugSubmitFailed: 'Bug submission failed',
                bugUploadSuccess: 'Image uploaded successfully',
                bugUploadFailed: 'Image upload failed',
                introTitle: 'I am Jiecang Drive intelligent customer service, nice to meet you!',
                introDescription: 'Jiecang Drive, technology drives smart life. I can provide you with product consultation, technical support, after-sales service and other assistance. Please tell me your questions～',
                introPlaceholder: 'Send message to Jiecang customer service assistant',
                expandText: 'Expand Text',
                collapseText: 'Collapse Text',
                feedbackDialogTitle: 'Feedback',
                feedbackCustomPlaceholder: 'Please enter your feedback...',
                feedbackRequired: 'Please select feedback option or enter feedback',
                feedbackSubmitted: 'Thank you for your suggestion',
                cancelButton: 'Cancel',
                submitButton: 'Submit',
                refreshPage: 'Refresh Page',
                refreshWarning: 'This refresh will clear the history',
                ttsRequestFailed: 'Failed to generate voice, please try again',
                feedbackOption1: 'Inaccurate Answer',
                feedbackOption2: 'Incomplete Information',
                feedbackOption3: 'Outdated Content',
                feedbackOption4: 'Unclear Expression',
                feedbackOption5: 'No Relevant Answer Found',
                feedbackOption6: 'Other',
                feedbackLikeSubmitted: 'Thank you for your satisfaction! We will continue to provide better service.',
                feedbackDislikeSubmitted: 'Thank you for your feedback! We will work hard to improve our service.',
                feedbackLikeMessage: 'Thank you for your feedback',
                feedbackDislikeMessage: 'We will improve our service',
                dislikePopupTitle: 'We would like to understand the reason for your dissatisfaction',
                dislikeOption1: 'Inaccurate answer',
                dislikeOption2: 'Not helpful',
                dislikeOption3: 'Contact Us',
                dislikeOption4: 'Other',
                dislikeReasonPlaceholder: 'We would like to understand the reason for your dissatisfaction',
                dislikeValidationMessage: 'Please select a reason or enter your comments',
            },
            de: {
                welcomeMessage: 'Hallo! Ich bin der intelligente Kundenservice-Assistent von Jiecang Drive, willkommen bei Jiecang. Ich kann Ihnen bei Produktberatung, technischem Support, Kundendienst und neuesten Produktinformationen helfen. Stellen Sie mir gerne alle Fragen!',
                inputPlaceholder: 'Nachricht eingeben...',
                clickToTalk: 'Zum Sprechen klicken',
                speaking: 'Sprechen…',
                aiReplyFailed: 'Netzwerkverbindung fehlgeschlagen, bitte versuchen Sie es später erneut.',
                recordingTooShort: 'Sprechzeit zu kurz',
                recordingFailed: 'Aufnahme fehlgeschlagen, bitte versuchen Sie es erneut',
                uploadFailed: 'Upload fehlgeschlagen',
                uploadRequestFailed: 'Upload-Anfrage fehlgeschlagen',
                imageUploadLimit: 'Nur ein Bild kann hochgeladen werden',
                imageUploading: 'Bild wird hochgeladen',
                imageFileTypeError: 'Es können nur Bilddateien hochgeladen werden',
                imageFileSizeError: 'Die Bildgröße darf 20M nicht überschreiten',
                microphonePermissionDenied: 'Mikrofon-Berechtigung verweigert, bitte aktivieren Sie die Mikrofon-Berechtigung in den Browser-Einstellungen',
                microphoneAuthRequired: 'Mikrofon-Berechtigung ist für die Aufnahme erforderlich, jetzt autorisieren?',
                microphoneAuthFailed: 'Mikrofon-Autorisierung fehlgeschlagen, bitte überprüfen Sie die Browser-Einstellungen',
                audioPlayFailed: 'Audio-Wiedergabe fehlgeschlagen',
                recordingCanceled: 'Aufnahme abgebrochen',
                languageFeatureTitle: 'Sprachauswahl',
                ttsFeatureTitle: 'Sprachantwort',
                ttsFeatureInDevelopment: 'Sprachfunktion ist noch nicht verfügbar, demnächst verfügbar!',
                ttsEnableConfirm: 'Aktivierung der Sprachantwort verhindert die Vorschau von Bildern und Videos. Sprachantwort aktivieren?',
                ttsDisableConfirm: 'Sprachantwort deaktivieren?',
                ttsEnabled: 'Sprachfunktion aktiviert',
                ttsDisabled: 'Sprachfunktion deaktiviert',
                ticketFeatureTitle: 'Bug-Einreichung',
                ticketFeatureInDevelopment: 'Ticket-Einreichungsfunktion ist noch nicht verfügbar, demnächst verfügbar!',
                bugDialogTitle: 'Bug-Einreichung',
                bugDateLabel: 'Zeit:',
                bugDatePlaceholder: 'Datum auswählen',
                bugTimePlaceholder: 'Zeit auswählen',
                bugScreenshotLabel: 'Screenshot:',
                bugDescriptionLabel: 'Beschreibung:',
                bugDescriptionPlaceholder: 'Bitte beschreiben Sie die Bug-Details, unterstützt das Einfügen von Bildern...',
                bugDescriptionPlaceholderMobile: 'Detaillierte Beschreibung hilft Ingenieuren, Probleme schneller zu lösen',
                bugSubmitButton: 'Einreichen',
                bugCancelButton: 'Abbrechen',
                bugSubmitSuccess: 'Bug erfolgreich eingereicht',
                bugSubmitFailed: 'Bug-Einreichung fehlgeschlagen',
                bugUploadSuccess: 'Bild erfolgreich hochgeladen',
                bugUploadFailed: 'Bild-Upload fehlgeschlagen',
                introTitle: 'Ich bin der intelligente Kundenservice von Jiecang Drive, schön Sie kennenzulernen!',
                introDescription: 'Jiecang Drive, Technologie treibt das intelligente Leben an. Ich kann Ihnen bei Produktberatung, technischem Support, Kundendienst und anderen Hilfestellungen behilflich sein. Teilen Sie mir Ihre Fragen mit～',
                introPlaceholder: 'Nachricht an Jiecang Kundenservice-Assistenten senden',
                expandText: 'Text erweitern',
                collapseText: 'Text einklappen',
                feedbackDialogTitle: 'Feedback',
                feedbackCustomPlaceholder: 'Bitte geben Sie Ihr Feedback ein...',
                feedbackRequired: 'Bitte wählen Sie eine Feedback-Option oder geben Sie Feedback ein',
                feedbackSubmitted: 'Vielen Dank für Ihren Vorschlag',
                cancelButton: 'Abbrechen',
                submitButton: 'Einreichen',
                refreshPage: 'Seite aktualisieren',
                refreshWarning: 'Diese Aktualisierung löscht den Verlauf',
                ttsRequestFailed: 'Stimmgenerierung fehlgeschlagen, bitte versuchen Sie es später erneut',
                feedbackOption1: 'Ungenaue Antwort',
                feedbackOption2: 'Unvollständige Informationen',
                feedbackOption3: 'Veralteter Inhalt',
                feedbackOption4: 'Unklare Ausdrucksweise',
                feedbackOption5: 'Keine relevante Antwort gefunden',
                feedbackOption6: 'Andere',
                feedbackLikeSubmitted: 'Vielen Dank für Ihre Zufriedenheit! Wir werden weiterhin besseren Service bieten.',
                feedbackDislikeSubmitted: 'Vielen Dank für Ihr Feedback! Wir werden hart arbeiten, um unseren Service zu verbessern.',
                feedbackLikeMessage: 'Vielen Dank für Ihre Bewertung',
                feedbackDislikeMessage: 'Wir werden unseren Service verbessern',
                dislikePopupTitle: 'Wir möchten den Grund für Ihre Unzufriedenheit verstehen',
                dislikeOption1: 'Antwort ist ungenau',
                dislikeOption2: 'Nicht hilfreich',
                dislikeOption3: 'Kontaktieren Sie uns',
                dislikeOption4: 'Andere',
                dislikeReasonPlaceholder: 'Wir möchten den Grund für Ihre Unzufriedenheit verstehen',
                dislikeValidationMessage: 'Bitte wählen Sie einen Grund oder geben Sie Ihre Anmerkungen ein',
            },
            fr: {
                welcomeMessage: 'Bonjour ! Je suis l\'assistant client intelligent de Jiecang Drive, bienvenue chez Jiecang. Je peux vous fournir des conseils produits, un support technique, un service après-vente et les dernières informations produits. N\'hésitez pas à me poser toutes vos questions !',
                inputPlaceholder: 'Saisir un message...',
                clickToTalk: 'Cliquer pour parler',
                speaking: 'En train de parler…',
                aiReplyFailed: 'Échec de la connexion réseau, veuillez réessayer plus tard.',
                recordingTooShort: 'Temps de parole trop court',
                recordingFailed: 'Échec de l\'enregistrement, veuillez réessayer',
                uploadFailed: 'Échec du téléchargement',
                uploadRequestFailed: 'Échec de la requête de téléchargement',
                imageUploadLimit: 'Une seule image peut être téléchargée',
                imageUploading: 'Téléchargement de l\'image',
                imageFileTypeError: 'Seuls les fichiers image peuvent être téléchargés',
                imageFileSizeError: 'La taille de l\'image ne peut pas dépasser 20M',
                microphonePermissionDenied: 'Permission microphone refusée, veuillez activer la permission microphone dans les paramètres du navigateur',
                microphoneAuthRequired: 'La permission microphone est requise pour l\'enregistrement, autoriser maintenant ?',
                microphoneAuthFailed: 'Échec de l\'autorisation microphone, veuillez vérifier les paramètres du navigateur',
                audioPlayFailed: 'Échec de la lecture audio',
                recordingCanceled: 'Enregistrement annulé',
                languageFeatureTitle: 'Sélection de la langue',
                ttsFeatureTitle: 'Réponse vocale',
                ttsFeatureInDevelopment: 'La fonction vocale n\'est pas encore disponible, bientôt disponible !',
                ttsEnableConfirm: 'Activer la réponse vocale empêchera la prévisualisation des images et vidéos. Activer la réponse vocale ?',
                ttsDisableConfirm: 'Désactiver la réponse vocale ?',
                ttsEnabled: 'Fonction vocale activée',
                ttsDisabled: 'Fonction vocale désactivée',
                ticketFeatureTitle: 'Soumission de Bug',
                ticketFeatureInDevelopment: 'La fonction de soumission de tickets n\'est pas encore disponible, bientôt disponible !',
                bugDialogTitle: 'Soumission de Bug',
                bugDateLabel: 'Heure:',
                bugDatePlaceholder: 'Sélectionner une date',
                bugTimePlaceholder: 'Sélectionner une heure',
                bugScreenshotLabel: 'Capture d\'écran:',
                bugDescriptionLabel: 'Description:',
                bugDescriptionPlaceholder: 'Veuillez décrire les détails du Bug, prend en charge le collage d\'images...',
                bugDescriptionPlaceholderMobile: 'Une description détaillée aide les ingénieurs à résoudre les problèmes plus rapidement',
                bugSubmitButton: 'Soumettre',
                bugCancelButton: 'Annuler',
                bugSubmitSuccess: 'Bug soumis avec succès',
                bugSubmitFailed: 'Échec de la soumission du Bug',
                bugUploadSuccess: 'Image téléchargée avec succès',
                bugUploadFailed: 'Échec du téléchargement de l\'image',
                introTitle: 'Je suis le service client intelligent de Jiecang Drive, ravi de vous rencontrer !',
                introDescription: 'Jiecang Drive, la technologie propulse la vie intelligente. Je peux vous fournir des conseils produits, un support technique, un service après-vente et d\'autres aides. Veuillez me dire vos questions～',
                introPlaceholder: 'Envoyer un message à l\'assistant client Jiecang',
                expandText: 'Développer le texte',
                collapseText: 'Réduire le texte',
                feedbackDialogTitle: 'Commentaires',
                feedbackCustomPlaceholder: 'Veuillez saisir vos commentaires...',
                feedbackRequired: 'Veuillez sélectionner une option de commentaire ou saisir des commentaires',
                feedbackSubmitted: 'Merci pour votre suggestion',
                cancelButton: 'Annuler',
                submitButton: 'Soumettre',
                refreshPage: 'Actualiser la page',
                refreshWarning: 'Cette actualisation effacera l’historique',
                ttsRequestFailed: 'Échec de la génération vocale, veuillez réessayer plus tard',
                feedbackOption1: 'Réponse inexacte',
                feedbackOption2: 'Informations incomplètes',
                feedbackOption3: 'Contenu obsolète',
                feedbackOption4: 'Expression peu claire',
                feedbackOption5: 'Aucune réponse pertinente trouvée',
                feedbackOption6: 'Autre',
                feedbackLikeSubmitted: 'Merci pour votre satisfaction ! Nous continuerons à fournir un meilleur service.',
                feedbackDislikeSubmitted: 'Merci pour vos commentaires ! Nous travaillerons dur pour améliorer notre service.',
                feedbackLikeMessage: 'Merci pour votre évaluation',
                feedbackDislikeMessage: 'Nous améliorerons notre service',
                dislikePopupTitle: 'Nous aimerions comprendre la raison de votre insatisfaction',
                dislikeOption1: 'Réponse inexacte',
                dislikeOption2: 'Peu utile',
                dislikeOption3: 'Contactez-nous',
                dislikeOption4: 'Autre',
                dislikeReasonPlaceholder: 'Nous aimerions comprendre la raison de votre insatisfaction',
                dislikeValidationMessage: 'Veuillez sélectionner un motif ou saisir vos commentaires',
            },
            ja: {
                welcomeMessage: 'こんにちは！私は捷昌ドライブのインテリジェントカスタマーサービスアシスタントです。捷昌へようこそ。製品相談、技術サポート、アフターサービス、最新製品情報など、お手伝いできます。お気軽にご質問ください！',
                inputPlaceholder: 'メッセージを入力...',
                clickToTalk: 'クリックして話す',
                speaking: '話し中…',
                aiReplyFailed: 'ネットワーク接続に失敗しました。後でもう一度お試しください。',
                recordingTooShort: '話す時間が短すぎます',
                recordingFailed: '録音に失敗しました。再試行してください',
                uploadFailed: 'アップロードに失敗しました',
                uploadRequestFailed: 'アップロードリクエストに失敗しました',
                imageUploadLimit: '画像は1枚のみアップロード可能です',
                imageUploading: '画像をアップロード中',
                imageFileTypeError: '画像ファイルのみアップロードできます',
                imageFileSizeError: '画像サイズは20Mを超えることはできません',
                microphonePermissionDenied: 'マイクの権限が拒否されました。ブラウザ設定でマイクの権限を有効にしてください',
                microphoneAuthRequired: '録音にはマイクの権限が必要です。今すぐ認証しますか？',
                microphoneAuthFailed: 'マイクの認証に失敗しました。ブラウザ設定を確認してください',
                audioPlayFailed: 'オーディオ再生に失敗しました',
                recordingCanceled: '録音をキャンセルしました',
                languageFeatureTitle: '言語選択',
                ttsFeatureTitle: '音声回答',
                ttsFeatureInDevelopment: '音声機能はまだ利用できません。近日公開予定！',
                ttsEnableConfirm: '音声回答を有効にすると、画像や動画のプレビューができなくなります。音声回答を有効にしますか？',
                ttsDisableConfirm: '音声回答を無効にしますか？',
                ttsEnabled: '音声機能が有効になりました',
                ttsDisabled: '音声機能が無効になりました',
                ticketFeatureTitle: 'Bug',
                ticketFeatureInDevelopment: 'チケット提出機能はまだ利用できません。近日公開予定！',
                bugDialogTitle: 'Bug',
                bugDateLabel: '時間：',
                bugDatePlaceholder: '日付を選択',
                bugTimePlaceholder: '時刻を選択',
                bugScreenshotLabel: 'スクリーンショット：',
                bugDescriptionLabel: '説明：',
                bugDescriptionPlaceholder: 'Bugの詳細を説明してください。画像の貼り付けに対応しています...',
                bugDescriptionPlaceholderMobile: '詳細な説明は、エンジニアが問題をより迅速に解決するのに役立ちます',
                bugSubmitButton: '送信',
                bugCancelButton: 'キャンセル',
                bugSubmitSuccess: 'Bugの送信に成功しました',
                bugSubmitFailed: 'Bugの送信に失敗しました',
                bugUploadSuccess: '画像のアップロードに成功しました',
                bugUploadFailed: '画像のアップロードに失敗しました',
                introTitle: '私は捷昌ドライブのインテリジェントカスタマーサービスです。お会いできて嬉しいです！',
                introDescription: '捷昌ドライブ、テクノロジーがスマートライフを推進します。製品相談、技術サポート、アフターサービスなどのお手伝いができます。ご質問をお聞かせください～',
                introPlaceholder: '捷昌カスタマーサービスアシスタントにメッセージを送信',
                expandText: 'テキストを展開',
                collapseText: 'テキストを折りたたむ',
                feedbackDialogTitle: 'フィードバック',
                feedbackCustomPlaceholder: 'フィードバックを入力してください...',
                feedbackRequired: 'フィードバックオプションを選択するか、フィードバックを入力してください',
                feedbackSubmitted: 'ご提案ありがとうございます',
                cancelButton: 'キャンセル',
                submitButton: '送信',
                refreshPage: 'ページを更新',
                refreshWarning: 'この更新で履歴が消去されます',
                ttsRequestFailed: '音声生成に失敗しました。後でもう一度お試しください',
                feedbackOption1: '回答が不正確',
                feedbackOption2: '情報が不完全',
                feedbackOption3: '内容が古い',
                feedbackOption4: '表現が不明確',
                feedbackOption5: '関連する回答が見つからない',
                feedbackOption6: 'その他',
                feedbackLikeSubmitted: 'ご満足いただきありがとうございます！引き続き、より良いサービスを提供いたします。',
                feedbackDislikeSubmitted: 'フィードバックありがとうございます！サービス改善に努めます。',
                feedbackLikeMessage: 'ご評価ありがとうございます',
                feedbackDislikeMessage: 'サービスを改善いたします',
                dislikePopupTitle: 'ご不満の理由をお聞かせください',
                dislikeOption1: '回答が正確ではない',
                dislikeOption2: '役に立たなかった',
                dislikeOption3: 'お問い合わせ',
                dislikeOption4: 'その他',
                dislikeReasonPlaceholder: 'ご不満の理由をお聞かせください',
                dislikeValidationMessage: '理由を選択するかご意見を入力してください',
            },
            it: {
                welcomeMessage: 'Ciao! Sono l\'assistente clienti intelligente di Jiecang Drive, benvenuto a Jiecang. Posso fornirti consulenza sui prodotti, supporto tecnico, servizio post-vendita e le ultime informazioni sui prodotti. Sentiti libero di farmi qualsiasi domanda!',
                inputPlaceholder: 'Inserisci messaggio...',
                clickToTalk: 'Clicca per parlare',
                speaking: 'Parlando…',
                aiReplyFailed: 'Connessione di rete fallita, riprova più tardi.',
                recordingTooShort: 'Tempo di parola troppo breve',
                recordingFailed: 'Registrazione fallita, riprova',
                uploadFailed: 'Caricamento fallito',
                uploadRequestFailed: 'Richiesta di caricamento fallita',
                imageUploadLimit: 'Può essere caricata solo un\'immagine',
                imageUploading: 'Caricamento immagine',
                imageFileTypeError: 'È possibile caricare solo file immagine',
                imageFileSizeError: 'La dimensione dell\'immagine non può superare 20M',
                microphonePermissionDenied: 'Permesso microfono negato, abilita il permesso microfono nelle impostazioni del browser',
                microphoneAuthRequired: 'Il permesso microfono è richiesto per la registrazione, autorizzare ora?',
                microphoneAuthFailed: 'Autorizzazione microfono fallita, controlla le impostazioni del browser',
                audioPlayFailed: 'Riproduzione audio fallita',
                recordingCanceled: 'Registrazione annullata',
                languageFeatureTitle: 'Selezione lingua',
                ttsFeatureTitle: 'Risposta vocale',
                ttsFeatureInDevelopment: 'La funzione vocale non è ancora disponibile, in arrivo!',
                ttsEnableConfirm: 'Abilitare la risposta vocale impedirà l\'anteprima di immagini e video. Abilitare la risposta vocale?',
                ttsDisableConfirm: 'Disabilitare la risposta vocale?',
                ttsEnabled: 'Funzione vocale abilitata',
                ttsDisabled: 'Funzione vocale disabilitata',
                ticketFeatureTitle: 'Invio Bug',
                ticketFeatureInDevelopment: 'La funzione di invio ticket non è ancora disponibile, in arrivo!',
                bugDialogTitle: 'Invio Bug',
                bugDateLabel: 'Ora:',
                bugDatePlaceholder: 'Seleziona data',
                bugTimePlaceholder: 'Seleziona ora',
                bugScreenshotLabel: 'Screenshot:',
                bugDescriptionLabel: 'Descrizione:',
                bugDescriptionPlaceholder: 'Si prega di descrivere i dettagli del Bug, supporta l\'incollaggio di immagini...',
                bugDescriptionPlaceholderMobile: 'Una descrizione dettagliata aiuta gli ingegneri a risolvere i problemi più rapidamente',
                bugSubmitButton: 'Invia',
                bugCancelButton: 'Annulla',
                bugSubmitSuccess: 'Bug inviato con successo',
                bugSubmitFailed: 'Invio Bug fallito',
                bugUploadSuccess: 'Immagine caricata con successo',
                bugUploadFailed: 'Caricamento immagine fallito',
                introTitle: 'Sono il servizio clienti intelligente di Jiecang Drive, felice di incontrarti!',
                introDescription: 'Jiecang Drive, la tecnologia guida la vita intelligente. Posso fornirti consulenza sui prodotti, supporto tecnico, servizio post-venta e altri aiuti. Per favore dimmi le tue domande～',
                introPlaceholder: 'Invia un messaggio all\'assistente clienti Jiecang',
                expandText: 'Espandi testo',
                collapseText: 'Comprimi testo',
                feedbackDialogTitle: 'Feedback',
                feedbackCustomPlaceholder: 'Inserisci il tuo feedback...',
                feedbackRequired: 'Seleziona un\'opzione di feedback o inserisci feedback',
                feedbackSubmitted: 'Grazie per il tuo suggerimento',
                cancelButton: 'Annulla',
                submitButton: 'Invia',
                refreshPage: 'Aggiorna pagina',
                refreshWarning: 'Questo aggiornamento cancellerà la cronologia',
                ttsRequestFailed: 'Generazione vocale fallita, riprova più tardi',
                feedbackOption1: 'Risposta imprecisa',
                feedbackOption2: 'Informazioni incomplete',
                feedbackOption3: 'Contenuto obsoleto',
                feedbackOption4: 'Espressione poco chiara',
                feedbackOption5: 'Nessuna risposta pertinente trovata',
                feedbackOption6: 'Altro',
                feedbackLikeSubmitted: 'Grazie per la tua soddisfazione! Continueremo a fornire un servizio migliore.',
                feedbackDislikeSubmitted: 'Grazie per il tuo feedback! Lavoreremo duramente per migliorare il nostro servizio.',
                feedbackLikeMessage: 'Grazie per la tua valutazione',
                feedbackDislikeMessage: 'Miglioreremo il nostro servizio',
                dislikePopupTitle: 'Vorremmo capire il motivo della vostra insoddisfazione',
                dislikeOption1: 'Risposta imprecisa',
                dislikeOption2: 'Non è stato utile',
                dislikeOption3: 'Contattaci',
                dislikeOption4: 'Altro',
                dislikeReasonPlaceholder: 'Vorremmo capire il motivo della vostra insoddisfazione',
                dislikeValidationMessage: 'Seleziona un motivo o inserisci i tuoi commenti',
            },
            pt: {
                welcomeMessage: 'Olá! Sou o assistente de atendimento ao cliente inteligente da Jiecang Drive, bem-vindo à Jiecang. Posso fornecer consultoria de produtos, suporte técnico, serviço pós-venda e as últimas informações de produtos. Sinta-se à vontade para me fazer qualquer pergunta!',
                inputPlaceholder: 'Digite mensagem...',
                clickToTalk: 'Clique para falar',
                speaking: 'Falando…',
                aiReplyFailed: 'Falha na conexão de rede, tente novamente mais tarde.',
                recordingTooShort: 'Tempo de fala muito curto',
                recordingFailed: 'Gravação falhou, tente novamente',
                uploadFailed: 'Upload falhou',
                uploadRequestFailed: 'Solicitação de upload falhou',
                imageUploadLimit: 'Apenas uma imagem pode ser carregada',
                imageUploading: 'Carregando imagem',
                imageFileTypeError: 'Apenas arquivos de imagem podem ser carregados',
                imageFileSizeError: 'O tamanho da imagem não pode exceder 20M',
                microphonePermissionDenied: 'Permissão do microfone negada, habilite a permissão do microfone nas configurações do navegador',
                microphoneAuthRequired: 'Permissão do microfone é necessária para gravação, autorizar agora?',
                microphoneAuthFailed: 'Autorização do microfone falhou, verifique as configurações do navegador',
                audioPlayFailed: 'Reprodução de áudio falhou',
                recordingCanceled: 'Gravação cancelada',
                languageFeatureTitle: 'Seleção de idioma',
                ttsFeatureTitle: 'Resposta de voz',
                ttsFeatureInDevelopment: 'Função de voz ainda não está disponível, em breve!',
                ttsEnableConfirm: 'Habilitar resposta de voz impedirá a visualização de imagens e vídeos. Habilitar resposta de voz?',
                ttsDisableConfirm: 'Desabilitar resposta de voz?',
                ttsEnabled: 'Função de voz habilitada',
                ttsDisabled: 'Função de voz desabilitada',
                ticketFeatureTitle: 'Envio de Bug',
                ticketFeatureInDevelopment: 'Função de envio de tickets ainda não está disponível, em breve!',
                bugDialogTitle: 'Envio de Bug',
                bugDateLabel: 'Hora:',
                bugDatePlaceholder: 'Selecionar data',
                bugTimePlaceholder: 'Selecionar hora',
                bugScreenshotLabel: 'Captura de tela:',
                bugDescriptionLabel: 'Descrição:',
                bugDescriptionPlaceholder: 'Por favor, descreva os detalhes do Bug, suporta colar imagens...',
                bugDescriptionPlaceholderMobile: 'Descrição detalhada ajuda os engenheiros a resolver problemas mais rapidamente',
                bugSubmitButton: 'Enviar',
                bugCancelButton: 'Cancelar',
                bugSubmitSuccess: 'Bug enviado com sucesso',
                bugSubmitFailed: 'Falha no envio do Bug',
                bugUploadSuccess: 'Imagem carregada com sucesso',
                bugUploadFailed: 'Falha no carregamento da imagem',
                introTitle: 'Sou o atendimento ao cliente inteligente da Jiecang Drive, prazer em conhecê-lo!',
                introDescription: 'Jiecang Drive, tecnologia impulsiona a vida inteligente. Posso fornecer consultoria de produtos, suporte técnico, serviço pós-venda e outras assistências. Por favor, me conte suas perguntas～',
                introPlaceholder: 'Envie uma mensagem para o assistente de atendimento Jiecang',
                expandText: 'Expandir texto',
                collapseText: 'Recolher texto',
                feedbackDialogTitle: 'Feedback',
                feedbackCustomPlaceholder: 'Digite seu feedback...',
                feedbackRequired: 'Selecione uma opção de feedback ou digite feedback',
                feedbackSubmitted: 'Obrigado pela sua sugestão',
                cancelButton: 'Cancelar',
                submitButton: 'Enviar',
                refreshPage: 'Atualizar página',
                refreshWarning: 'Esta atualização limpará o histórico',
                ttsRequestFailed: 'Falha na geração de voz, tente novamente mais tarde',
                feedbackOption1: 'Resposta imprecisa',
                feedbackOption2: 'Informações incompletas',
                feedbackOption3: 'Conteúdo desatualizado',
                feedbackOption4: 'Expressão pouco clara',
                feedbackOption5: 'Nenhuma resposta relevante encontrada',
                feedbackOption6: 'Outro',
                feedbackLikeSubmitted: 'Obrigado por sua satisfação! Continuaremos fornecendo melhor serviço.',
                feedbackDislikeSubmitted: 'Obrigado pelo seu feedback! Trabalharemos duro para melhorar nosso serviço.',
                feedbackLikeMessage: 'Obrigado pela sua avaliação',
                feedbackDislikeMessage: 'Melhoraremos nosso serviço',
                dislikePopupTitle: 'Gostaríamos de entender o motivo da sua insatisfação',
                dislikeOption1: 'Resposta imprecisa',
                dislikeOption2: 'Não foi útil',
                dislikeOption3: 'Entre em contato',
                dislikeOption4: 'Outro',
                dislikeReasonPlaceholder: 'Gostaríamos de entender o motivo da sua insatisfação',
                dislikeValidationMessage: 'Selecione um motivo ou insira seus comentários',
            },
            ko: {
                welcomeMessage: '안녕하세요! 저는 지창드라이브 지능형 고객 서비스 어시스턴트입니다. 지창에 오신 것을 환영합니다. 제품 상담, 기술 지원, 애프터 서비스 및 최신 제품 정보를 제공할 수 있습니다. 언제든지 질문해 주세요!',
                inputPlaceholder: '메시지 입력...',
                clickToTalk: '클릭하여 말하기',
                speaking: '말하는 중…',
                aiReplyFailed: '네트워크 연결에 실패했습니다. 나중에 다시 시도해 주세요.',
                recordingTooShort: '말하는 시간이 너무 짧습니다',
                recordingFailed: '녹음에 실패했습니다. 다시 시도해 주세요',
                uploadFailed: '업로드에 실패했습니다',
                uploadRequestFailed: '업로드 요청에 실패했습니다',
                imageUploadLimit: '이미지는 하나만 업로드할 수 있습니다',
                imageUploading: '이미지 업로드 중',
                imageFileTypeError: '이미지 파일만 업로드할 수 있습니다',
                imageFileSizeError: '이미지 크기는 20M을 초과할 수 없습니다',
                microphonePermissionDenied: '마이크 권한이 거부되었습니다. 브라우저 설정에서 마이크 권한을 활성화해 주세요',
                microphoneAuthRequired: '녹음을 위해 마이크 권한이 필요합니다. 지금 인증하시겠습니까?',
                microphoneAuthFailed: '마이크 인증에 실패했습니다. 브라우저 설정을 확인해 주세요',
                audioPlayFailed: '오디오 재생에 실패했습니다',
                recordingCanceled: '녹음을 취소했습니다',
                languageFeatureTitle: '언어 선택',
                ttsFeatureTitle: '음성 답변',
                ttsFeatureInDevelopment: '음성 기능은 아직 사용할 수 없습니다. 곧 출시 예정!',
                ttsEnableConfirm: '음성 답변을 활성화하면 이미지와 비디오 미리보기가 불가능해집니다. 음성 답변을 활성화하시겠습니까?',
                ttsDisableConfirm: '음성 답변을 비활성화하시겠습니까?',
                ttsEnabled: '음성 기능이 활성화되었습니다',
                ttsDisabled: '음성 기능이 비활성화되었습니다',
                ticketFeatureTitle: 'Bug 제출',
                ticketFeatureInDevelopment: '티켓 제출 기능은 아직 사용할 수 없습니다. 곧 출시 예정!',
                bugDialogTitle: 'Bug 제출',
                bugDateLabel: '시간：',
                bugDatePlaceholder: '날짜 선택',
                bugTimePlaceholder: '시간 선택',
                bugScreenshotLabel: '스크린샷：',
                bugDescriptionLabel: '설명：',
                bugDescriptionPlaceholder: 'Bug 세부 사항을 설명해 주세요. 이미지 붙여넣기를 지원합니다...',
                bugDescriptionPlaceholderMobile: '자세한 설명은 엔지니어가 문제를 더 빠르게 해결하는 데 도움이 됩니다',
                bugSubmitButton: '제출',
                bugCancelButton: '취소',
                bugSubmitSuccess: 'Bug 제출 성공',
                bugSubmitFailed: 'Bug 제출 실패',
                bugUploadSuccess: '이미지 업로드 성공',
                bugUploadFailed: '이미지 업로드 실패',
                introTitle: '저는 지창드라이브 지능형 고객 서비스입니다. 만나서 반갑습니다!',
                introDescription: '지창드라이브, 기술이 스마트 라이프를 이끕니다. 제품 상담, 기술 지원, 애프터 서비스 등의 도움을 드릴 수 있습니다. 질문을 알려주세요～',
                introPlaceholder: '지창 고객 서비스 어시스턴트에게 메시지 보내기',
                expandText: '텍스트 확장',
                collapseText: '텍스트 접기',
                feedbackDialogTitle: '피드백',
                feedbackCustomPlaceholder: '피드백을 입력해 주세요...',
                feedbackRequired: '피드백 옵션을 선택하거나 피드백을 입력해 주세요',
                feedbackSubmitted: '소중한 의견 감사합니다',
                cancelButton: '취소',
                submitButton: '제출',
                refreshPage: '페이지 새로고침',
                refreshWarning: '이번 새로고침은 기록을 삭제합니다',
                ttsRequestFailed: '음성 생성에 실패했습니다. 나중에 다시 시도해 주세요',
                feedbackOption1: '부정확한 답변',
                feedbackOption2: '불완전한 정보',
                feedbackOption3: '오래된 내용',
                feedbackOption4: '불분명한 표현',
                feedbackOption5: '관련 답변을 찾을 수 없음',
                feedbackOption6: '기타',
                feedbackLikeSubmitted: '만족해 주셔서 감사합니다! 더 나은 서비스를 제공하겠습니다.',
                feedbackDislikeSubmitted: '피드백 주셔서 감사합니다! 서비스 개선을 위해 노력하겠습니다.',
                feedbackLikeMessage: '평가해 주셔서 감사합니다',
                feedbackDislikeMessage: '서비스를 개선하겠습니다',
                dislikePopupTitle: '귀하의 불만 사유를 알고 싶습니다',
                dislikeOption1: '답변이 정확하지 않음',
                dislikeOption2: '도움이 되지 않음',
                dislikeOption3: '문의하기',
                dislikeOption4: '기타',
                dislikeReasonPlaceholder: '귀하의 불만 사유를 알고 싶습니다',
                dislikeValidationMessage: '이유를 선택하거나 의견을 입력해 주세요',
            },
            es: {
                welcomeMessage: '¡Hola! Soy el asistente de servicio al cliente inteligente de Jiecang Drive, bienvenido a Jiecang. Puedo brindarte consultoría de productos, soporte técnico, servicio post-venta y la información más reciente de productos. ¡No dudes en hacerme cualquier pregunta!',
                inputPlaceholder: 'Ingresar mensaje...',
                clickToTalk: 'Hacer clic para hablar',
                speaking: 'Hablando…',
                aiReplyFailed: 'Falló la conexión de red, inténtalo de nuevo más tarde.',
                recordingTooShort: 'Tiempo de habla muy corto',
                recordingFailed: 'Grabación falló, inténtalo de nuevo',
                uploadFailed: 'Subida falló',
                uploadRequestFailed: 'Solicitud de subida falló',
                imageUploadLimit: 'Solo se puede subir una imagen',
                imageUploading: 'Subiendo imagen',
                imageFileTypeError: 'Solo se pueden subir archivos de imagen',
                imageFileSizeError: 'El tamaño de la imagen no puede exceder 20M',
                microphonePermissionDenied: 'Permiso de micrófono denegado, habilita el permiso de micrófono en la configuración del navegador',
                microphoneAuthRequired: 'Se requiere permiso de micrófono para grabar, ¿autorizar ahora?',
                microphoneAuthFailed: 'Autorización de micrófono falló, verifica la configuración del navegador',
                audioPlayFailed: 'Reproducción de audio falló',
                recordingCanceled: 'Grabación cancelada',
                languageFeatureTitle: 'Selección de idioma',
                ttsFeatureTitle: 'Respuesta de voz',
                ttsFeatureInDevelopment: 'La función de voz aún no está disponible, ¡próximamente!',
                ttsEnableConfirm: 'Habilitar respuesta de voz impedirá la vista previa de imágenes y videos. ¿Habilitar respuesta de voz?',
                ttsDisableConfirm: '¿Deshabilitar respuesta de voz?',
                ttsEnabled: 'Función de voz habilitada',
                ttsDisabled: 'Función de voz deshabilitada',
                ticketFeatureTitle: 'Envío de Bug',
                ticketFeatureInDevelopment: 'La función de envío de tickets aún no está disponible, ¡próximamente!',
                bugDialogTitle: 'Envío de Bug',
                bugDateLabel: 'Hora:',
                bugDatePlaceholder: 'Seleccionar fecha',
                bugTimePlaceholder: 'Seleccionar hora',
                bugScreenshotLabel: 'Captura de pantalla:',
                bugDescriptionLabel: 'Descripción:',
                bugDescriptionPlaceholder: 'Por favor describa los detalles del Bug, soporta pegar imágenes...',
                bugDescriptionPlaceholderMobile: 'Una descripción detallada ayuda a los ingenieros a resolver problemas más rápido',
                bugSubmitButton: 'Enviar',
                bugCancelButton: 'Cancelar',
                bugSubmitSuccess: 'Bug enviado con éxito',
                bugSubmitFailed: 'Fallo en el envío del Bug',
                bugUploadSuccess: 'Imagen cargada con éxito',
                bugUploadFailed: 'Fallo en la carga de la imagen',
                introTitle: '¡Soy el servicio al cliente inteligente de Jiecang Drive, encantado de conocerte!',
                introDescription: 'Jiecang Drive, la tecnología impulsa la vida inteligente. Puedo brindarte consultoría de productos, soporte técnico, servicio post-venta y otra asistencia. Por favor, cuéntame tus preguntas～',
                introPlaceholder: 'Enviar mensaje al asistente de servicio al cliente Jiecang',
                expandText: 'Expandir texto',
                collapseText: 'Contraer texto',
                feedbackDialogTitle: 'Comentarios',
                feedbackCustomPlaceholder: 'Ingrese sus comentarios...',
                feedbackRequired: 'Seleccione una opción de comentario o ingrese comentarios',
                feedbackSubmitted: 'Gracias por su sugerencia',
                cancelButton: 'Cancelar',
                submitButton: 'Enviar',
                refreshPage: 'Actualizar página',
                refreshWarning: 'Esta actualización borrará el historial',
                ttsRequestFailed: 'Falló la generación de voz, inténtelo más tarde',
                feedbackOption1: 'Respuesta inexacta',
                feedbackOption2: 'Información incompleta',
                feedbackOption3: 'Contenido desactualizado',
                feedbackOption4: 'Expresión poco clara',
                feedbackOption5: 'No se encontró respuesta relevante',
                feedbackOption6: 'Otro',
                feedbackLikeSubmitted: '¡Gracias por su satisfacción! Continuaremos brindando un mejor servicio.',
                feedbackDislikeSubmitted: '¡Gracias por sus comentarios! Trabajaremos arduamente para mejorar nuestro servicio.',
                feedbackLikeMessage: 'Gracias por su evaluación',
                feedbackDislikeMessage: 'Mejoraremos nuestro servicio',
                dislikePopupTitle: 'Nos gustaría conocer el motivo de su insatisfacción',
                dislikeOption1: 'Respuesta inexacta',
                dislikeOption2: 'No fue útil',
                dislikeOption3: 'Contáctenos',
                dislikeOption4: 'Otro',
                dislikeReasonPlaceholder: 'Nos gustaría conocer el motivo de su insatisfacción',
                dislikeValidationMessage: 'Selecciona un motivo o escribe tus comentarios',
            },
            ru: {
                welcomeMessage: 'Привет! Я интеллектуальный помощник клиентского сервиса Jiecang Drive, добро пожаловать в Jiecang. Я могу предоставить консультации по продуктам, техническую поддержку, послепродажное обслуживание и последнюю информацию о продуктах. Не стесняйтесь задавать мне любые вопросы!',
                inputPlaceholder: 'Введите сообщение...',
                clickToTalk: 'Нажмите, чтобы говорить',
                speaking: 'Говорю…',
                aiReplyFailed: 'Не удалось подключиться к сети, попробуйте позже.',
                recordingTooShort: 'Время разговора слишком короткое',
                recordingFailed: 'Запись не удалась, попробуйте снова',
                uploadFailed: 'Загрузка не удалась',
                uploadRequestFailed: 'Запрос на загрузку не удался',
                imageUploadLimit: 'Можно загрузить только одно изображение',
                imageUploading: 'Загрузка изображения',
                imageFileTypeError: 'Можно загружать только файлы изображений',
                imageFileSizeError: 'Размер изображения не может превышать 20M',
                microphonePermissionDenied: 'Разрешение на микрофон отклонено, включите разрешение на микрофон в настройках браузера',
                microphoneAuthRequired: 'Для записи требуется разрешение на микрофон, авторизовать сейчас?',
                microphoneAuthFailed: 'Авторизация микрофона не удалась, проверьте настройки браузера',
                audioPlayFailed: 'Воспроизведение аудио не удалось',
                recordingCanceled: 'Запись отменена',
                languageFeatureTitle: 'Выбор языка',
                ttsFeatureTitle: 'Голосовой ответ',
                ttsFeatureInDevelopment: 'Голосовая функция пока недоступна, скоро будет!',
                ttsEnableConfirm: 'Включение голосового ответа предотвратит предварительный просмотр изображений и видео. Включить голосовой ответ?',
                ttsDisableConfirm: 'Отключить голосовой ответ?',
                ttsEnabled: 'Голосовая функция включена',
                ttsDisabled: 'Голосовая функция отключена',
                ticketFeatureTitle: 'Отправка Bug',
                ticketFeatureInDevelopment: 'Функция отправки тикетов пока недоступна, скоро будет!',
                bugDialogTitle: 'Отправка Bug',
                bugDateLabel: 'Время:',
                bugDatePlaceholder: 'Выберите дату',
                bugTimePlaceholder: 'Выберите время',
                bugScreenshotLabel: 'Скриншот:',
                bugDescriptionLabel: 'Описание:',
                bugDescriptionPlaceholder: 'Пожалуйста, опишите детали Bug, поддерживает вставку изображений...',
                bugDescriptionPlaceholderMobile: 'Подробное описание помогает инженерам быстрее решать проблемы',
                bugSubmitButton: 'Отправить',
                bugCancelButton: 'Отмена',
                bugSubmitSuccess: 'Bug успешно отправлен',
                bugSubmitFailed: 'Не удалось отправить Bug',
                bugUploadSuccess: 'Изображение успешно загружено',
                bugUploadFailed: 'Не удалось загрузить изображение',
                introTitle: 'Я интеллектуальный клиентский сервис Jiecang Drive, рад познакомиться!',
                introDescription: 'Jiecang Drive, технологии движут умной жизнью. Я могу предоставить консультации по продуктам, техническую поддержку, послепродажное обслуживание и другую помощь. Пожалуйста, расскажите мне о ваших вопросах～',
                introPlaceholder: 'Отправить сообщение помощнику клиентского сервиса Jiecang',
                expandText: 'Развернуть текст',
                collapseText: 'Свернуть текст',
                feedbackDialogTitle: 'Обратная связь',
                feedbackCustomPlaceholder: 'Пожалуйста, введите вашу обратную связь...',
                feedbackRequired: 'Пожалуйста, выберите вариант обратной связи или введите обратную связь',
                feedbackSubmitted: 'Спасибо за ваше предложение',
                cancelButton: 'Отмена',
                submitButton: 'Отправить',
                refreshPage: 'Обновить страницу',
                refreshWarning: 'Это обновление очистит историю',
                ttsRequestFailed: 'Не удалось сгенерировать голос, попробуйте позже',
                feedbackOption1: 'Неточный ответ',
                feedbackOption2: 'Неполная информация',
                feedbackOption3: 'Устаревший контент',
                feedbackOption4: 'Неясное выражение',
                feedbackOption5: 'Релевантный ответ не найден',
                feedbackOption6: 'Другое',
                feedbackLikeSubmitted: 'Спасибо за вашу удовлетворенность! Мы продолжим предоставлять лучший сервис.',
                feedbackDislikeSubmitted: 'Спасибо за ваш отзыв! Мы будем усердно работать над улучшением нашего сервиса.',
                feedbackLikeMessage: 'Спасибо за вашу оценку',
                feedbackDislikeMessage: 'Мы улучшим наш сервис',
                dislikePopupTitle: 'Мы хотели бы узнать причину вашего недовольства',
                dislikeOption1: 'Ответ неточен',
                dislikeOption2: 'Не помогло',
                dislikeOption3: 'Связаться с нами',
                dislikeOption4: 'Другое',
                dislikeReasonPlaceholder: 'Мы хотели бы узнать причину вашего недовольства',
                dislikeValidationMessage: 'Выберите причину или введите комментарии',
            }
        }
        // 获取输入框占位符
        const getInputPlaceholder = () => {
            if (chatState.value === 'intro') {
                // Intro页面使用动态配置的占位符
                return introConfig.value?.input_placeholder;
            } else {
                // Chatting页面使用原有配置
                return t('inputPlaceholder');
            }
        }

        // 语言检测函数
        // 需要修改为：
        const detectLanguage = () => {
            const language = (navigator.browserLanguage || navigator.language).toLowerCase()
            
            // 支持所有10种语言
            if (language.indexOf('zh') > -1) {
                return 'zh'
            } else if (language.indexOf('en') > -1) {
                return 'en'
            } else if (language.indexOf('de') > -1) {
                return 'de'
            } else if (language.indexOf('fr') > -1) {
                return 'fr'
            } else if (language.indexOf('ja') > -1) {
                return 'ja'
            } else if (language.indexOf('it') > -1) {
                return 'it'
            } else if (language.indexOf('pt') > -1) {
                return 'pt'
            } else if (language.indexOf('ko') > -1) {
                return 'ko'
            } else if (language.indexOf('es') > -1) {
                return 'es'
            } else if (language.indexOf('ru') > -1) {
                return 'ru'
            } else {
                return 'en' // 默认英文
            }
        }

        // 翻译函数
        const t = (key) => {
            return translations[currentLang.value][key] || key
        }
        
        const dislikeOptionLabels = computed(() => ([
            t('dislikeOption1'),
            t('dislikeOption2'),
            t('dislikeOption3'),
            t('dislikeOption4')
        ]))
        
        // BUG弹窗翻译函数 - 使用当前选择的语言（跟随语言切换）
        // 当currentLanguage变化时，模板会重新渲染，tb函数会读取新的语言值
        const tb = (key) => {
            const lang = currentLanguage.value || detectLanguage();
            return translations[lang]?.[key] || translations['zh']?.[key] || key;
        }

        const canSend = computed(() => {
            return (inputMessage.value.trim() || previewImages.value.length > 0) && !isAiResponding.value||isRequestCancellable.value
        })


        const scrollToBottom = async () => {
            await nextTick();
            const container = chatContainer.value;
            if (container) {
                // 直接滚动到底部，避免平滑滚动的闪屏
                container.scrollTop = container.scrollHeight;
            }
        }

        // 强制滚动到底部（用于流式回复）
        const forceScrollToBottom = () => {
            const container = chatContainer.value;
            if (!container) return;
            const distanceToBottom = container.scrollHeight - container.scrollTop - container.clientHeight;
            // 仅当用户接近底部时才自动滚动，避免打断用户向上查看
            if (distanceToBottom <= 150) {//原先设置过大
                container.scrollTop = container.scrollHeight;
            }
        }

        const handleInputFocus = () => {
            document.body.style.overflow = 'hidden'
            document.body.style.position = 'fixed'
            isKeyboardOpen.value = true
            showRecordModal.value = false
            cleanupRecording()
            setTimeout(scrollToBottom, 300)
        }

        const handleInputBlur = () => {
            document.body.style.overflow = ''
            document.body.style.position = ''
            isKeyboardOpen.value = false
        }

        // 录音格式检测和配置 - 使用MP3格式
        const getSupportedMimeType = () => {
            // 优先使用MP3格式
            const mp3Types = [
                'audio/mp3',
                'audio/mpeg',
                'audio/mp4'
            ];

            for (let type of mp3Types) {
                if (MediaRecorder.isTypeSupported(type)) {
                    console.log('使用录音格式: MP3');
                    return type;
                }
            }

            // 如果MP3不支持，降级到其他格式
            const fallbackTypes = [
                'audio/webm',
                'audio/ogg',
                'audio/wav',
                'audio/wave'
            ];
            for (let type of fallbackTypes) {
                if (MediaRecorder.isTypeSupported(type)) {
                    console.log('MP3不支持，降级使用格式:', type);
                    return type;
                }
            }
            console.warn('浏览器不支持任何音频格式');
            return 'audio/mp3';  // 默认返回MP3
        }

        let preferredMimeType = getSupportedMimeType();
        let preferredExt = 'mp3';  // 统一使用 mp3 扩展名

        // 上传工具函数
        const uploadFileToServer = async (file) => {
            const formData = new FormData();
            formData.append('file', file);
            let res;
            try {
                res = await request({
                    url: '/api/upload',
                    method: 'post',
                    data: formData,
                    headers: { 'Content-Type': 'multipart/form-data' }
                });
            } catch (e) {
                //alert(1)
                ElMessage.error(t('uploadRequestFailed'));
                return null;
            }
            if (res && res.success) {
                return res.url;
            } else {
                //alert(2)
                ElMessage.error((res && res.msg) || t('uploadFailed'));
                return null;
            }
        };

        // 图片上传
        const handleImageUpload = async (event) => {
            const MAX_IMAGE_SIZE = 15 * 1024*1024 ;
            if (isAiResponding.value) {
                return; // AI回答期间禁止上传图片
            }
          
            const files = Array.from(event.target.files);
              // 2. 检查文件大小
              if (files[0].size > MAX_IMAGE_SIZE) {
                ElMessage.error(t('imageFileSizeError')); // 新的翻译
                return;
            }
            if (files.length > 0) {
                const file = files[0];
                if (!file.type.startsWith('image/')) {
                    ElMessage.error(t('imageUploadLimit'));
                    return;
                }
                isUploadingImage.value = true;
                const url = await uploadFileToServer(file);
                isUploadingImage.value = false;
                if (url) {
                    previewImages.value = [url];
                }
            }
            if (fileInputRef.value) fileInputRef.value.value = '';
        };

        const removePreviewImage = (idx) => {
            previewImages.value = [] // 清空所有图片
        }

        // 打字机效果函数
        const typewriterEffect = async (targetMsg, fullText, delay = 30) => {
            targetMsg.text = '';
            for (let i = 0; i < fullText.length; i++) {
                targetMsg.text += fullText[i];
                messages.value.splice(messages.value.indexOf(targetMsg), 1, { ...targetMsg });
                await nextTick();
                await scrollToBottom(); // 每输出一个字都滚动到底部
                await new Promise(resolve => setTimeout(resolve, delay));
            }
        }
const cc= () => {
    // 1. 添加空值检查
    const rawLanguage = navigator.language || navigator.userLanguage || navigator.browserLanguage || navigator.systemLanguage;
    if (!rawLanguage) return 1; // 默认英文
    
    const language = rawLanguage.toLowerCase();
    
    const languageMap = {
        'zh': 0,    // 中文
        'en': 1,    // 英文  
        'de': 2,    // 德语
        'fr': 3,    // 法语
        'ja': 4,    // 日语
        'it': 5,    // 意大利语
        'pt': 6,    // 葡萄牙语
        'ko': 7,    // 韩语
        'es': 8,    // 西班牙语
        'ru': 9     // 俄语
    };
    
    // 2. 直接使用startsWith处理所有情况
    for (const [code, value] of Object.entries(languageMap)) {
        if (language.startsWith(code)) {
            return value;
        }
    }
    
    return 1; // 默认英文
};


// 新增转换函数
const getBrowserLanguageCodeFromStorage = () => {
    const currentLanguage = localStorage.getItem('currentLanguage');
    if (currentLanguage) {
        const languageMap = {
            'zh': 0, 'en': 1, 'de': 2, 'fr': 3, 'ja': 4,
            'it': 5, 'pt': 6, 'ko': 7, 'es': 8, 'ru': 9
        };
        if (languageMap[currentLanguage] !== undefined) {
            return languageMap[currentLanguage];
        }
    }
    
    // 降级：使用浏览器检测
    return getBrowserLanguageCode();
};

// 获取当前语言代码（用于反馈功能）
const getLanguageCode = () => {
    return getBrowserLanguageCodeFromStorage();
};

        // 根据 fk 映射对应的本地化文本（1-6 对应六个预设选项）
        const getFkText = (fk) => {
            switch (fk) {
                case 1: return t('feedbackOption1');
                case 2: return t('feedbackOption2');
                case 3: return t('feedbackOption3');
                case 4: return t('feedbackOption4');
                case 5: return t('feedbackOption5');
                case 6: return t('feedbackOption6');
                default: return '';
            }
        };

        

        // 标记：是否处于AI流式返回中（用于控制评价入口等UI显示）
        const isStreamingResponse = ref(false)
        // 当前正在流式的AI消息的 userMessageId，仅隐藏这条的评价入口
        const streamingMessageId = ref(null)

        // 流式AI回复处理（支持TTS/音频/文本自动切换）
        const streamAIReply = async (body) => {
            // 设置AI回答状态
            isAiResponding.value = true;
            //停止按钮
            isRequestCancellable.value = true
            // 开始流式：打开流式标记，用于隐藏评价入口
            isStreamingResponse.value = true


            const abortController = new AbortController()
            currentAbortController.value = abortController

            
            // 1. 先插入加载状态
            const loadingMsg = { type: 'loading', text: '', isUser: false };
            messages.value.push(loadingMsg);
            await scrollToBottom();

            try {
                // 添加语言标记到请求体
                const requestBody = {
                    ...body,
                    language: currentLang.value === 'zh' ? 0 : 1,  // 0代表中文，1代表英文
                    tts: useTTS.value ? 1 : 0,  // 0代表文字，1代表TTS
                   // browserLanguage: getBrowserLanguageCode(),     // 新增字段
                   browserLanguage: getBrowserLanguageCodeFromStorage(),
                    // 新增：携带AI会话信息（如果有的话）下面两个已经去掉,后端没有接收
                    aiConversationId: localStorage.getItem('aiConversationId') || null,
                    aiMessageId: localStorage.getItem('aiMessageId') || null,
                };
                
                // 获取conversationId并添加到请求头
                const conversationId = localStorage.getItem('conversationId');
                const headers = { 'Content-Type': 'application/json' };
                if (conversationId) {
                    headers['X-Conversation-ID'] = conversationId;
                }
                
                const res = await fetch('/api/dify/chat-messages/stream', {
                    method: 'POST',
                    body: JSON.stringify(requestBody),
                    headers: headers,
                    signal: abortController.signal  // 添加取消信号
                });
                if (!res.ok) throw new Error('AI服务异常');
                
                // 统一流式处理所有AI回复
                const reader = res.body.getReader();
                let decoder = new TextDecoder();
                let buffer = '';
                let isFirstResponse = true;
                let aiMsg = null;
                // 新增：用于保存AI会话信息
                let aiConversationId = null;
                let aiMessageId = null;
                
                while (true) {
                    const { value, done } = await reader.read();
                    if (done) break;
                    const chunk = decoder.decode(value, { stream: true });
                    buffer += chunk;
                    let lines = buffer.split(/\r?\n|\n|\r/);
                    buffer = lines.pop();
                    for (let line of lines) {
                        if (line.trim()) {
                            try {
                                const json = JSON.parse(line);


                                // 🔥 优先处理错误事件
                                if (json.event === 'error' && json.answer) {
                                    // 处理错误事件，输出answer，不显示评价功能
                                    console.log('收到错误事件:', json);
                                    isRequestCancellable.value = false
                                    const errorMsg = { 
                                        type: 'text', 
                                        text: json.answer, 
                                        isUser: false,

                                        userMessageId: json.userMessageId,  // 保存用户消息ID
                                            feedback: 0,
                                            suggest: '' ,// 新增
                                            isSuccess: 1,  // 新增：标记为成功状态
                                            fk: json.fk ?? 0 // 新增：更多选项编号（1-6）
                                        // 不设置 userMessageId，这样不会显示评价按钮
                                    };
                                    const loadingIndex = messages.value.findIndex(msg => msg.type === 'loading');
                                    if (loadingIndex !== -1) {
                                        messages.value.splice(loadingIndex, 1, errorMsg);
                                    } else {
                                        messages.value.push(errorMsg);
                                    }
                                    await nextTick();
                                    forceScrollToBottom();
                                    isAiResponding.value = false;
                                    return;
                                }

                                // 🔥 新增：处理系统消息（会话失效等）
                                if (json.type === 'system' && json.action === 'refresh-required') {
                                    console.log('收到系统消息：会话失效，需要刷新:', json.message);
                                    
                                    // 清除本地存储的会话信息
                                    localStorage.removeItem('conversationId');
                                    localStorage.removeItem('aiConversationId');
                                    localStorage.removeItem('aiMessageId');
                                    localStorage.removeItem('hasMoreHistory');
                                    localStorage.removeItem('nextQueryTimestamp');
                                    
                                    // 创建系统消息对象
                                    const systemMsg = {
                                        type: 'system',
                                        action: 'refresh-required',
                                        text: json.message || (currentLang.value === 'zh' ? '会话检测失败请刷新' : 'Session validation failed, please refresh'),
                                        isUser: false
                                    };
                                    
                                    // 替换加载状态为系统消息
                                    const loadingIndex = messages.value.findIndex(msg => msg.type === 'loading');
                                    if (loadingIndex !== -1) {
                                        messages.value.splice(loadingIndex, 1, systemMsg);
                                    } else {
                                        messages.value.push(systemMsg);
                                    }
                                    
                                    // 重置AI响应状态
                                    isAiResponding.value = false;
                                    
                                    // 滚动到底部显示系统消息
                                    await nextTick();
                                    forceScrollToBottom();
                                    
                                    // 退出流式处理
                                    return;
                                }

                                
                                // 新增：获取AI会话信息（不重复保存）
                                if (json.conversation_id && !aiConversationId) {
                                    aiConversationId = json.conversation_id;
                                }
                                if (json.message_id && !aiMessageId) {
                                    aiMessageId = json.message_id;
                                }
                                
                                // 音频回复
                                if (json.type === 'voice' && json.url) {
                                    isRequestCancellable.value = false
                                    const aiMsg = { type: 'voice', url: json.url, isUser: false, text: json.text, showText: false };
                                    const loadingIndex = messages.value.findIndex(msg => msg.type === 'loading');
                                    if (loadingIndex !== -1) {
                                        messages.value.splice(loadingIndex, 1, aiMsg);
                                    } else {
                                        messages.value.push(aiMsg);
                                    }
                                    await nextTick();
                                    forceScrollToBottom();
                                    isAiResponding.value = false;
                                    return;
                                } else if (json.type === 'text' && json.text) {
                                    alert(1)
                                    isRequestCancellable.value = false
                                    // 纯文本回复（TTS失败或AI无内容）
                                    const aiMsg = { type: 'text', text: json.text, isUser: false };
                                    const loadingIndex = messages.value.findIndex(msg => msg.type === 'loading');
                                    if (loadingIndex !== -1) {
                                        messages.value.splice(loadingIndex, 1, aiMsg);
                                    } else {
                                        messages.value.push(aiMsg);
                                    }
                                    await nextTick();
                                    forceScrollToBottom();
                                    isAiResponding.value = false;
                                    return;




                                } else if (json.event === 'message' && json.answer) {
                                    //alert(2)
                                    //isRequestCancellable.value = false
                                    // 普通流式文本
                                    if (isFirstResponse) {
                                        // 验证 userMessageId 是否存在
                                        if (!json.userMessageId) {
                                            console.error('AI消息缺少userMessageId:', json);
                                            ElMessage.error('AI消息ID缺失，请刷新页面重试');
                                            return; // 停止处理
                                        }
                                        // 保存userMessageId（用于评价功能）
                                        aiMsg = { 
                                            type: 'text', 
                                            text: json.answer, 
                                            isUser: false,
                                            userMessageId: json.userMessageId,  // 保存用户消息ID
                                            feedback: 0,
                                            suggest: '' ,// 新增
                                            isSuccess: 1,  // 新增：标记为成功状态
                                            fk: json.fk ?? 0 // 新增：更多选项编号（1-6）
                                        };
                                        //alert(JSON.stringify(aiMsg))
                                        const loadingIndex = messages.value.findIndex(msg => msg.type === 'loading');
                                        if (loadingIndex !== -1) {
                                            messages.value.splice(loadingIndex, 1, aiMsg);
                                        }
                                        isFirstResponse = false;
                                        // 记录当前流式消息ID，用于只隐藏该条消息的评价入口
                                        streamingMessageId.value = json.userMessageId;
                                    } else {
                                        aiMsg.text += json.answer;
                                        messages.value.splice(messages.value.indexOf(aiMsg), 1, { ...aiMsg });
                                    }
                                    await nextTick();
                                    forceScrollToBottom();
                                }
                            } catch (e) {
                                // 解析异常忽略
                            }
                        }
                    }
                }
                isRequestCancellable.value = false
                isStreamingResponse.value = false
                streamingMessageId.value = null
                // 新增：流式处理完成后，统一保存AI会话信息
                if (aiConversationId && aiMessageId) {
                    // 保存AI会话信息到localStorage
                    localStorage.setItem('aiConversationId', aiConversationId);
                    localStorage.setItem('aiMessageId', aiMessageId);
                    console.log('保存AI会话信息:', aiConversationId, aiMessageId);
                }
                
                // // 如果TTS开关开启，且AI消息为文本类型，自动播放TTS
                // if (useTTS.value && aiMsg && aiMsg.userMessageId) {
                //     // 保存userMessageId，避免引用问题
                //     const savedUserMessageId = aiMsg.userMessageId;
                    
                //     // 找到消息在数组中的索引
                //     const messageIndex = messages.value.findIndex(msg => 
                //         msg === aiMsg || 
                //         (msg.userMessageId === savedUserMessageId && !msg.isUser)
                //     );
                    
                //     if (messageIndex !== -1) {
                //         // 延迟一段时间，等待后端异步TTS生成完成
                //         setTimeout(() => {
                //             // 再次检查消息是否存在，使用最新的消息对象
                //             const currentMessage = messages.value[messageIndex];
                //             if (currentMessage && currentMessage.userMessageId) {
                //                 console.log('TTS开关已开启，自动播放语音:', currentMessage.userMessageId);
                //                 handlePlayTTS(messageIndex, currentMessage.userMessageId);
                //             } else {
                //                 console.warn('自动播放TTS失败：消息不存在或缺少userMessageId', {
                //                     messageIndex,
                //                     message: currentMessage,
                //                     savedUserMessageId
                //                 });
                //             }
                //         }, 1000); // 延迟1.5秒，给后端异步TTS生成时间
                //     } else {
                //         console.warn('自动播放TTS失败：未找到消息索引', {
                //             savedUserMessageId,
                //             aiMsg
                //         });
                //     }
                // }
                
                // 流式文本回复完成时重置状态
                isAiResponding.value = false;
            } catch (e) {
                // if (e.name === 'AbortError') {
                //     console.log('用户取消了请求')
                //     return // 不显示错误消息
                // }
                
                if (e.name === 'AbortError') {
    console.log('用户取消了请求')
    
    // 移除加载状态，根据当前语言显示取消消息
    const loadingIndex = messages.value.findIndex(msg => msg.type === 'loading');
    if (loadingIndex !== -1) {
        const cancelMessages = {
            zh: '本次请求已取消',
            en: 'Request has been cancelled',
            de: 'Anfrage wurde abgebrochen',
            fr: 'La demande a été annulée',
            ja: 'リクエストがキャンセルされました',
            it: 'La richiesta è stata annullata',
            pt: 'A solicitação foi cancelada',
            ko: '요청이 취소되었습니다',
            es: 'La solicitud ha sido cancelada',
            ru: 'Запрос был отменен'
        };
        
            const cancelMsg = { 
                type: 'text', 
                text: cancelMessages[currentLang.value] || cancelMessages.en,
                isUser: false 
            };
            messages.value.splice(loadingIndex, 1, cancelMsg);
            await scrollToBottom();
            }
    
            return
        }
                console.error('AI回复出错:', e);
                // 如果出错时还是加载状态，需要替换为错误消息
                const loadingIndex = messages.value.findIndex(msg => msg.type === 'loading');
                if (loadingIndex !== -1) {
                    const errorMsg = { type: 'text', text: t('aiReplyFailed'), isUser: false };
                    messages.value.splice(loadingIndex, 1, errorMsg);
                } else if (aiMsg) {
                    aiMsg.text = t('aiReplyFailed');
                    messages.value.splice(messages.value.indexOf(aiMsg), 1, { ...aiMsg });
                }
                await scrollToBottom();
                // 出错时也要重置状态
                isAiResponding.value = false;
            }finally{
                isAiResponding.value = false
                isRequestCancellable.value = false
                currentAbortController.value = null
                // 结束流式：关闭流式标记并清除当前消息ID，允许其它消息显示评价入口
                isStreamingResponse.value = false
                streamingMessageId.value = null
            }
        }

        // 3. 添加停止请求方法
        // const cancelCurrentRequest = () => {
        //     if (currentAbortController.value) {
        //         currentAbortController.value.abort()
        //     }
        // }
        // 添加停止请求方法
        // const cancelCurrentRequest = () => {
        //     if (currentAbortController.value) {
        //         currentAbortController.value.abort()
        //         isRequestCancellable.value = false
        //         isAiResponding.value = false
        //     }
        // }
//         const cancelCurrentRequest = () => {
//     if (currentAbortController.value) {
//         currentAbortController.value.abort()
        
       
//         isRequestCancellable.value = false
//         isAiResponding.value = false
//     }
// }
const cancelCurrentRequest = () => {
    if (currentAbortController.value) {
        currentAbortController.value.abort()
        // 不在这里重置状态，让 finally 块统一处理
    }
}
        // 新增：清空AI会话信息的工具方法
        const clearAISessionInfo = () => {
            localStorage.removeItem('aiConversationId');
            localStorage.removeItem('aiMessageId');
            console.log('清空AI会话信息');
        };



         // 🔥 新增：刷新方法
         const handleRefresh = () => {
            console.log('用户点击刷新按钮');
            
            // 清除本地存储
            localStorage.removeItem('conversationId');
            localStorage.removeItem('aiConversationId');
            localStorage.removeItem('aiMessageId');
            localStorage.removeItem('hasMoreHistory');
            localStorage.removeItem('nextQueryTimestamp');
            
            // 刷新页面
            window.location.reload();
        };

        // 修改sendMessage，图文消息传递图片url
        const sendMessage = async () => {
            if (!canSend.value || isAiResponding.value) return
            
            // 状态切换逻辑：从welcome或intro状态切换到chatting状态
            if (chatState.value === 'welcome' || chatState.value === 'intro') {
                chatState.value = 'chatting'
                // 新增：从介绍页面进入聊天时，清空AI会话信息（开始新对话）
                clearAISessionInfo();
            }
            
            const text = inputMessage.value.trim()
            const images = previewImages.value.slice()
            let userMsg;
            if (images.length) {
                if (text) {
                    // 有图片 + 有文字 = mixed
                    userMsg = {
                        type: 'mixed',
                        text,
                        images,
                        isUser: true
                    }
                    messages.value.push(userMsg)
                    previewImages.value = []
                    inputMessage.value = ''
                    // 强制滚动到底部显示用户消息
                    await scrollToBottom()
                    // 传递图片url
                    await streamAIReply({ type: 'mixed', text, imageUrls: images })
                } else {
                    // 有图片 + 无文字 = image
                    userMsg = {
                        type: 'mixed',
                        text,
                        images,
                        isUser: true
                    }
                    messages.value.push(userMsg)
                    previewImages.value = []
                    inputMessage.value = ''
                    // 强制滚动到底部显示用户消息
                    await scrollToBottom()
                    // 传递图片url
                    await streamAIReply({ type: 'image', imageUrls: images })
                }
            } else if (text) {
                userMsg = {
                    type: 'text',
                    text,
                    isUser: true
                }
                messages.value.push(userMsg)
                inputMessage.value = ''
                // 强制滚动到底部显示用户消息
                await scrollToBottom()
                await streamAIReply({ type: 'text', text })
            }
        }

        // 录音最大时长60秒，最小时长1秒
        const MAX_RECORD_TIME = 60
        const MIN_RECORD_TIME = 1

        // 新增：点击录音按钮的处理
        const handleRecordClick = () => {
            if (!isRecording.value && showRecordModal.value) {
                startRecording();
                //newStartRecording2();
            } else if (isRecording.value) {
                stopRecording();
                //newStopRecording2();
            }
        };

        // 开始录音
        const startRecording = async () => {
            if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
                ElMessage.error(t('microphoneAuthFailed') || '当前浏览器不支持录音功能');
                showRecordModal.value = false;
                return;
            }
            if (isRecording.value) return;  // 防止重复启动

            try {
                // 确保清理之前的资源
                cleanupRecording();

                // 设置音频约束 - 简化配置
                const audioConstraints = {
                    audio: {
                        echoCancellation: true,
                        noiseSuppression: true,
                        autoGainControl: true
                    }
                };

                const stream = await navigator.mediaDevices.getUserMedia(audioConstraints)
                console.log('getUserMedia返回的stream:', stream)
                
                // 检查实际音频设置
                const audioTrack = stream.getAudioTracks()[0];
                const settings = audioTrack.getSettings();
                console.log('音频轨道设置:', settings);
                console.log('采样率:', settings.sampleRate);
                console.log('声道数:', settings.channelCount);
                console.log('采样大小:', settings.sampleSize);
                
                // 验证音频设置是否符合Azure要求
                if (settings.sampleRate !== 16000) {
                    console.warn('警告：采样率不是16kHz，实际值:', settings.sampleRate);
                }
                if (settings.channelCount !== 1) {
                    console.warn('警告：不是单声道，实际值:', settings.channelCount);
                }

                // 检查是否支持任何音频格式
                if (!preferredMimeType) {
                    throw new Error('当前浏览器不支持任何音频录制格式');
                }

                // 创建 MediaRecorder 实例 - 优化配置确保Azure兼容
                const options = {
                    mimeType: preferredMimeType,
                    audioBitsPerSecond: 256000  // 256kbps，适合16kHz 16bit单声道WAV
                };

                try {
                    mediaRecorder.value = new MediaRecorder(stream, options);
                    console.log('MediaRecorder创建成功，配置:', options);
                } catch (e) {
                    console.error('创建MediaRecorder失败，尝试不带配置创建:', e);
                    // 如果带配置创建失败，尝试不带配置创建
                    mediaRecorder.value = new MediaRecorder(stream);
                    console.log('MediaRecorder创建成功（无配置）');
                }

                audioChunks.value = []

                mediaRecorder.value.ondataavailable = async (event) => {
                    console.log('ondataavailable事件触发，event.data.size:', event.data.size)
                    if (event.data.size > 0) {
                        audioChunks.value.push(event.data)
                        // 只在录音已停止时处理数据
                        if (!isRecording.value) {
                            if (isCancelByUser) {
                                ElMessage.info(t('recordingCanceled'));
                                isCancelByUser = false;
                                showRecordModal.value = false;
                                cleanupRecording();
                                return;
                            }
                            // 录音时长判断
                            if (recordingTime.value < MIN_RECORD_TIME) {
                                ElMessage.warning(t('recordingTooShort'));
                                showRecordModal.value = false;
                                cleanupRecording();
                                return;
                            }
                            // 处理录音数据并上传
                            const audioBlob = new Blob(audioChunks.value, { type: preferredMimeType });
                            console.log('录音文件大小', audioBlob.size, '类型', audioBlob.type)
                            if (audioChunks.value.length === 0 || audioBlob.size === 0) {
                                ElMessage.error(t('recordingFailed'));
                                showRecordModal.value = false;
                                cleanupRecording();
                                return;
                            }
                            const file = new File([audioBlob], `record_${Date.now()}.${preferredExt}`, { type: preferredMimeType });

                            // 立即关闭录音弹窗和清理资源
                            showRecordModal.value = false;
                            cleanupRecording();

                            const url = await uploadFileToServer(file);
                            if (url) {
                                // 状态切换逻辑：从welcome或intro状态切换到chatting状态
                                if (chatState.value === 'welcome' || chatState.value === 'intro') {
                                    chatState.value = 'chatting'
                                }
                                
                                messages.value.push({
                                    type: 'voice',
                                    url,
                                    duration: recordingTime.value,
                                    isUser: true
                                });
                                await scrollToBottom();
                                // 录音上传成功后，发送URL给后端获取AI回复
                                if (!isAiResponding.value) {
                                    await streamAIReply({
                                        type: 'voice',
                                        audioUrl: url
                                    });
                                }
                            }
                            await scrollToBottom();
                        }
                    }
                }

                mediaRecorder.value.onstart = () => {
                    console.log('mediaRecorder开始录音，使用格式:', preferredMimeType)
                }

                mediaRecorder.value.onstop = () => {
                    console.log('mediaRecorder停止录音')
                }

                mediaRecorder.value.onerror = (e) => {
                    console.error('mediaRecorder录音出错:', e)
                }

                mediaRecorder.value.start()
                isRecording.value = true
                recordingTime.value = 0
                recordingStartTime = Date.now()

                // 使用固定间隔更新计时
                recordingTimer = setInterval(() => {
                    const currentTime = Math.floor((Date.now() - recordingStartTime) / 1000)
                    if (currentTime !== recordingTime.value) {
                        recordingTime.value = currentTime
                    }
                    if (recordingTime.value >= MAX_RECORD_TIME) {
                        stopRecording()
                    }
                }, 1000)
            } catch (error) {
                console.error('录音失败:', error)
                ElMessage.error(error.message || t('recordingFailed'))
                cleanupRecording()
            }
        }

        // 停止录音
        const stopRecording = async () => {
            if (!isRecording.value) return;

            try {
                isRecording.value = false;  // 先设置状态
                clearTimers();  // 清理定时器

                if (mediaRecorder.value && mediaRecorder.value.state === 'recording') {
                    console.log('调用mediaRecorder.stop()')
                    mediaRecorder.value.stop();
                }
            } catch (error) {
                console.error('停止录音失败:', error);
                ElMessage.error(t('recordingFailed'));
                cleanupRecording();
            }
        };

        // 取消录音
        const cancelRecording = () => {
            if (mediaRecorder.value && mediaRecorder.value.state === 'recording') {
                isCancelByUser = true; // 标记为用户取消
                mediaRecorder.value.stop();
            }
            showRecordModal.value = false;
            cleanupRecording();
        };

        // 清理定时器
        const clearTimers = () => {
            if (recordingTimer) {
                clearInterval(recordingTimer)
                recordingTimer = null
            }
            if (recordTimeout) {
                clearTimeout(recordTimeout)
                recordTimeout = null
            }
        }

        // 清理录音资源
        const cleanupRecording = () => {
            if (mediaRecorder.value) {
                try {
                    // 如果还在录音，先停止
                    if (mediaRecorder.value.state === 'recording') {
                        mediaRecorder.value.stop();
                    }
                    // 停止所有音轨
                    if (mediaRecorder.value.stream) {
                        mediaRecorder.value.stream.getTracks().forEach(track => {
                            track.stop();
                            mediaRecorder.value.stream.removeTrack(track);
                        });
                    }
                } catch (e) {
                    console.error('清理录音资源时出错:', e);
                }
                mediaRecorder.value = null;
            }

            isRecording.value = false;
            recordingTime.value = 0;
            recordingStartTime = 0;
            audioChunks.value = [];
            clearTimers();
        };
        // 🛑 停止实时语音识别
// const newStopRecording2 = () => {
//     console.log('=== 停止实时语音识别 ===');
    
//     // 1. 停止录音
//     if (mediaRecorder.value && mediaRecorder.value.state !== 'inactive') {
//         mediaRecorder.value.stop();
//         console.log('✅ 录音已停止');
//     }
    
//     // 2. 关闭WebSocket连接
//     if (ws.value && ws.value.readyState === WebSocket.OPEN) {
//         ws.value.close();
//         console.log('✅ WebSocket连接已关闭');
//     }
    
//     // 3. 清理资源
//     cleanupRecording();
    
//     ElMessage.success('录音已停止');
// };

        // 显示页面中间刷新按钮
        const showRefreshButtonClick = () => {
            showRefreshButton.value = true;
        };
        
        // 🔧 WebSocket连接测试方法（只测试连接，不录音）
        // 🔧 实时语音识别方法
// const newStartRecording2 = async () => {
//     console.log('=== 实时语音识别开始 ===');
    
//     // 1. 检查浏览器支持
//     if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
//         ElMessage.error('当前浏览器不支持录音功能');
//         return;
//     }
    
//     // 2. 防止重复启动
//     if (isRecording.value) return;
    
//     try {
//         // 3. 清理之前的资源
//         cleanupRecording();
        
//         // 4. 清空实时识别文本
//         realTimeRecognizedText.value = '';
        
//         // 5. 获取语言参数并建立WebSocket连接
//         const language = getBrowserLanguageCodeFromStorage();
//         const wsUrl = `wss://ai.slssys.com/api/realtime-asr/${language}`;
//         console.log('连接WebSocket:', wsUrl);
        
//         ws.value = new WebSocket(wsUrl);
        
//         // 6. WebSocket连接成功后，开始录音
//         ws.value.onopen = async () => {
//             console.log('✅ WebSocket连接成功！');
            
//             try {
//                 // 6.1 获取麦克风权限
//                 const stream = await navigator.mediaDevices.getUserMedia({ 
//                     audio: {
//                         echoCancellation: true,
//                         noiseSuppression: true,
//                         autoGainControl: true
//                     }
//                 });
//                 console.log('✅ 获取麦克风权限成功');
                
//                 // 6.2 创建MediaRecorder - 配置音频格式确保Azure兼容
//                 const getPreferredMimeType = () => {
//                     // 优先使用WebM格式（大多数浏览器支持）
//                     const webmTypes = ['audio/webm', 'audio/webm;codecs=opus'];
//                     for (let type of webmTypes) {
//                         if (MediaRecorder.isTypeSupported(type)) {
//                             console.log('使用录音格式:', type);
//                             return type;
//                         }
//                     }
//                     // 降级到其他格式
//                     const fallbackTypes = ['audio/ogg', 'audio/mp4'];
//                     for (let type of fallbackTypes) {
//                         if (MediaRecorder.isTypeSupported(type)) {
//                             console.log('降级使用格式:', type);
//                             return type;
//                         }
//                     }
//                     return undefined; // 使用浏览器默认
//                 };
                
//                 const mimeType = getPreferredMimeType();
//                 const options = mimeType ? {
//                     mimeType: mimeType,
//                     audioBitsPerSecond: 128000  // 128kbps，适合实时传输
//                 } : {};
                
//                 try {
//                     mediaRecorder.value = new MediaRecorder(stream, options);
//                     console.log('✅ MediaRecorder创建成功，配置:', options);
//                 } catch (e) {
//                     console.error('创建MediaRecorder失败，尝试不带配置创建:', e);
//                     mediaRecorder.value = new MediaRecorder(stream);
//                     console.log('✅ MediaRecorder创建成功（无配置）');
//                 }
                
//                 // 6.3 配置实时发送音频数据
//                 mediaRecorder.value.ondataavailable = async (event) => {
//                     alert('ondataavailable触发！大小: ' + event.data.size);
//                     console.log('🔔 ondataavailable被触发！', 'data.size:', event.data.size, 'WebSocket状态:', ws.value?.readyState);
                    
//                     // 检查条件
//                     let canSend = event.data.size > 0 && ws.value && ws.value.readyState === WebSocket.OPEN;
//                     alert('canSend: ' + canSend + ', ws存在: ' + !!ws.value + ', readyState: ' + ws.value?.readyState + ', OPEN: ' + WebSocket.OPEN);
                    
//                     if (canSend) {
//                         alert('📤 准备发送音频数据，大小:', event.data.size);
                        
//                         // 将Blob转换为ArrayBuffer并发送
//                         try {
//                             const buffer = await event.data.arrayBuffer();
//                             console.log('📦 数据转换为ArrayBuffer，大小:', buffer.byteLength);
//                             ws.value.send(buffer);
//                             alert('已发送！');
//                             console.log('✅ 数据已成功发送到WebSocket');
//                         } catch (err) {
//                             alert('发送失败: ' + err.message);
//                             console.error('❌ 发送音频失败:', err);
//                         }
//                     } else {
//                         alert('条件不满足！size=' + event.data.size + ', ws=' + !!ws.value + ', state=' + ws.value?.readyState);
//                         console.warn('⚠️ 条件不满足，不发送数据:');
//                         console.log('  - event.data.size:', event.data.size);
//                         console.log('  - ws.value存在:', !!ws.value);
//                         console.log('  - WebSocket.readyState:', ws.value?.readyState);
//                         console.log('  - WebSocket.OPEN:', WebSocket.OPEN);
//                     }
//                 };
                
//                 // 6.4 启动录音（每250ms触发一次ondataavailable）
//                 mediaRecorder.value.start(250);
//                 isRecording.value = true;
//                 recordingTime.value = 0;
//                 recordingStartTime = Date.now();
                
//                 console.log('✅ 开始录音');
//                 console.log('📊 MediaRecorder状态:', mediaRecorder.value.state); // 应该是 'recording'
//                 console.log('📊 MediaRecorder.mimeType:', mediaRecorder.value.mimeType);
//                 console.log('📊 MediaRecorder.audioBitsPerSecond:', mediaRecorder.value.audioBitsPerSecond);
//                 ElMessage.success('开始录音');
                
//                 // 6.5 启动录音计时器
//                 recordingTimer = setInterval(() => {
//                     const currentTime = Math.floor((Date.now() - recordingStartTime) / 1000);
//                     if (currentTime !== recordingTime.value) {
//                         recordingTime.value = currentTime;
//                     }
//                     if (recordingTime.value >= MAX_RECORD_TIME) {
//                         newStopRecording2();
//                     }
//                 }, 1000);
                
//             } catch (error) {
//                 console.error('❌ 获取麦克风失败:', error);
//                 ElMessage.error('获取麦克风权限失败');
//                 if (ws.value) ws.value.close();
//             }
//         };
        
//         // 7. 接收识别结果
//         let lastResult = ''; // 缓存上一次的结果
//         ws.value.onmessage = (event) => {
//             const result = event.data;
//             console.log('📨 收到服务器消息:', result);
            
//             // 如果是CONNECTED消息，用弹出框显示
//             if (result && result.startsWith('CONNECTED')) {
//                 console.log('✅ 收到连接确认消息');
//                 ElMessage.success('WebSocket连接成功，开始录音...');
//             }
//             alert(result);
//             // 如果是RECEIVED消息（简化版本）
//             if (result && result.startsWith('RECEIVED')) {
//                 console.log('✅ 服务器确认收到音频数据:', result);
//             }
            
//             // 更新实时识别文本
//             if (result && !result.startsWith('CONNECTED') && !result.startsWith('ERROR') && !result.startsWith('COMPLETE') && !result.startsWith('RECEIVED')) {
//                 // ✅ 优化：避免重复追加
//                 // Azure的recognizing事件会不断发送相似的中间结果
//                 // 如果结果与上次相同或更短，说明是新的最终片段，追加新文本
//                 if (result !== lastResult) {
//                     if (lastResult && result.includes(lastResult)) {
//                         // 新结果是上一条的扩展（中间结果更新），覆盖
//                         const newPart = result.replace(lastResult, '').trim();
//                         if (newPart) {
//                             // 提取新增部分并追加
//                             realTimeRecognizedText.value += ' ' + result;
//                         }
//                     } else {
//                         // 完全不同的结果，直接追加
//                         realTimeRecognizedText.value += (realTimeRecognizedText.value ? ' ' : '') + result;
//                     }
//                     lastResult = result;
//                 }
//             }
//         };
        
//         // 8. 错误处理
//         ws.value.onerror = (error) => {
//             console.error('❌ WebSocket错误:', error);
//             ElMessage.error('WebSocket连接错误');
//         };
        
//         // 9. 连接关闭
//         ws.value.onclose = (event) => {
//             console.log('⚠️ WebSocket连接已关闭');
//             console.log('关闭代码:', event.code);
//             console.log('关闭原因:', event.reason);
//             console.log('是否正常关闭:', event.wasClean);
//         };
        
//     } catch (error) {
//         console.error('❌ 创建WebSocket失败:', error);
//         ElMessage.error('创建WebSocket失败: ' + error.message);
//     }
// };

        const previewImage = (url, images = null) => {
            if (images && Array.isArray(images) && images.length > 0) {
                imageList.value = images
                imageIndex.value = images.indexOf(url)
            } else {
                imageList.value = [url]
                imageIndex.value = 0
            }
            showImageViewer.value = true
        }



        // 处理HTML内容中的点击事件
        const handleHtmlClick = (event) => {
            const target = event.target;
            
            if (target.tagName === 'IMG') {
                event.preventDefault();
                previewImage(target.src);
            }
            // 视频点击已经通过单独的事件监听器处理
        }

        // 强制应用媒体文件样式（仅用于图片）
        const applyMediaStyles = (element) => {
            if (!element) return;
            
            if (element.tagName === 'IMG') {
                // 图片样式
                element.style.setProperty('max-width', '200px', 'important');
                element.style.setProperty('max-height', '150px', 'important');
                element.style.setProperty('width', 'auto', 'important');
                element.style.setProperty('height', 'auto', 'important');
                element.style.setProperty('border-radius', '6px', 'important');
                element.style.setProperty('margin', '6px 0', 'important');
                element.style.setProperty('display', 'block', 'important');
                element.style.setProperty('background', '#f5f5f5', 'important');
                element.style.setProperty('box-shadow', '0 1px 3px rgba(0,0,0,0.1)', 'important');
                element.style.setProperty('border', '1px solid #e0e0e0', 'important');
                element.style.setProperty('cursor', 'pointer', 'important');
                element.style.setProperty('object-fit', 'contain', 'important');
            }
            // 完全不处理视频，让浏览器按默认行为处理
        }

        // 应用样式到所有聊天消息中的媒体元素（仅用于图片）
        const applyMediaStylestoAllElements = () => {
            const botMessages = document.querySelectorAll('.message.bot');
            botMessages.forEach(message => {
                // 只处理图片，视频完全不干预
                const images = message.querySelectorAll('img');
                
                images.forEach(img => {
                    // 排除用户上传的图片和反馈图标
                    if (!img.classList.contains('message-image') && !img.classList.contains('feedback-icon')) {
                        applyMediaStyles(img);
                    }
                });
            });
        }

        const playVoice = (url) => {
            // 不再需要
        }

        const voiceBubbleStyle = (duration) => {
            // 不再需要
        }

        const handleImageButtonClick = () => {
            showRecordModal.value = false
            cleanupRecording()
            fileInputRef.value && fileInputRef.value.click();
        }

        const setAudioRef = (el, idx) => {
            if (el) audioRefs.value[idx] = el
        }

        const togglePlay = async (idx, url) => {
            // 停止其他音频
            audioRefs.value.forEach((audio, i) => {
                if (audio && i !== idx) audio.pause()
            })
            await nextTick()
            const audio = audioRefs.value[idx]
            if (!audio) return
            if (playingIndex.value === idx) {
                audio.pause()
                playingIndex.value = null
            } else {
                try {
                    await audio.play()
                    playingIndex.value = idx
                } catch (e) {
                    ElMessage.error(t('audioPlayFailed'))
                    playingIndex.value = null
                }
            }
        }

        const onAudioEnded = (idx) => {
            if (playingIndex.value === idx) playingIndex.value = null
        }
        const onAudioPlay = (idx) => {
            playingIndex.value = idx
        }
        const onAudioPause = (idx) => {
            if (playingIndex.value === idx) playingIndex.value = null
        }

        // 检查麦克风授权并弹出录音按钮
        const checkMicrophonePermission = async () => {
            if (isAiResponding.value) {
                return; // AI回答期间禁止录音
            }
            if (previewImages.value.length > 0 || isUploadingImage.value) {
                ElMessage.warning(t('imageUploadLimit'));
                return;
            }
            // 1. 检查权限状态
            if (navigator.permissions && navigator.permissions.query) {
                try {
                    const status = await navigator.permissions.query({ name: 'microphone' })
                    if (status.state === 'granted') {
                        showRecordModal.value = true
                        return
                    } else if (status.state === 'denied') {
                        ElMessage.error(t('microphonePermissionDenied'))
                        return
                    }
                    // state === 'prompt'，需要请求授权
                    ElMessageBox.confirm(t('microphoneAuthRequired'), currentLang.value === 'zh' ? '麦克风授权' : 'Microphone Authorization', {
                        confirmButtonText: currentLang.value === 'zh' ? '授权' : 'Authorize',
                        cancelButtonText: currentLang.value === 'zh' ? '取消' : 'Cancel',
                        type: 'warning',
                    }).then(async () => {
                        try {
                            await navigator.mediaDevices.getUserMedia({ audio: true })
                            showRecordModal.value = true
                        } catch (e) {
                            ElMessage.error(t('microphoneAuthFailed'))
                        }
                    }).catch(() => { })
                } catch (e) {
                    // 兼容性兜底
                    showRecordModal.value = true
                }
            } else {
                // 不支持 Permissions API，直接尝试弹窗
                showRecordModal.value = true
            }
        }

        // const switchLanguage = (lang) => {
        //     currentLang.value = lang
        //     // localStorage.setItem('preferredLanguage', lang) // 注释掉本地存储
        // }
        // const switchLanguage = (lang) => {
        //     currentLang.value = lang;
            
        //     // 从本地配置切换，立即生效
        //     const allConfigs = JSON.parse(localStorage.getItem('allIntroConfigs') || '{}');
        //     const targetConfig = allConfigs[lang];
            
        //     if (targetConfig) {
        //         introConfig.value = targetConfig;
        //         currentLanguage.value = lang;
        //         localStorage.setItem('currentLanguage', lang);
                
        //         console.log('语言切换成功:', lang, targetConfig);
        //     } else {
        //         console.error('未找到对应语言的配置:', lang);
        //     }
        // }
        // 增强现有switchLanguage函数（保持现有变量使用）
        // Chat.vue 中
        const switchLanguage = (lang) => {
            //alert('切换语言')
            //alert(lang)
            try {
                // 验证语言代码
                if (!LANGUAGE_CONFIG[lang]) {
                    console.error('不支持的语言代码:', lang);
                    return;
                }
                
                // 验证本地存储数据
                const allConfigs = JSON.parse(localStorage.getItem('allIntroConfigs') || '{}');
                if (Object.keys(allConfigs).length === 0) {
                    console.error('本地配置为空，请重新加载页面');
                    // 可以触发重新获取配置
                    return;
                }
                
                const targetConfig = allConfigs[lang];
                if (!targetConfig) {
                    console.error('配置缺失，程序逻辑错误:', {
                        lang: lang,
                        availableLanguages: Object.keys(allConfigs)
                    });
                    return;
                }
                
                // 正常切换逻辑
                currentLang.value = lang;
                introConfig.value = targetConfig;
                currentLanguage.value = lang;
                localStorage.setItem('currentLanguage', lang);
                if (targetConfig?.logo) setFavicon(targetConfig.logo);

                showLangDropdown.value = false;
                
                console.log('语言切换成功:', lang, targetConfig);
                
            } catch (error) {
                console.error('语言切换失败:', error);
            }
        }
        

        const toggleLangDropdown = () => {
            showLangDropdown.value = !showLangDropdown.value
        }

        // TTS功能弹窗
        const showTTSFeature = () => {
            ElMessageBox.alert(
                t('ttsFeatureInDevelopment'),
                t('ttsFeatureTitle'),
                {
                    confirmButtonText: currentLang.value === 'zh' ? '确定' : 'OK',
                    type: 'info'
                }
            )
        }

        // 工单提交功能弹窗
        // const showTicketFeature = () => {
        //     ElMessageBox.alert(
        //         t('ticketFeatureInDevelopment'),
        //         t('ticketFeatureTitle'),
        //         {
        //             confirmButtonText: currentLang.value === 'zh' ? '确定' : 'OK',
        //             type: 'info'
        //         }
        //     )
        // }
        // 工单提交功能弹窗
        // const showTicketFeature = () => {
        //     ElMessageBox.alert(
        //         t('ticketFeatureInDevelopment'),
        //         t('ticketFeatureTitle'),
        //         {
        //             confirmButtonText: currentLang.value === 'zh' ? '确定' : 'OK',
        //             type: 'info'
        //         }
        //     ).catch(() => {
        //         // 添加错误处理，防止关闭时报错
        //         console.log('工单提交弹窗已关闭');
        //     });
        // }
        // 设备检测函数已在 setup 开始处定义，此处删除重复定义

// 2. 修改showTicketFeature函数 - 统一使用Dialog，区分PC和移动端
const showTicketFeature = () => {
    // 如果是移动端，初始化移动端数据
    if (isMobile.value) {
        initMobileBugData();
    }
    // 统一使用Dialog弹窗（PC和移动端）
    showPCDialog.value = true;
};
//         const showTicketFeatur2e = () => {
//  // 检测设备类型
//  const deviceInfo = detectDevice();
//     const isMobile = deviceInfo.isMobile;
    
//     // 获取当前日期和时间
//     const now = new Date();
//     const currentDate = now.toISOString().split('T')[0]; // YYYY-MM-DD
//     const currentTime = now.toTimeString().split(' ')[0].substring(0, 5); // HH:MM

//     const bugFormHtml = `
//     <div style="padding: 15px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;">
//         <div style="margin-bottom: 16px;">
//             <label style="display: block; margin-bottom: 6px; font-size: 15px; font-weight: 500; color: #333;">${tb('bugDateLabel')}</label>
//             <div style="display: flex; gap: 4%;">
//                 <input type="date" id="bugDate" value="${currentDate}" style="width: 48%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 6px; font-size: 14px; background-color: #f8f9fa;" />
//                 <input type="time" id="bugTime" value="${currentTime}"style="width: 48%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 6px; font-size: 14px; background-color: #f8f9fa;" />
//             </div>
//         </div>
       
//         <div style="margin-bottom: 16px;">
//             <label style="display: block; margin-bottom: 6px; font-size: 15px; font-weight: 500; color: #333;">${tb('bugScreenshotLabel')}</label>
//             <input type="file" id="bugScreenshot" accept="image/*" style="width: 100%; padding: 10px; border: 1px dashed #dcdfe6; border-radius: 6px; background-color: #f8f9fa; font-size: 14px;" />
            
//         </div>
        
//         <div style="margin-bottom: 12px;">
//             <label style="display: block; margin-bottom: 6px; font-size: 15px; font-weight: 500; color: #333;">${tb('bugDescriptionLabel')}</label>
//             <textarea id="bugReporter" placeholder="${tb('bugDescriptionPlaceholderMobile')}" style="width: 100%; padding: 10px; border: 1px solid #dcdfe6; border-radius: 6px; min-height: 80px; resize: vertical; font-size: 14px; background-color: #f8f9fa;"></textarea>
//         </div>
//     </div>
// `;

// 其余代码保持不变...
// 旧的移动端ElMessageBox代码已注释，现在统一使用el-dialog
//     ElMessageBox({
//         title: tb('bugDialogTitle'),
//         message: bugFormHtml,
//         dangerouslyUseHTMLString: true,
//         showCancelButton: true,
//         confirmButtonText: tb('bugSubmitButton'),
//         cancelButtonText: tb('bugCancelButton'),
//         customClass: 'bug-submit-dialog',
//         beforeClose: async (action, instance, done) => {
//             if (action === 'confirm') {
//                 // 获取表单数据
//                 const date = document.getElementById('bugDate').value;
//                 const time = document.getElementById('bugTime').value;
//                 const reporter = document.getElementById('bugReporter').value;
//                 const screenshot = document.getElementById('bugScreenshot').files[0];
//                 
//                 // 验证必填字段
//                 // if (!date || !time || !reporter) {
//                 //     ElMessage.error('请填写完整信息');
//                 //     return;
//                 // }
//                 
//                 // 显示加载状态
//                 instance.confirmButtonLoading = true;
//                 
//                 try {
//                     // 提交BUG报告
//                     await submitBugReport({
//                         date: date,
//                         time: time,
//                         reporter: reporter,
//                         screenshot: screenshot
//                     });
//                     done();
//                 } catch (error) {
//                     instance.confirmButtonLoading = false;
//                 }
//             } else {
//                 done();
//             }
//         }
//     }).then(() => {
//                     // 弹窗关闭后，添加图片选择事件监听
//         setTimeout(() => {
//             const fileInput = document.getElementById('bugScreenshot');
//             if (fileInput) {
//                 fileInput.addEventListener('change', handleBugImageUpload);
//             }
//         }, 100);
//     }).catch(() => {
//         console.log('BUG提交弹窗已关闭');
//     });
// }
// 处理BUG提交中的图片上传
const handleBugImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    try {
        // 直接上传图片
        const url = await uploadFileToServer(file);
        
        if (url) {
            // 保存URL到文件输入的dataset中
            event.target.dataset.uploadedUrl = url;
            ElMessage.success(tb('bugUploadSuccess'));
        }
    } catch (error) {
        console.error('图片上传失败:', error);
        ElMessage.error('图片上传失败');
    }
};
// 提交BUG报告函数
const submitBugReport = async (bugData) => {
    try {
        let screenshotUrl = null;
        
        // 如果有截图，先上传截图
        if (bugData.screenshot) {
            screenshotUrl = await uploadFileToServer(bugData.screenshot);
        }
        
        // 提交BUG报告数据
        const response = await request({
            url: '/bug-report',
            method: 'post',
            data: {
                date: bugData.date,
                time: bugData.time,
                reporter: bugData.reporter,
                description: bugData.reporter,
                screenshotUrl: screenshotUrl
            }
        });
        
        if (response.code === 200) {
            ElMessage.success(tb('bugSubmitSuccess'));
        } else {
            ElMessage.error(tb('bugSubmitFailed'));
        }
    } catch (error) {
        console.error('提交BUG报告失败:', error);
        ElMessage.error(tb('bugSubmitFailed'));
        throw error;
    }
};

        // 点击外部关闭下拉
        const handleClickOutside = (e) => {
            const menu = document.querySelector('.language-dropdown-wrapper')
            if (menu && !menu.contains(e.target)) {
                showLangDropdown.value = false
            }
        }

        // 加载历史消息
        const loadHistoryMessages = (historyMessages) => {
            console.log('开始加载历史消息:', historyMessages)
            historyMessages.forEach(msg => {
                if (msg && msg.type) {
                    console.log('添加历史消息:', msg)
                    messages.value.push(msg)
                }
            })
            // 滚动到底部显示最新消息
            nextTick(() => {
                scrollToBottom()
            })
        }

        // 反馈处理（简单反馈）
        const handleFeedback = async (index, type) => {

            const message = messages.value[index];
            // alert(index);
            // alert(JSON.stringify(message));

            // 验证 userMessageId 是否存在
            if (!message.userMessageId) {
                console.error('消息缺少userMessageId:', message);
                ElMessage.error('消息ID缺失，无法提交反馈');
                return;
            }
    

            console.log('点击反馈前:', { index, type, currentFeedback: message.feedback });
            console.log('消息对象:', message);
            console.log('DOM元素类名:', document.querySelectorAll('.feedback-btn')[index]?.className);
            
            // 转换反馈类型为数字：1=😊（like），2=😢（dislike）
            const feedbackValue = type === 'like' ? 1 : 2;
            
            // 如果点击相同的反馈，则取消（设为0）
            if (message.feedback === type) {
                message.feedback = null;
                message.feedbackValue = 0;
                console.log('取消反馈:', { feedback: null, feedbackValue: 0 });
            } else {
                // 点击不同的反馈，直接设置新状态
                message.feedback = type;
                message.feedbackValue = feedbackValue;
                console.log('设置反馈:', { feedback: type, feedbackValue });
            }
            
            console.log('点击反馈后:', { feedback: message.feedback, feedbackValue: message.feedbackValue });
            
            // 发送反馈到后端更新（延迟2秒）
            try {
                // 延迟2秒后发送请求
                //await new Promise(resolve => setTimeout(resolve, 2000));
                
                const response = await request.post('/feedback/suggest', {
                    userMessageId: message.userMessageId,  // 用户消息ID
                    feedback: message.feedbackValue,       // 1=😊, 2=😢
                    language: getLanguageCode()            // 语言代码 0-9
                });
                console.log(response);
                
                // 检查会话失效
                if (response && response.type === 'system' && response.action === 'refresh-required') {
                    console.log('反馈请求：会话失效，需要刷新:', response.message);
                    
                    // 创建系统消息对象，显示刷新按钮
                    const systemMsg = {
                        type: 'system',
                        action: 'refresh-required',
                        text: response.message || (currentLang.value === 'zh' ? '会话检测失败请刷新' : 'Session validation failed, please refresh'),
                        isUser: false
                    };
                    
                    // 添加到消息列表
                    messages.value.push(systemMsg);
                    
                    // 滚动到底部
                    await nextTick();
                    forceScrollToBottom();
                    return;
                }
                
                // 后端返回成功后才显示提示
                if (response && response.success) {
                    // 根据反馈类型显示不同的提示信息
                    if (message.feedbackValue === 1) {
                        // 笑脸 - 显示"谢谢你的评价"
                        ElMessage.success(t('feedbackLikeMessage'));
                    } else if (message.feedbackValue === 2) {
                        // 哭脸 - 显示"我们会改进服务"
                        //ElMessage.success(t('feedbackDislikeMessage'));
                        // 先关闭所有其他弹窗，确保只显示一个弹窗
                        closeAllDislikePopups();
                        // 显示点踩评价弹窗
                        message.showDislikePopup = true;
                        // 初始化字段
                        message.dislikeOptions = 0;
                        message.dislikeReason = '';
                    }
                    // 取消反馈时（feedbackValue === 0）不显示提示
                } else {
                    ElMessage.error(response?.message || '反馈提交失败');  // 显示后端返回的错误消息
                }
            } catch (e) {
                console.log('发送反馈请求:', {
                    userMessageId: message.userMessageId,
                    feedback: message.feedbackValue
                });
                console.error('反馈提交失败:', e);
                ElMessage.error('网络错误，请稍后重试');  // 网络错误使用前端固定提示
            }
        };
        
        // 关闭所有点踩弹窗
        const closeAllDislikePopups = () => {
            messages.value.forEach(msg => {
                if (msg.showDislikePopup) {
                    msg.showDislikePopup = false;
                }
            });
        }
        
        // 提交点踩反馈
        const submitDislikeFeedback = async (index, message) => {
            const selectedOption = Number(message.dislikeOptions) || 0
            const reasonText = (message.dislikeReason || '').trim()

            if (selectedOption === 0 && !reasonText) {
                ElMessage.warning(t('dislikeValidationMessage'))
                return
            }

            const payload = {
                userMessageId: message.userMessageId ? String(message.userMessageId) : '',
                dislikeOptions: selectedOption > 0 ? selectedOption : null,
                dislikeReason: reasonText,
                language: getLanguageCode()
            }

            try {
                const res = await request.post('/feedback/dislike-detail', payload)
                if (res && res.success) {
                    message.dislikeOptions = selectedOption
                    message.dislikeReason = reasonText
                    message.showDislikePopup = false
                    ElMessage.success(res.message || t('feedbackDislikeMessage'))
                    
                    // 如果选择了"联系我们"（选项3），自动发送消息
                    if (selectedOption === 3) {
                        // 检测浏览器第一语言
                        const browserLang = navigator.language || navigator.browserLanguage || 'en'
                        const isChinese = browserLang.toLowerCase().startsWith('zh')
                        const contactMessage = isChinese ? '你们的联系方式' : 'What are your contact details?'
                        
                        // 创建用户消息
                        const userMsg = {
                            type: 'text',
                            text: contactMessage,
                            isUser: true
                        }
                        messages.value.push(userMsg)
                        
                        // 滚动到底部并发送消息
                        await scrollToBottom()
                        await streamAIReply({ type: 'text', text: contactMessage })
                    }

                   //以上是联系我们的代码     


                } else {
                    ElMessage.error(res?.message || '提交失败，请稍后重试')
                }
            } catch (error) {
                console.error('提交点踩反馈失败:', error)
                ElMessage.error('提交失败，请稍后重试')
            }
        }

        // 停止HTTP方式的TTS播放（用于handlePlayTTS）
        const stopTTSPlaybackForHTTP = (index) => {
            const message = messages.value[index];
            if (!message) return;

            // 标记为用户主动关闭（避免显示错误提示）
            message.ttsUserCancelled = true;

            // 1. 停止音频播放
            if (message.ttsAudio) {
                try {
                    // 先移除事件处理器，避免触发 onerror
                    message.ttsAudio.onerror = null;
                    message.ttsAudio.onended = null;
                    message.ttsAudio.pause();
                    message.ttsAudio.src = '';
                } catch (e) {
                    console.error('停止音频播放失败:', e);
                }
                message.ttsAudio = null;
            }

            // 2. 取消HTTP请求
            if (message.ttsCancelTokenSource) {
                try {
                    message.ttsCancelTokenSource.cancel('用户取消TTS请求');
                } catch (e) {
                    console.error('取消TTS请求失败:', e);
                }
                message.ttsCancelTokenSource = null;
            }

            // 3. 清理状态
            message.isPlayingTTS = false;
            message.ttsUserCancelled = false; // 重置标志
        };

        // 停止所有正在播放的TTS（用于页面隐藏时）
        const stopAllTTSPlayback = () => {
            messages.value.forEach((msg, index) => {
                if (msg.isPlayingTTS) {
                    // 判断是HTTP方式、WebSocket流式方式还是分片方式
                    // 注意：判断顺序很重要，先判断 ttsAudioQueue（handlePlayTTS3），因为 handlePlayTTS3 也会设置 ttsWebSocket
                    if (msg.ttsAudioQueue) {
                        // handlePlayTTS3 方式（Web Audio API 分片播放）
                        stopTTSPlaybackForChunked(index);
                    } else if (msg.ttsWebSocket && msg.ttsMediaSource) {
                        // handlePlayTTS2 方式（MediaSource 流式播放）
                        stopTTSPlayback(index);
                    } else if (msg.ttsCancelTokenSource || (msg.ttsAudio && !msg.ttsWebSocket)) {
                        // handlePlayTTS 方式（HTTP 完整音频播放）
                        stopTTSPlaybackForHTTP(index);
                    }
                }
            });
        };

        // TTS播放处理 - 通过userMessageId获取TTS音频URL
        const handlePlayTTS = async (index, userMessageId) => {
            const message = messages.value[index];
            
            // 如果正在播放或正在请求，则停止
            if (message.isPlayingTTS) {
                stopTTSPlaybackForHTTP(index);
                return;
            }

            // 停止所有其他正在播放的HTTP方式TTS（确保同时只有一个TTS在播放）
            messages.value.forEach((msg, idx) => {
                if (idx !== index && msg.isPlayingTTS) {
                    // 只停止HTTP方式的TTS（有ttsCancelTokenSource或ttsAudio，且没有ttsWebSocket）
                    if ((msg.ttsCancelTokenSource || msg.ttsAudio) && !msg.ttsWebSocket) {
                        stopTTSPlaybackForHTTP(idx);
                    }
                }
            });

            // 验证userMessageId是否存在
            if (!userMessageId) {
                
                ElMessage.error(t('ttsRequestFailed'));
                console.error('userMessageId不存在，无法生成TTS');
                return;
            }
            
            // 内部方法：请求URL并播放，播放失败自动重试（最多2次）
            const requestAndPlay = async (retryCount = 0) => {
                // 若已被用户中断
                if (!message.isPlayingTTS) return;

                const cancelTokenSource = axios.CancelToken.source();
                message.ttsCancelTokenSource = cancelTokenSource;

                try {
                    const response = await request.post('/tts/by-message-id', {
                        userMessageId: userMessageId,
                        language: getBrowserLanguageCodeFromStorage()
                    }, {
                        cancelToken: cancelTokenSource.token
                    });

                    message.ttsCancelTokenSource = null;

                    if (cancelTokenSource.reason) {
                        message.isPlayingTTS = false;
                        return;
                    }

                    if (response && response.audioUrl) {
                        const audio = new Audio(response.audioUrl);
                        message.ttsAudio = audio;

                        audio.onended = () => {
                            message.isPlayingTTS = false;
                            message.ttsAudio = null;
                        };
                        audio.onerror = async () => {
                            // 如果是用户主动关闭，不显示错误提示
                            if (message.ttsUserCancelled) {
                                message.ttsAudio = null;
                                message.isPlayingTTS = false;
                                return;
                            }
                            console.error('音频播放失败（onerror）');
                            message.ttsAudio = null;
                            message.isPlayingTTS = false;
                            //ElMessage.error(t('ttsRequestFailed'));
                        };

                        try {
                            await audio.play();
                        } catch (e) {
                            // 如果是用户主动关闭，不显示错误提示
                            if (message.ttsUserCancelled) {
                                message.ttsAudio = null;
                                message.isPlayingTTS = false;
                                return;
                            }
                            console.error('播放失败（play.catch）:', e);
                            message.ttsAudio = null;
                            message.isPlayingTTS = false;
                            //ElMessage.error(t('ttsRequestFailed'));
                        }
                    } else {
                        message.isPlayingTTS = false;
                        //ElMessage.error(t('ttsRequestFailed'));
                    }
                } catch (e) {
                    if (axios.isCancel(e) || e.code === 'ERR_CANCELED') {
                        console.log('TTS请求已被用户取消');
                        message.isPlayingTTS = false;
                        message.ttsCancelTokenSource = null;
                        return;
                    }
                    console.error('TTS请求失败:', e);
                    message.ttsCancelTokenSource = null;
                    message.isPlayingTTS = false;
                    //ElMessage.error(t('ttsRequestFailed'));
                }
            };

            try {
                // 设置播放状态，图标切换为kai.png
                message.isPlayingTTS = true;
                message.ttsUserCancelled = false; // 重置标志
                await requestAndPlay(0);
            } catch (e) {
                // 如果是用户主动关闭或请求被取消，不显示错误提示
                if (message.ttsUserCancelled || axios.isCancel(e) || e.code === 'ERR_CANCELED') {
                    message.isPlayingTTS = false;
                    message.ttsCancelTokenSource = null;
                    return;
                }
                console.error('TTS流程异常:', e);
                ElMessage.error(t('ttsRequestFailed'));
                message.isPlayingTTS = false;
                message.ttsCancelTokenSource = null;
            }
        };

        // TTS播放处理 - 通过WebSocket实时流式播放
        const handlePlayTTS2 = (index, userMessageId) => {
            const message = messages.value[index];
            
            // 如果正在播放，则停止
            if (message.isPlayingTTS) {
                stopTTSPlayback(index);
                return;
            }

            // 停止所有其他正在播放的TTS（确保同时只有一个TTS在播放）
            messages.value.forEach((msg, idx) => {
                if (idx !== index && msg.isPlayingTTS) {
                    stopTTSPlayback(idx);
                }
            });

            // 验证userMessageId是否存在
            if (!userMessageId) {
                ElMessage.error(t('ttsRequestFailed'));
                console.error('userMessageId不存在，无法生成TTS');
                return;
            }

            // 构建WebSocket URL
            const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
            const host = window.location.host; // 包含端口号
            const wsUrl = `${protocol}//${host}/api/ws/tts-traditional?userMessageId=${userMessageId}`;

            // 初始化状态
            message.isPlayingTTS = true;
            message.ttsQueue = [];
            message.ttsEnded = false;
            message.ttsAudio = null;
            message.ttsMediaSource = null;
            message.ttsSourceBuffer = null;
            message.ttsUserCancelled = false; // 用户主动取消标志

            // 兼容性处理：iOS 17+ 需要使用 ManagedMediaSource，其他浏览器使用 MediaSource
            const MediaSourceClass = window.ManagedMediaSource || window.MediaSource;
            if (!MediaSourceClass) {
                ElMessage.error(t('ttsRequestFailed'));
                message.isPlayingTTS = false;
                return;
            }
            
            // 创建MediaSource
            const ms = new MediaSourceClass();
            message.ttsMediaSource = ms;
            
            // 创建Audio元素
            const audio = new Audio();
            message.ttsAudio = audio;
            audio.src = URL.createObjectURL(ms);

            // MediaSource打开事件
            ms.addEventListener('sourceopen', () => {
                try {
                    // 添加SourceBuffer，格式为 audio/mpeg (对应后端的 Audio16Khz32KBitRateMonoMp3)
                    const sb = ms.addSourceBuffer('audio/mpeg');
                    //alert(sb)
                    message.ttsSourceBuffer = sb;

                    // SourceBuffer更新完成事件
                    sb.addEventListener('updateend', () => {
                        flushQueue(index);
                    });

                    // 连接WebSocket
                    const ws = new WebSocket(wsUrl);
                    message.ttsWebSocket = ws;
                    ws.binaryType = 'arraybuffer';

                    // WebSocket消息接收
                    ws.onmessage = (e) => {
                        if (e.data instanceof ArrayBuffer) {
                            message.ttsQueue.push(new Uint8Array(e.data));
                            flushQueue(index);
                        }
                    };

                    // WebSocket关闭事件
                    ws.onclose = (event) => {
                        message.ttsEnded = true;
                        // 如果是用户主动关闭，不显示错误
                        if (message.ttsUserCancelled) {
                            message.ttsUserCancelled = false; // 重置标志
                        }
                        if (message.ttsSourceBuffer && !message.ttsSourceBuffer.updating && message.ttsQueue.length === 0) {
                            safeEndMediaSource(index);
                        }
                    };

                    // WebSocket错误事件
                    ws.onerror = (err) => {
                        console.error('WebSocket错误:', err);
                        // 如果是用户主动关闭，不显示错误提示
                        if (!message.ttsUserCancelled) {
                            ElMessage.error(t('ttsRequestFailed'));
                        }
                        try {
                            ws.close();
                        } catch (e) {
                            console.error('关闭WebSocket失败:', e);
                        }
                        // 清理状态
                        message.isPlayingTTS = false;
                        message.ttsWebSocket = null;
                        message.ttsMediaSource = null;
                        message.ttsSourceBuffer = null;
                        message.ttsAudio = null;
                        message.ttsQueue = [];
                        message.ttsUserCancelled = false; // 重置标志
                    };

                    // 尝试播放音频（需要用户手势触发）
                    audio.play().catch((e) => {
                        console.warn('自动播放被阻止，需要用户交互:', e);
                        // 如果自动播放失败，用户需要手动点击播放按钮
                    });

                } catch (e) {
                    console.error('MediaSource初始化失败:', e);
                    ElMessage.error(t('ttsRequestFailed'));
                    message.isPlayingTTS = false;
                    message.ttsMediaSource = null;
                    message.ttsAudio = null;
                }
            });

            // MediaSource错误事件
            ms.addEventListener('error', (e) => {
                console.error('MediaSource错误:', e);
                // 如果是用户主动关闭，不显示错误提示
                if (!message.ttsUserCancelled) {
                    ElMessage.error(t('ttsRequestFailed'));
                }
                message.isPlayingTTS = false;
            });

            // 音频播放结束事件
            audio.onended = () => {
                message.isPlayingTTS = false;
                // 清理资源
                if (message.ttsWebSocket) {
                    try {
                        message.ttsWebSocket.close();
                    } catch (e) {}
                }
                message.ttsWebSocket = null;
                message.ttsMediaSource = null;
                message.ttsSourceBuffer = null;
                message.ttsAudio = null;
                message.ttsQueue = [];
            };

            // 音频播放错误事件
            audio.onerror = (e) => {
                console.error('音频播放错误:', e);
                // 如果是用户主动关闭，不显示错误提示
                if (!message.ttsUserCancelled) {
                    ElMessage.error(t('ttsRequestFailed'));
                }
                message.isPlayingTTS = false;
                // 清理资源
                if (message.ttsWebSocket) {
                    try {
                        message.ttsWebSocket.close();
                    } catch (e) {}
                }
                message.ttsWebSocket = null;
                message.ttsMediaSource = null;
                message.ttsSourceBuffer = null;
                message.ttsAudio = null;
                message.ttsQueue = [];
            };
        };

        // 刷新队列：将队列中的数据添加到SourceBuffer
        const flushQueue = (index) => {
            const message = messages.value[index];
            if (!message || !message.ttsSourceBuffer || message.ttsSourceBuffer.updating || message.ttsQueue.length === 0) {
                return;
            }

            const chunk = message.ttsQueue.shift();
            try {
                message.ttsSourceBuffer.appendBuffer(chunk);
            } catch (e) {
                console.error('appendBuffer错误:', e);
                // 如果发生 QUOTA_EXCEEDED_ERR，可以适当处理
                if (e.name === 'QuotaExceededError') {
                    console.warn('SourceBuffer配额超出，跳过当前数据块');
                } else {
                    // 其他错误，重新加入队列或丢弃
                    console.error('无法添加数据到SourceBuffer:', e);
                }
            }
        };

        // 停止TTS播放（统一清理函数）
        const stopTTSPlayback = (index) => {
            const message = messages.value[index];
            if (!message) return;

            // 1. 标记为用户主动关闭（避免显示错误提示）
            message.ttsUserCancelled = true;

            // 2. 关闭WebSocket连接（后端会自动停止TTS合成）
            if (message.ttsWebSocket) {
                try {
                    // 直接关闭连接，不需要发送消息
                    // 后端 @OnClose 会自动处理停止逻辑
                    if (message.ttsWebSocket.readyState === WebSocket.OPEN || 
                        message.ttsWebSocket.readyState === WebSocket.CONNECTING) {
                        message.ttsWebSocket.close();
                    }
                } catch (e) {
                    console.error('关闭WebSocket失败:', e);
                }
                message.ttsWebSocket = null;
            }

            // 2. 停止音频播放
            if (message.ttsAudio) {
                try {
                    message.ttsAudio.pause();
                    message.ttsAudio.src = '';
                } catch (e) {
                    console.error('停止音频播放失败:', e);
                }
                message.ttsAudio = null;
            }

            // 3. 结束MediaSource
            if (message.ttsMediaSource) {
                try {
                    if (message.ttsMediaSource.readyState === 'open') {
                        if (message.ttsSourceBuffer && !message.ttsSourceBuffer.updating) {
                            message.ttsMediaSource.endOfStream();
                        }
                    }
                } catch (e) {
                    console.error('结束MediaSource失败:', e);
                }
                message.ttsMediaSource = null;
            }

            // 4. 清理所有状态
            message.isPlayingTTS = false;
            message.ttsSourceBuffer = null;
            message.ttsQueue = [];
            message.ttsEnded = false;
        };

        // 安全结束MediaSource（用于正常播放完成）
        const safeEndMediaSource = (index) => {
            const message = messages.value[index];
            if (!message || !message.ttsMediaSource) {
                return;
            }

            try {
                if (message.ttsMediaSource.readyState === 'open') {
                    message.ttsMediaSource.endOfStream();
                }
            } catch (e) {
                console.error('结束MediaSource失败:', e);
            }

            // 清理状态
            message.isPlayingTTS = false;
            message.ttsWebSocket = null;
            message.ttsMediaSource = null;
            message.ttsSourceBuffer = null;
            message.ttsQueue = [];
        };

        // TTS播放处理 - 使用 Web Audio API（兼容所有移动端浏览器）
        const handlePlayTTS3 = async (index, userMessageId) => {
            const message = messages.value[index];
            
            // 如果正在播放，则停止
            if (message.isPlayingTTS) {
                stopTTSPlaybackForChunked(index);
                return;
            }

            // 停止所有其他正在播放的TTS（确保同时只有一个TTS在播放）
            messages.value.forEach((msg, idx) => {
                if (idx !== index && msg.isPlayingTTS) {
                    // 停止其他方式的TTS
                    // 注意：判断顺序很重要，先判断 ttsAudioQueue（handlePlayTTS3），因为 handlePlayTTS3 也会设置 ttsWebSocket
                    if (msg.ttsAudioQueue) {
                        // handlePlayTTS3 方式（Web Audio API 分片播放）
                        stopTTSPlaybackForChunked(idx);
                    } else if (msg.ttsWebSocket && msg.ttsMediaSource) {
                        // handlePlayTTS2 方式（MediaSource 流式播放）
                        stopTTSPlayback(idx);
                    } else if (msg.ttsCancelTokenSource || (msg.ttsAudio && !msg.ttsWebSocket)) {
                        // handlePlayTTS 方式（HTTP 完整音频播放）
                        stopTTSPlaybackForHTTP(idx);
                    }
                }
            });

            // 验证userMessageId是否存在
            if (!userMessageId) {
                ElMessage.error(t('ttsRequestFailed'));
                console.error('userMessageId不存在，无法生成TTS');
                return;
            }

            // 检查 Web Audio API 支持
            const AudioContextClass = window.AudioContext || window.webkitAudioContext;
            if (!AudioContextClass) {
                ElMessage.error('您的浏览器不支持 Web Audio API');
                console.error('Web Audio API 不支持');
                return;
            }

            // 构建WebSocket URL
            const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
            const host = window.location.host;
            const wsUrl = `${protocol}//${host}/api/ws/tts-chunked?userMessageId=${userMessageId}`;
            
            // 初始化状态
            message.isPlayingTTS = true;
            message.ttsAudioQueue = []; // 音频Buffer队列（存储ArrayBuffer）
            message.ttsWebSocket = null;
            message.ttsAudioContext = null; // Web Audio API 的 AudioContext
            message.ttsCurrentSource = null; // 当前播放的 AudioBufferSourceNode
            message.ttsIsPlaying = false; // 是否正在播放
            message.ttsUserCancelled = false;

            // 关键：在用户交互上下文中创建 AudioContext
            // Web Audio API 不需要像 HTML5 Audio 那样解锁，但 AudioContext 必须在用户交互中创建
            try {
                // 创建 AudioContext（必须在用户交互上下文中）
                const audioContext = new AudioContextClass();
                message.ttsAudioContext = audioContext;
                
                // 如果 AudioContext 处于 suspended 状态，需要 resume（某些浏览器需要）
                if (audioContext.state === 'suspended') {
                    audioContext.resume().then(() => {
                        console.log('[TTS3] AudioContext已恢复, state:', audioContext.state);
                    }).catch((e) => {
                        console.error('[TTS3] AudioContext恢复失败:', e);
                    });
                }
                
                // 连接 WebSocket
                connectWebSocket();
                
            } catch (error) {
                console.error('[TTS3] 创建AudioContext失败:', error);
                ElMessage.error('音频播放初始化失败');
                message.isPlayingTTS = false;
                return;
            }
            
            // 连接 WebSocket 的函数
            function connectWebSocket() {
                // 检查是否已经连接过（防止重复连接）
                if (message.ttsWebSocket && (message.ttsWebSocket.readyState === WebSocket.CONNECTING || message.ttsWebSocket.readyState === WebSocket.OPEN)) {
                    return;
                }
                
                // 连接WebSocket
                const ws = new WebSocket(wsUrl);
                message.ttsWebSocket = ws;
                ws.binaryType = 'arraybuffer'; // 使用 arraybuffer，方便 Web Audio API 解码

                // WebSocket连接成功
                ws.onopen = () => {
                    console.log('[TTS3] WebSocket连接成功，AudioContext已准备好:', !!message.ttsAudioContext);
                };
                
                // WebSocket连接错误
                ws.onerror = (error) => {
                    console.error('[TTS3] WebSocket连接错误:', error);
                };

                // WebSocket消息接收
                ws.onmessage = async (e) => {
                    let arrayBuffer;
                    
                    if (e.data instanceof ArrayBuffer) {
                        arrayBuffer = e.data;
                    } else if (e.data instanceof Blob) {
                        // 如果收到的是 Blob，转换为 ArrayBuffer
                        arrayBuffer = await e.data.arrayBuffer();
                    } else {
                        console.warn(`[TTS3] 收到非ArrayBuffer/Blob类型数据: ${typeof e.data}`);
                        return;
                    }
                    
                    // 将 ArrayBuffer 添加到队列
                    message.ttsAudioQueue.push(arrayBuffer);
                    console.log(`[TTS3] 收到音频块, 队列长度: ${message.ttsAudioQueue.length}, 大小: ${arrayBuffer.byteLength} bytes`);
                    
                    // 如果当前没有播放，开始播放
                    if (!message.ttsIsPlaying) {
                        console.log(`[TTS3] 开始播放第一个音频块`);
                        playNextChunk(index);
                    } else {
                        console.log(`[TTS3] 音频块已加入队列，等待当前播放完成`);
                    }
                };

                // WebSocket关闭事件
                ws.onclose = (event) => {
                    console.log(`[TTS3] WebSocket关闭, 队列长度: ${message.ttsAudioQueue.length}, 是否正在播放: ${message.ttsIsPlaying}, 关闭码: ${event.code}, 原因: ${event.reason}`);
                    message.ttsWebSocket = null;
                    
                    // 如果队列为空且没有正在播放，清理状态
                    if (message.ttsAudioQueue.length === 0 && !message.ttsIsPlaying) {
                        console.log(`[TTS3] 队列为空且未播放，清理状态`);
                        message.isPlayingTTS = false;
                    } else {
                        console.log(`[TTS3] WebSocket关闭但仍有待播放内容，队列: ${message.ttsAudioQueue.length}, 播放中: ${message.ttsIsPlaying}`);
                    }
                };
            } // connectWebSocket 函数结束
        };

        // 播放下一个音频片段（使用 Web Audio API）
        const playNextChunk = async (index) => {
            const message = messages.value[index];
            console.log(`[TTS3] playNextChunk 被调用, index: ${index}, 队列长度: ${message?.ttsAudioQueue?.length || 0}, isPlayingTTS: ${message?.isPlayingTTS}, ttsIsPlaying: ${message?.ttsIsPlaying}, AudioContext存在: ${!!message?.ttsAudioContext}`);
            
            if (!message || !message.isPlayingTTS) {
                console.log(`[TTS3] playNextChunk 提前返回: message不存在或未在播放状态`);
                return;
            }

            // 如果已经在播放，直接返回（防止并发调用）
            if (message.ttsIsPlaying && message.ttsCurrentSource) {
                console.log(`[TTS3] 已有音频正在播放，跳过此次调用`);
                return;
            }

            // 如果队列为空，检查 WebSocket 状态
            if (message.ttsAudioQueue.length === 0) {
                console.log(`[TTS3] 队列为空，检查WebSocket状态`);
                
                // 如果 WebSocket 还在连接中或已打开，等待数据到达（不立即停止）
                if (message.ttsWebSocket && (message.ttsWebSocket.readyState === WebSocket.CONNECTING || message.ttsWebSocket.readyState === WebSocket.OPEN)) {
                    console.log(`[TTS3] 队列为空但WebSocket还在连接中，等待数据到达...`);
                    message.ttsIsPlaying = false; // 重置播放状态，等待新数据
                    return;
                }
                
                // 如果 WebSocket 已关闭或不存在，才真正停止播放
                console.log(`[TTS3] 队列为空且WebSocket已关闭，停止播放`);
                message.ttsIsPlaying = false;
                message.isPlayingTTS = false;
                return;
            }

            // 确保 AudioContext 存在
            if (!message.ttsAudioContext) {
                console.log(`[TTS3] AudioContext还未创建，等待...`);
                // 延迟重试（最多重试10次，即1秒）
                if (!message.ttsRetryCount) {
                    message.ttsRetryCount = 0;
                }
                message.ttsRetryCount++;
                if (message.ttsRetryCount < 10) {
                    setTimeout(() => playNextChunk(index), 100);
                } else {
                    console.warn(`[TTS3] AudioContext等待超时，停止播放`);
                    message.isPlayingTTS = false;
                    message.ttsRetryCount = 0;
                }
                return;
            }
            
            // 重置重试计数
            if (message.ttsRetryCount) {
                message.ttsRetryCount = 0;
            }

            // 设置播放状态，防止并发调用
            message.ttsIsPlaying = true;
            const arrayBuffer = message.ttsAudioQueue.shift(); // 取出第一个 ArrayBuffer
            console.log(`[TTS3] 准备播放音频块，剩余队列长度: ${message.ttsAudioQueue.length}, 大小: ${arrayBuffer.byteLength} bytes`);

            const audioContext = message.ttsAudioContext;
            
            // 确保 AudioContext 处于 running 状态
            if (audioContext.state === 'suspended') {
                try {
                    await audioContext.resume();
                    console.log('[TTS3] AudioContext已恢复, state:', audioContext.state);
                } catch (e) {
                    console.error('[TTS3] AudioContext恢复失败:', e);
                    message.ttsIsPlaying = false;
                    if (!message.ttsUserCancelled) {
                        playNextChunk(index); // 继续尝试下一个
                    }
                    return;
                }
            }

            try {
                // 解码音频数据
                const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
                console.log(`[TTS3] 音频解码成功, 时长: ${audioBuffer.duration}秒, 采样率: ${audioBuffer.sampleRate}Hz`);
                
                // 停止当前播放的源（如果有）
                if (message.ttsCurrentSource) {
                    try {
                        message.ttsCurrentSource.stop();
                    } catch (e) {
                        // 忽略已经停止的错误
                    }
                    message.ttsCurrentSource = null;
                }
                
                // 创建新的 AudioBufferSourceNode
                const source = audioContext.createBufferSource();
                source.buffer = audioBuffer;
                source.connect(audioContext.destination);
                message.ttsCurrentSource = source;
                
                // 播放结束事件
                source.onended = () => {
                    console.log(`[TTS3] ✅ 音频块播放完成，队列剩余: ${message.ttsAudioQueue.length}`);
                    message.ttsIsPlaying = false;
                    message.ttsCurrentSource = null;
                    
                    // 继续播放下一个
                    if (!message.ttsUserCancelled) {
                        playNextChunk(index);
                    }
                };
                
                // 开始播放
                source.start(0);
                console.log(`[TTS3] ✅ 开始播放音频片段（Web Audio API），队列剩余: ${message.ttsAudioQueue.length}`);
                
            } catch (error) {
                console.error(`[TTS3] 播放失败:`, error);
                message.ttsIsPlaying = false;
                message.ttsCurrentSource = null;
                
                // 如果是用户主动关闭，不显示错误提示
                if (message.ttsUserCancelled) {
                    return;
                }
                
                // 如果是解码错误，可能是音频格式不支持
                if (error.name === 'EncodingError' || error.message.includes('decode')) {
                    ElMessage.warning('音频格式不支持，请检查音频文件');
                    message.isPlayingTTS = false;
                    return;
                }
                
                // 其他错误，继续尝试下一个
                playNextChunk(index);
            }
        };

        // 停止分片播放方式的TTS（Web Audio API）
        const stopTTSPlaybackForChunked = (index) => {
            const message = messages.value[index];
            if (!message) return;

            console.log(`[TTS3] 停止播放, 队列长度: ${message.ttsAudioQueue ? message.ttsAudioQueue.length : 0}`);

            // 标记为用户主动关闭
            message.ttsUserCancelled = true;

            // 停止当前播放的 AudioBufferSourceNode
            if (message.ttsCurrentSource) {
                try {
                    message.ttsCurrentSource.stop();
                } catch (e) {
                    // 忽略已经停止的错误
                    console.warn('停止AudioBufferSourceNode失败:', e);
                }
                message.ttsCurrentSource = null;
            }

            // 关闭WebSocket连接
            if (message.ttsWebSocket) {
                try {
                    if (message.ttsWebSocket.readyState === WebSocket.OPEN || 
                        message.ttsWebSocket.readyState === WebSocket.CONNECTING) {
                        message.ttsWebSocket.close();
                    }
                } catch (e) {
                    console.error('关闭WebSocket失败:', e);
                }
                message.ttsWebSocket = null;
            }

            // 清理队列（ArrayBuffer 不需要特殊清理，会被垃圾回收）
            if (message.ttsAudioQueue) {
                message.ttsAudioQueue = [];
            }

            // 清理 AudioContext（可选，也可以保留以便后续使用）
            // if (message.ttsAudioContext) {
            //     try {
            //         message.ttsAudioContext.close();
            //     } catch (e) {
            //         console.error('关闭AudioContext失败:', e);
            //     }
            //     message.ttsAudioContext = null;
            // }

            // 清理状态
            message.isPlayingTTS = false;
            message.ttsIsPlaying = false;
            message.ttsUserCancelled = false;
        };
        
        //以上都是websocket
        
        // TTS功能切换（弹窗确认，修复取消报错，国际化内容）
        const toggleTTS = () => {
            if (!useTTS.value) {
                // 当前未开启，询问是否开启
                ElMessageBox.confirm(
                    t('ttsEnableConfirm'),
                    t('ttsFeatureTitle'),
                    {
                        confirmButtonText: currentLang.value === 'zh' ? '开启' : 'Enable',
                        cancelButtonText: currentLang.value === 'zh' ? '取消' : 'Cancel',
                        type: 'info',
                    }
                ).then(() => {
                    useTTS.value = true;
                    ElMessage.success(t('ttsEnabled'));
                }).catch(() => {}); // 防止取消时报错
            } else {
                // 当前已开启，询问是否关闭
                ElMessageBox.confirm(
                    t('ttsDisableConfirm'),
                    t('ttsFeatureTitle'),
                    {
                        confirmButtonText: currentLang.value === 'zh' ? '关闭' : 'Disable',
                        cancelButtonText: currentLang.value === 'zh' ? '取消' : 'Cancel',
                        type: 'warning',
                    }
                ).then(() => {
                    useTTS.value = false;
                    ElMessage.info(t('ttsDisabled'));
                }).catch(() => {}); // 防止取消时报错
            }
        };

        // 页面可见性变化处理函数（用于停止TTS播放）
        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                stopAllTTSPlayback();
            }
        };

        onMounted(() => {
            // 首先检查协议状态（无论 intro 还是 chatting）
            const agreementConsent = localStorage.getItem('agreement_consent')
            if (agreementConsent === '1') {
                console.log('用户不同意协议，阻止渲染 Intro/Chatting 页面')
                // 阻止后续逻辑执行
                // 可以选择显示错误提示或重定向到 Welcome 页面
                // 这里先阻止渲染，后续可以根据需求添加提示
                return
            }
            
            // 检测浏览器语言或从localStorage读取用户偏好
            // const savedLang = localStorage.getItem('preferredLanguage')
            // if (savedLang) {
            //     currentLang.value = savedLang
            // } else {
            //     currentLang.value = detectLanguage()
            // }
            // 现在始终强制跟随浏览器语言
            currentLang.value = detectLanguage()

            // 从localStorage读取配置
            const cachedConfigs = localStorage.getItem('allIntroConfigs');
            const cachedLanguage = localStorage.getItem('currentLanguage');
                
            if (cachedConfigs && cachedLanguage) {
                const allConfigs = JSON.parse(cachedConfigs);
                introConfig.value = allConfigs[cachedLanguage];
                currentLanguage.value = cachedLanguage;
                if (introConfig.value?.logo) setFavicon(introConfig.value.logo);
                console.log('从缓存恢复配置:', cachedLanguage);
            }

            
            // 不再手动设置初始状态，使用props传入的状态
            // chatState.value = 'intro'
            
            // 新增：检查是否有更多历史数据，启用动态加载功能
            const hasMore = localStorage.getItem('hasMoreHistory')
            const nextTimestamp = localStorage.getItem('nextQueryTimestamp')
            const conversationId = localStorage.getItem('conversationId')
            
            if (hasMore === 'true' && nextTimestamp && conversationId) {
                // 将ISO格式转换为时间戳
                try {
                    //const timestamp = new Date(nextTimestamp).getTime()
                    const timestamp = nextTimestamp
                    nextQueryTimestamp.value = timestamp.toString()
                    hasMoreHistory.value = true
                    enableDynamicLoading.value = true
                    console.log('启用历史数据动态加载，ISO格式:', nextTimestamp, '转换后时间戳:', timestamp)
                } catch (error) {
                    console.error('时间戳转换失败:', error)
                    // 转换失败时禁用动态加载
                    hasMoreHistory.value = false
                    enableDynamicLoading.value = false
                    console.log('时间戳转换失败，禁用动态加载')
                }
            } else {
                // 禁用动态加载功能
                enableDynamicLoading.value = false
                console.log('无需动态加载历史数据')
            }
            
            // 加载历史消息
            if (props.initialState === 'chatting' && props.historyMessages.length > 0) {
                console.log('加载历史消息:', props.historyMessages)
                loadHistoryMessages(props.historyMessages)
            }
            
            scrollToBottom()
            // 应用图片样式限制
            setTimeout(() => {
                applyMediaStylestoAllElements();
            }, 100);
            
            // 新增：添加滚动监听器
            if (chatContainer.value) {
                chatContainer.value.addEventListener('scroll', handleScroll)
            }
            
            // 监听窗口大小变化，更新设备类型
            window.addEventListener('resize', () => {
                isMobile.value = detectDevice().isMobile
            })
           // alert(isMobile.value)
            
            // 监听页面可见性变化，隐藏时停止TTS播放
            document.addEventListener('visibilitychange', handleVisibilityChange);
            
            document.addEventListener('click', globalClickCloseRecordingModal, true)
            document.addEventListener('click', handleClickOutside)
            document.addEventListener('click', globalClickCloseDislikePopup, true)
        })

        onBeforeUnmount(() => {
            cleanupRecording()
            
            // 新增：移除滚动监听器
            if (chatContainer.value) {
                chatContainer.value.removeEventListener('scroll', handleScroll)
            }
            
            // 移除页面可见性监听
            document.removeEventListener('visibilitychange', handleVisibilityChange);
            
            document.removeEventListener('click', globalClickCloseRecordingModal, true)
            document.removeEventListener('click', handleClickOutside)
            document.removeEventListener('click', globalClickCloseDislikePopup, true)
        })

        const globalClickCloseRecordingModal = (e) => {
            if (showRecordModal.value) {
                const modal = document.querySelector('.recording-content')
                if (modal && !modal.contains(e.target)) {
                    showRecordModal.value = false
                    cleanupRecording()
                }
            }
        }
        
        // 点击外部关闭点踩弹窗
        const globalClickCloseDislikePopup = (e) => {
            // 检查是否有任何点踩弹窗显示
            const hasOpenPopup = messages.value.some(msg => msg.showDislikePopup)
            if (hasOpenPopup) {
                // 检查点击是否在弹窗内容区域内
                const popupContent = e.target.closest('.dislike-popup-content')
                
                // 如果点击不在弹窗内容内，则关闭所有弹窗
                // 这样点击任何外部区域（包括评价按钮、其他消息等）都会关闭弹窗
                if (!popupContent) {
                    closeAllDislikePopups()
                }
            }
        }

        // 添加Markdown渲染方法
        const renderMarkdown = (text) => {
          if (!text) return ''
          
          try {
            return md.render(text)
          } catch (error) {
            console.error('Markdown渲染失败:', error)
            return text // 降级到纯文本
          }
        }

        // 新增：滚动检测函数
        // const handleScroll = () => {
        //     if (isLoadingMore.value || !enableDynamicLoading.value) return
            
        //     const container = chatContainer.value
        //     if (!container) return
            
        //     // 检测是否滚动到顶部附近（阈值100px）
        //     if (container.scrollTop < 10) {
        //         if (hasMoreHistory.value && nextQueryTimestamp.value) {
        //             console.log('检测到滚动到顶部，准备加载更多历史数据')
        //             loadMoreHistoryMessages()
        //         }
        //     }
        // }
        const handleScroll = () => {
    if (isLoadingMore.value || !enableDynamicLoading.value) return
    
    const container = chatContainer.value
    if (!container) return
    
    // 检测是否滚动到顶部附近（阈值100px）
    if (container.scrollTop < 20) {
        if (hasMoreHistory.value && nextQueryTimestamp.value) {
            console.log('检测到滚动到顶部，准备加载更多历史数据')
            
            // 延时执行，避免连续触发
            setTimeout(() => {
                // 再次检查状态，确保没有重复请求
                if (!isLoadingMore.value && hasMoreHistory.value && nextQueryTimestamp.value) {
                    loadMoreHistoryMessages()
                }
            }, 500); // 500ms延时
        }
    }
}

        // 新增：加载更多历史消息
        const loadMoreHistoryMessages = async () => {
            if (isLoadingMore.value || !hasMoreHistory.value || !nextQueryTimestamp.value) {
                return
            }
            
            try {
                isLoadingMore.value = true
                console.log('开始加载更多历史数据，时间戳:', nextQueryTimestamp.value)
                
                // 获取会话ID
                const conversationId = localStorage.getItem('conversationId')
                if (!conversationId) {
                    throw new Error('会话ID不存在')
                }
                
                // 发送请求到后端
                const response = await request.get('/message/messages', {
                    params: {
                        before: nextQueryTimestamp.value  // 只需要时间戳
                    },
                    headers: {
                        'X-Conversation-ID': conversationId  // 会话ID通过请求头传递
                    }
                })
                
                // 检查响应状态
                if (response && response.code === 200 && response.data) {
                    const messagesData = response.data.messages || []
                    
                    if (messagesData.length > 0) {
                        // 处理新加载的消息（包含feedback、fk、suggest）
                        const newMessages = processHistoryMessages(messagesData)
                        
                        // 添加到消息列表开头（保持时间顺序）
                        messages.value.unshift(...newMessages)
                        
                        // 更新分页信息
                        if (response.data.hasMoreHistory) {
                            // 还有更多数据
                            localStorage.setItem('hasMoreHistory', 'true')
                            localStorage.setItem('nextQueryTimestamp', response.data.nextQueryTimestamp)
                            nextQueryTimestamp.value = response.data.nextQueryTimestamp
                            hasMoreHistory.value = true
                            console.log('更新下次查询时间戳:', response.data.nextQueryTimestamp)
                        } else {
                            // 没有更多历史了
                            localStorage.setItem('hasMoreHistory', 'false')
                            localStorage.removeItem('nextQueryTimestamp')
                            hasMoreHistory.value = false
                            nextQueryTimestamp.value = null
                            enableDynamicLoading.value = false
                            console.log('已加载完所有历史数据')
                        }
                        
                        // 保持滚动位置，避免页面跳动
                        nextTick(() => {
                            const container = chatContainer.value
                            if (container) {
                                // 根据新加载的消息数量调整滚动位置
                                const scrollAdjustment = newMessages.length * 40 // 估算每条消息高度
                                container.scrollTop = scrollAdjustment
                            }
                        })
                    } else {
                        // 返回的消息列表为空，说明没有更多历史了
                        localStorage.setItem('hasMoreHistory', 'false')
                        localStorage.removeItem('nextQueryTimestamp')
                        hasMoreHistory.value = false
                        nextQueryTimestamp.value = null
                        enableDynamicLoading.value = false
                        console.log('后端返回空消息列表，已加载完所有历史数据')
                    }
                } else {
                    // 响应错误，停止加载更多
                    const errorMsg = response?.message || response?.data?.message || '加载历史数据失败'
                    console.error('加载更多历史数据失败:', errorMsg)
                    localStorage.setItem('hasMoreHistory', 'false')
                    hasMoreHistory.value = false
                    enableDynamicLoading.value = false
                    ElMessage.error(errorMsg)
                }
            } catch (error) {
                console.error('加载更多历史数据失败:', error)
                ElMessage.error('加载历史数据失败，请重试')
            } finally {
                isLoadingMore.value = false
            }
        }

        // 新增：处理历史消息格式转换
        const processHistoryMessages = (messages) => {
            return messages
                .filter(msg => msg.isSuccess === 1)
                .map(msg => {
                    const userMsg = buildUserMessage(msg)
                    const aiMsg = buildAIMessage(msg)
                    
                    // 添加历史消息标记
                    if (userMsg) userMsg.isHistoryMessage = true
                    if (aiMsg) aiMsg.isHistoryMessage = true
                    
                    return [userMsg, aiMsg].filter(Boolean)
                })
                .flat()
        }

       // 新增：构建用户消息
        // const buildUserMessage = (msg) => {
        //     if (msg.type === 0) { // 文本
        //         return {
        //             type: 'text',
        //             text: msg.content,
        //             isUser: true
        //         }
        //     } else if (msg.type === 1) { // 语音  2025-12-23发现2是图文
        //         return {
        //             type: 'voice',
        //             url: msg.audioUrl,
        //             isUser: true
        //         }
        //     } else if (msg.type === 2) { // 图片   2025-12-23发现2是图文
        //         return {
        //             type: 'image',
        //             url: msg.imageUrl,
        //             isUser: true
        //         }
        //     }
        //     return null
        // }

        const buildUserMessage = (msg) => {
         switch (msg.type) {
        case 0: // 文本
            return {
                type: 'text',
                text: msg.content,
                isUser: true
            }
        case 1: // 图片
            return {
                type: 'image',
                url: msg.imageUrl,
                isUser: true
            }
        case 2: // 图文混合
            return {
                type: 'mixed',
                text: msg.content,
                images: [msg.imageUrl],
                isUser: true
            }
        case 3: // 语音
            return {
                type: 'voice',
                url: msg.audioUrl,
                isUser: true
            }
        default:
            return null
    }
}



        // 旧代码
        // const buildAIMessage = (msg) => {
        //     if (msg.isTTS === 1) { // 语音回复
        //         return {
        //             type: 'voice',
        //             url: msg.aiAudioUrl,
        //             text: msg.aiResponse,
        //             showText: false,
        //             isUser: false
        //         }
        //         } else { // 文本回复
        //             return {
        //                 type: 'text',
        //                 text: msg.aiResponse,
        //                 isUser: false
        //             }
        //         }
        // }


        // 新增：构建AI消息
        const buildAIMessage = (msg) => {
            // 将feedback数字转换为字符串，并设置feedbackValue
            // feedback: 1=点赞, 2=点踩 -> 转换为 'like'/'dislike'
            let feedbackStr = null;
            let feedbackValue = msg.feedback || 0;
            if (msg.feedback === 1) {
                feedbackStr = 'like';
            } else if (msg.feedback === 2) {
                feedbackStr = 'dislike';
            }
            
            if (msg.isTTS === 1) { // 语音回复
                return {
                    type: 'voice',
                    url: msg.aiAudioUrl,
                    text: msg.aiResponse,
                    showText: false,
                    isUser: false,
                    userMessageId: msg.timestamp, // 添加：用户消息时间戳
                    feedback: feedbackStr,        // 字符串格式：'like'/'dislike'/null
                    feedbackValue: feedbackValue, // 数字格式：1/2/0
                    suggest: msg.suggest || '',   // 添加：建议内容
                    isSuccess: msg.isSuccess,     // 添加：成功状态
                    fk: msg.fk ?? 0,              // 添加：更多选项编号（1-6）
                    // dislikeOptions: msg.dislikeOptions ? Number(msg.dislikeOptions) : 0,
                    // dislikeReason: msg.dislikeReason || ''
                }
            } else { // 文本回复
                return {
                    type: 'text',
                    text: msg.aiResponse,
                    isUser: false,
                    userMessageId: msg.timestamp, // 添加：用户消息时间戳
                    feedback: feedbackStr,        // 字符串格式：'like'/'dislike'/null
                    feedbackValue: feedbackValue, // 数字格式：1/2/0
                    suggest: msg.suggest || '',   // 添加：建议内容
                    isSuccess: msg.isSuccess,     // 添加：成功状态
                    fk: msg.fk ?? 0,              // 添加：更多选项编号（1-6）
                    // dislikeOptions: msg.dislikeOptions ? Number(msg.dislikeOptions) : 0,
                    // dislikeReason: msg.dislikeReason || ''
                }
            }
        }


// 处理移动端图片上传
const handleMobileImageUpload = async (event) => {
    const file = event.target.files[0];
    if (!file) return;
    
    // 验证文件类型
    // if (!file.type.startsWith('image/')) {
    //     ElMessage.error(tb('bugUploadFailed'));
    //     return;
    // }
    
    // 创建预览
    const reader = new FileReader();
    reader.onload = (e) => {
        mobileBugData.value.screenshotPreview = e.target.result;
    };
    reader.readAsDataURL(file);
    
    mobileBugData.value.screenshot = file;
    
    try {
        // 上传图片
        const url = await uploadFileToServer(file);
        if (url) {
            mobileBugData.value.screenshotUrl = url;
            ElMessage.success(tb('bugUploadSuccess'));
        }
    } catch (error) {
        console.error('图片上传失败:', error);
        ElMessage.error(tb('bugUploadFailed'));
    }
};

// 移除移动端图片
const removeMobileImage = () => {
    mobileBugData.value.screenshot = null;
    mobileBugData.value.screenshotPreview = null;
    mobileBugData.value.screenshotUrl = null;
    const fileInput = document.getElementById('bugScreenshot');
    if (fileInput) {
        fileInput.value = '';
    }
};

// 处理PC端Dialog关闭
const handlePCDialogClose = (done) => {
    // 重置数据
    if (isMobile.value) {
        resetMobileBugData();
    } else {
        resetPCBugData();
    }
    done();
};

// 处理富文本输入
const handleRichTextInput = () => {
    pcBugData.value.content = richEditor.value.innerHTML;
};


// 处理图片粘贴
const handleImagePaste = async (event) => {
    event.preventDefault();
    const items = event.clipboardData.items;
    
    for (let item of items) {
        if (item.type.indexOf('image') !== -1) {
            const file = item.getAsFile();
            
            // 上传图片
            const imageUrl = await uploadImage(file);
            if (imageUrl) {
                // 插入图片到富文本
                const img = document.createElement('img');
                img.src = imageUrl;
                // 统一样式：限制最大尺寸
                img.style.maxWidth = '100px';
                img.style.maxHeight = '80px';
                img.style.width = 'auto';
                img.style.height = 'auto';
                img.style.margin = '10px 10px 10px 0';
                img.style.display = 'inline-block';
                img.style.verticalAlign = 'top';
                img.style.objectFit = 'contain';
                img.style.borderRadius = '4px';
                img.style.border = '1px solid #e0e0e0';
                
                // 插入到光标位置
                const selection = window.getSelection();
                if (selection.rangeCount > 0) {
                    const range = selection.getRangeAt(0);
                    range.insertNode(img);
                    
                    // 移动光标到图片后面
                    range.setStartAfter(img);
                    range.collapse(true);
                    selection.removeAllRanges();
                    selection.addRange(range);
                }
            }
        }
    }
};
// 初始化移动端Bug数据（设置默认日期和时间）
const initMobileBugData = () => {
    const now = new Date();
    mobileBugData.value.date = now.toISOString().split('T')[0]; // YYYY-MM-DD
    mobileBugData.value.time = now.toTimeString().split(' ')[0].substring(0, 5); // HH:MM
};

// 重置PC端BUG数据
const resetPCBugData = () => {
    pcBugData.value = {
        date: new Date(),
        time: new Date(),
        content: ''
    };
    
    // 清空富文本编辑器内容
    if (richEditor.value) {
        richEditor.value.innerHTML = '';
    }
    
    // 重置上传状态
    isUploadingImage.value = false;
};

// 重置移动端BUG数据
const resetMobileBugData = () => {
    mobileBugData.value = {
        date: '',
        time: '',
        description: '',
        screenshot: null,
        screenshotPreview: null,
        screenshotUrl: null
    };
    // 重置文件输入
    const fileInput = document.getElementById('bugScreenshot');
    if (fileInput) {
        fileInput.value = '';
    }
    initMobileBugData();
};
// 上传图片函数
const uploadImage = async (file) => {
    const formData = new FormData();
    formData.append('file', file);
    
    try {
        // 显示上传中提示
        isUploadingImage.value = true;
        ElMessage.info('图片上传中...');
        
        const response = await request.post('/api/upload', formData);
        if (response && response.url) {
            ElMessage.success(tb('bugUploadSuccess'));
            return response.url;
        } else {
            console.error('响应中没有找到URL:', response);
            ElMessage.error('图片上传失败');
            return null;
        }
    } catch (error) {
        console.error('图片上传失败:', error);
        ElMessage.error('图片上传失败');
        return null;
    } finally {
        // 无论成功失败都隐藏上传中状态
        isUploadingImage.value = false;
    }
};
// 处理取消按钮点击
const handleCancel = () => {
    // 重置数据
    if (isMobile.value) {
        resetMobileBugData();
    } else {
        resetPCBugData();
    }
    // 关闭Dialog
    showPCDialog.value = false;
};
// PC端提交BUG
const submitPCBug = async () => {
    try {
        const bugData = {
            date: pcBugData.value.date.toISOString().split('T')[0],
            time: pcBugData.value.time.toTimeString().split(' ')[0].substring(0, 5),
            description: pcBugData.value.content,
            reporter: 'PC用户',
            screenshotUrl: null
        };

        const response = await request.post('/bug-report', bugData);
        
        if (response.code===200) {
            ElMessage.success(tb('bugSubmitSuccess'));
            // 重置数据并关闭Dialog
            resetPCBugData();
            showPCDialog.value = false;
        } else {
            ElMessage.error(tb('bugSubmitFailed'));
        }
    } catch (error) {
        console.error('Bug提交失败:', error);
        ElMessage.error(tb('bugSubmitFailed'));
    }
};

// 移动端提交BUG
const submitMobileBug = async () => {
    try {
        const bugData = {
            date: mobileBugData.value.date,
            time: mobileBugData.value.time,
            description: mobileBugData.value.description,
            reporter: '移动端用户',
            screenshotUrl: mobileBugData.value.screenshotUrl
        };

        const response = await request.post('/bug-report', bugData);
        
        if (response.code === 200) {
            ElMessage.success(tb('bugSubmitSuccess'));
            // 重置数据并关闭Dialog
            resetMobileBugData();
            showPCDialog.value = false;
        } else {
            ElMessage.error(tb('bugSubmitFailed'));
        }
    } catch (error) {
        console.error('Bug提交失败:', error);
        ElMessage.error(tb('bugSubmitFailed'));
    }
};

        return {
            realTimeRecognizedText,
            // 现有变量...
            showPCDialog,
    pcBugData,
    mobileBugData,
    richEditor,
    closeAllDislikePopups,
    submitDislikeFeedback,
 // 新增方法
 handlePCDialogClose,
    handleRichTextInput,
    handleImagePaste,
    handleMobileImageUpload,
    removeMobileImage,
    submitPCBug,
    submitMobileBug,
    handleCancel,
    initMobileBugData,
    resetMobileBugData,
    tb,
    // 图标
    xiaoIcon,
    kuIcon,
    kaiIcon,
    guanIcon,
    dislikeOptionLabels,

    isRequestCancellable,
cancelCurrentRequest,
            handleRefresh,
            showRefreshButton,
            showRefreshButtonClick,
            messages,
            inputMessage,
            isTyping,
            chatContainer,
            isKeyboardOpen,
            isRecording,
            recordingTime,
            previewImages,
            canSend,
            sendMessage,
            handleInputFocus,
            handleInputBlur,
            handleImageUpload,
            removePreviewImage,
            startRecording,
            stopRecording,
            
         
            cancelRecording,
            previewImage,
            handleHtmlClick,
            playVoice,
            voiceBubbleStyle,
            fileInputRef,
            handleImageButtonClick,
            inputRef,
            showRecordModal,
            showImageViewer,
            imageList,
            imageIndex,
            audioRefs,
            playingIndex,
            setAudioRef,
            togglePlay,
            onAudioEnded,
            onAudioPlay,
            onAudioPause,
            handleRecordClick,
            checkMicrophonePermission,
            currentLang,
            switchLanguage,
            t,
            showLangDropdown,
            toggleLangDropdown,
            showTTSFeature,
            showTicketFeature,
            isUploadingImage,
            chatState,
            forceScrollToBottom,
            useTTS,
            toggleTTS,
            renderMarkdown,
            isAiResponding,
            hasMoreHistory,
            nextQueryTimestamp,
            isLoadingMore,
            enableDynamicLoading,
            // 新增：动态加载相关函数
            handleScroll,
            loadMoreHistoryMessages,
            processHistoryMessages,
            buildUserMessage,
            buildAIMessage,
            introConfig,  // 确保这个被暴露
            LANGUAGE_CONFIG,
            currentLanguage,
            isMobile,  // 设备检测响应式变量
            
            // 反馈相关
            showFeedbackDialogVisible,
            currentFeedbackMessageIndex,
            currentFeedbackMessage,
            currentFeedbackOption,
            feedbackCustomText,
            feedbackOptions,
            showFeedbackDialog,
            selectFeedbackOption,
            cancelFeedbackDialog,
            submitFeedback,
            handleFeedback,
            handlePlayTTS,
            handlePlayTTS2,
            handlePlayTTS3,
            isStreamingResponse,
            streamingMessageId,
            getFkText
        }
    }
}
</script>

<style scoped>
.chat-page {
    width: 100%;
    height: 100vh;
    height: 100dvh;
    /* 使用动态视口高度 */
    background: #fafafa;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
}

/* 语言选择器样式 */
.language-dropdown-wrapper {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 1000;
}

.lang-icon-btn {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #eee;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: background 0.2s;
    padding: 0;
}

.lang-icon-btn:active {
    background: #f0f0f0;
}

.lang-icon {
    width: 24px;
    height: 24px;
    display: block;
    object-fit: contain;
}

.lang-dropdown-menu {
    position: absolute;
    top: 48px;
    right: 0;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.13);
    min-width: 110px;
    border: 1px solid #eee;
    padding: 6px 0;
    display: flex;
    flex-direction: column;
    gap: 2px;
    z-index: 1100;
}

.lang-dropdown-item {
    padding: 8px 18px;
    font-size: 15px;
    color: #333;
    cursor: pointer;
    transition: background 0.18s, color 0.18s;
    border-radius: 8px;
}

.lang-dropdown-item.active,
.lang-dropdown-item:hover {
    background: #007aff;
    color: #fff;
}

@supports (padding: max(0px)) {
    .language-dropdown-wrapper {
        top: max(20px, env(safe-area-inset-top) + 10px);
        right: max(20px, env(safe-area-inset-right) + 10px);
    }
}

/* 功能图标区域样式 */
.feature-icons-wrapper {
    position: fixed;
    top: 70px;
    right: 20px;
    z-index: 1000;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.feature-icon-btn {
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #eee;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
    transition: all 0.2s ease;
    padding: 0;
}

.feature-icon-btn:hover {
    background: #f0f0f0;
    transform: scale(1.05);
}

.feature-icon-btn:active {
    background: #e0e0e0;
    transform: scale(0.95);
}

.feature-icon-btn.active {
    background: #007aff;
    color: #fff;
    box-shadow: 0 2px 12px rgba(0, 122, 255, 0.3);
}

.feature-icon {
    font-size: 18px;
    color: #333;
}

.feature-icon-img {
    width: 20px;
    height: 20px;
    display: block;
    object-fit: contain;
}

.refresh-f5-btn {
    color: #666;
    font-size: 12px;
    font-weight: 500;
}

@supports (padding: max(0px)) {
    .feature-icons-wrapper {
        top: max(70px, env(safe-area-inset-top) + 60px);
        right: max(20px, env(safe-area-inset-right) + 10px);
    }
}

/* 介绍页面样式 */
.intro-container {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 40px 20px;
    background: #fafafa;
}

.intro-content {
    text-align: center;
    max-width: 400px;
    width: 100%;
}

.intro-logo {
    margin-bottom: 10px;
}

/* 保留原外边框尺寸，去掉圆圈与渐变，仅作 logo 容器 */
.logo-circle {
    width: 160px;
    height: 160px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 8px;
}

.logo-img {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.intro-text {
    margin-bottom: 24px;
}

.intro-title {
    font-size: 24px;
    font-weight: 600;
    color: #333;
    margin-bottom: 16px;
    line-height: 1.4;
}

.intro-description {
    font-size: 16px;
    color: #666;
    line-height: 1.6;
    margin: 0;
}

/* 移动端适配 */
@media (max-width: 480px) {
    .intro-container {
        padding: 20px 16px;
    }
    
    .intro-title {
        font-size: 20px;
    }
    
    .intro-description {
        font-size: 14px;
    }
    
    .logo-circle {
        width: 64px;
        height: 64px;
    }
}

.chat-container {
    flex: 1;
    overflow-y: auto;
    padding: 12px 0 80px 0;
    background: transparent;
}

.chat-header {
    padding: env(safe-area-inset-top) 20px 15px;
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-bottom: 1px solid #e5e5e5;
    display: flex;
    align-items: center;
    justify-content: center;
    position: sticky;
    top: 0;
    z-index: 100;
}

.chat-title {
    font-size: 18px;
    font-weight: 600;
    color: #1a1a1a;
}

.chat-container {
    flex: 1;
    padding: 20px;
    /* 预留底部空间，避免最新消息的评价框被输入栏遮挡 */
    padding-bottom: calc(50px + env(safe-area-inset-bottom));
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 10px;
    -webkit-overflow-scrolling: touch;
    /* 增加iOS滚动流畅度 */
    overscroll-behavior: contain;
    /* 防止滚动穿透 */
}

.message {
    max-width: 100%;
    padding: 0px 0px;
    border-radius: 12px;
    font-size: 16px;
    line-height: 1.4;
    animation: messageSlideIn 0.3s ease-out;
    word-break: break-word;
    margin: 0;
    /* 防止长文本溢出 */
    
}   

.message.bot {
    align-self: flex-start;
    background: #f0f0f0;
    color: #1a1a1a;
}
/* 单独为AI消息设置最小宽度 */
.ai-message-content {
    min-width: 300px;
}

.message.user {
    align-self: flex-end;
    background: #f0f0f0;
    color: #1a1a1a;
}

.chat-input-container {
    padding: 15px 20px calc(8px + env(safe-area-inset-bottom));
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-top: 1px solid #e5e5e5;
    position: sticky;
    bottom: 0;
    z-index: 100;
    transition: transform 0.3s ease;
}

.image-preview-bar {
    display: flex;
    gap: 8px;
    margin-bottom: 6px;
}

.image-preview-box {
    position: relative;
    width: 48px;
    height: 48px;
    border-radius: 8px;
    overflow: hidden;
    background: #f5f5f5;
    box-shadow: none;
    border: none;
}

.preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    background: #f5f5f5;
    box-shadow: none;
    border: none;
}

.remove-image {
    position: absolute;
    top: 2px;
    right: 2px;
    background: rgba(0, 0, 0, 0.5);
    border: none;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.chat-input-wrapper {
    display: flex;
    align-items: center;
    background: #f5f5f5;
    border-radius: 24px;
    padding: 8px 12px;
    gap: 8px;
}

.input-actions {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-right: 6px;
}

.action-button {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: #f0f1f5;
    border: none;
    color: #666;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    touch-action: manipulation;
    transition: background 0.2s, transform 0.15s;
}

.action-button:active {
    background: #e5e6eb;
    transform: scale(0.95);
}

.action-button.disabled {
    opacity: 0.4;
    pointer-events: none;
}

.action-button:disabled {
    opacity: 0.4;
    pointer-events: none;
}

.action-button .el-icon {
    font-size: 20px;
}

.input-content {
    flex: 1;
    display: flex;
    align-items: center;
}
.chat-input {
    min-height: 50px;
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-size: 17px;
    padding: 0px 5px;      /* ✅ 添加上下padding */
    color: #222;
    line-height: 1.6;       /* ✅ 设置行高 */
    resize: none;          /* ✅ 禁止调整大小 */
    /* 移除无效的flex样式 */
}

/* ✅ 额外添加placeholder伪元素样式 */
/* transform: translateY(60%); 向上偏移50%，配合align-items居中 加上导致切换语言  其他语言place到底部*/
.chat-input::placeholder {
           /* placeholder文字居中 */
    line-height: 1.5;           /* 行高 */
   
}
.send-button {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #007aff;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 4px;
    transition: background 0.2s, transform 0.15s;
    box-shadow: none;
    flex-shrink: 0;
}

.send-button:active {
    background: #005ecb;
    transform: scale(0.96);
}

.send-button:disabled {
    background: #c0c4cc;
    color: #fff;
    cursor: not-allowed;
    transform: none;
}

.typing-indicator {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #f0f0f0;
    border-radius: 18px;
    max-width: 80px;
    align-self: flex-start;
}

.typing-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #999;
    animation: typingBounce 1.5s infinite ease-in-out;
}

.typing-dot:nth-child(2) {
    animation-delay: 0.2s;
}

.typing-dot:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes messageSlideIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes typingBounce {

    0%,
    60%,
    100% {
        transform: translateY(0);
    }

    30% {
        transform: translateY(-10px);
    }
}

.message-image {
    max-width: 44vw;
    max-height: 100px;
    border-radius: 8px;
    margin: 2px 0;
    display: block;
    background: #f5f5f5;
    box-shadow: none;
    border: none;
}

.voice-message {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 270px;
    max-width: 80vw;
    width: auto;
    box-sizing: border-box;
    padding: 8px 16px;
    border-radius: 16px;
    font-size: 15px;
    margin: 2px 0 30px 0;
    background: #f7f8fa;
}
.voice-message audio {
    width: 100%;
    min-width: 240px;
    max-width: 100%;
}
.user-voice {
    background: #eaf3ff;
    border: 1px solid #dbeafe;
}
.user-voice-simple {
    background: #eaf3ff;
    border: 1px solid #dbeafe;
    margin: 2px 0 8px 0; /* 减少底部边距，保持紧凑 */
}
.bot-voice {
    background: #f7f8fa;
    border: 1px solid #ededed;
}

.modern-recording-modal {
    background: rgba(0, 0, 0, 0.28);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
}
/* 语音弹窗大小 */
.recording-modal-content {
    background: #fff;
    border-radius: 22px;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    padding: 36px 32px 5px 32px;
    display: flex;
    flex-direction: column;
    align-items: center;
    min-width: 200px;
    min-height: 80px;
    position: relative;
}

.recording-circle-btn {
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: linear-gradient(135deg, #4f8aff 0%, #6fd6ff 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 16px rgba(79, 138, 255, 0.18);
    margin-bottom: 18px;
    position: relative;
    cursor: pointer;
    transition: box-shadow 0.2s, transform 0.2s;
    animation: pulse 1.2s infinite;
}

@keyframes pulse {
    0% {
        box-shadow: 0 0 0 0 rgba(79, 138, 255, 0.18);
    }

    70% {
        box-shadow: 0 0 0 16px rgba(79, 138, 255, 0.04);
    }

    100% {
        box-shadow: 0 0 0 0 rgba(79, 138, 255, 0.18);
    }
}

.recording-circle-btn:active {
    transform: scale(0.96);
    background: linear-gradient(135deg, #357aff 0%, #4fd6ff 100%);
}

.recording-mic {
    color: #fff;
    font-size: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.recording-status {
    margin-top: 10px;
    font-size: 18px;
    color: #333;
    font-weight: 500;
    letter-spacing: 1px;
    min-height: 28px;
    text-align: center;
}

/* 适配刘海屏 */
@supports (padding: max(0px)) {
    .chat-header {
        padding-top: max(env(safe-area-inset-top), 20px);
    }

    .chat-input-container {
        padding-bottom: max(env(safe-area-inset-bottom), 30px);
    }
}

.mixed-message-text {
    margin-bottom: 4px;
    font-size: 16px;
    color: #222;
}

.mixed-message-images {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.mixed-message-images .message-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border-radius: 14px;
    border: 1px solid #ededed;
    background: #f7f8fa;
    padding: 4px;
}

.mixed-message-videos {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    margin-top: 8px;
}

.message-video {
    max-width: 150px;       /* 固定最大宽度150像素 */
    max-height: 100px;      /* 固定最大高度100像素 */
    width: auto;            /* 自动宽度保持比例 */
    height: auto;           /* 自动高度保持比例 */
    border-radius: 6px;
    margin: 2px 0;
    display: block;
    background: #f5f5f5;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    border: 1px solid #e0e0e0;
    cursor: pointer;
    transition: transform 0.2s ease;
}

.message-video:hover {
    transform: scale(1.02);  /* 鼠标悬停时轻微放大 */
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.thinking-dots {
    display: inline-block;
    background: #f0f0f0;
    border-radius: 12px;
    padding: 8px 12px;
    margin: 2px 0;
    min-width: 50px;
    text-align: center;
}

.thinking-dots span {
    animation: blink 1.2s infinite;
    font-size: 18px;
    margin: 0 1px;
    color: #666;
}

.thinking-dots span:nth-child(2) {
    animation-delay: 0.2s;
}

.thinking-dots span:nth-child(3) {
    animation-delay: 0.4s;
}

@keyframes blink {

    0%,
    80%,
    100% {
        opacity: 0.2;
    }

    40% {
        opacity: 1;
    }
}

.image-uploading-tip {
    color: #007aff;
    font-size: 14px;
    margin: 8px 0 0 8px;
}

.uploading-dots span {
  animation: blink 1.2s infinite;
  font-size: 18px;
  margin: 0 1px;
}
.uploading-dots span:nth-child(2) {
  animation-delay: 0.2s;
}
.uploading-dots span:nth-child(3) {
  animation-delay: 0.4s;
}
@keyframes blink {
  0%, 80%, 100% { opacity: 0.2; }
  40% { opacity: 1; }
}

/* HTML内容样式 - 针对动态添加的内容 */
.message.bot img:not(.message-image):not(.feedback-icon),
.message.bot div img:not(.message-image):not(.feedback-icon) {
    max-width: 200px !important;       /* 最大宽度200像素 */
    max-height: 150px !important;      /* 最大高度150像素 */
    width: auto !important;            /* 自动宽度保持比例 */
    height: auto !important;           /* 自动高度保持比例 */
    border-radius: 6px !important;
    margin: 6px 0 !important;
    display: block !important;
    background: #f5f5f5 !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    border: 1px solid #e0e0e0 !important;
    cursor: pointer !important;
    transition: all 0.1s ease !important;  /* 减少过渡时间，减少闪烁 */
    object-fit: contain !important;    /* 保持完整显示，不裁剪 */
}

.message.bot img:not(.message-image):not(.feedback-icon):hover,
.message.bot div img:not(.message-image):not(.feedback-icon):hover {
    transform: scale(1.02);  /* 鼠标悬停时轻微放大 */
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.message.bot video:not(.message-video),
.message.bot div video:not(.message-video) {
    /* 不限制视频尺寸，让视频保持原始大小 */
    border-radius: 6px !important;
    margin: 6px 0 !important;
    display: block !important;
    /* 不设置背景色，让视频组件自己处理封面图 */
    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    border: 1px solid #e0e0e0 !important;
}

.message.bot video:not(.message-video):hover,
.message.bot div video:not(.message-video):hover {
    transform: scale(1.02);  /* 鼠标悬停时轻微放大 */
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

/* 强制限制所有在聊天消息中的媒体文件大小 */
.chat-container .message.bot img:not(.feedback-icon) {
    max-width: 200px !important;
    max-height: 150px !important;
}

.chat-container .message.bot video {
    /* 不限制视频尺寸，让视频保持原始大小 */
}

/* 直接控制所有通过v-html插入的媒体元素 */
.message.bot [v-html] img:not(.feedback-icon),
.message.bot [v-html] video {
    max-width: 200px !important;
    max-height: 150px !important;
    width: auto !important;
    height: auto !important;
    border-radius: 6px !important;
    margin: 6px 0 !important;
    display: block !important;
    background: #f5f5f5 !important;
    box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
    border: 1px solid #e0e0e0 !important;
    cursor: pointer !important;
    transition: all 0.1s ease !important;
    object-fit: contain !important;
}

.message.bot [v-html] video {
    /* 不限制视频尺寸，让视频保持原始大小 */
    /* 不设置背景色，让视频组件自己处理封面图 */
}

/* 响应式设计 - 针对不同屏幕尺寸优化 */
@media (max-width: 480px) {
    .message.bot div img:not(.feedback-icon),
    .message.bot img:not(.feedback-icon) {
        max-width: 160px !important;    /* 小屏幕上图片 */
        max-height: 120px !important;
    }
    
    .message.bot div video,
    .message.bot video,
    .message-video {
        /* 小屏幕上也不限制视频尺寸 */
        /* 不设置背景色，让视频组件自己处理封面图 */
    }
}

@media (min-width: 768px) {
    .message.bot div img:not(.feedback-icon) {
        max-width: 180px;    /* 大屏幕上图片更大 */
        max-height: 140px;
    }
    
    .message.bot div video,
    .message-video {
        /* 大屏幕上也不限制视频尺寸 */
    }
}

.voice-text-toggle {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}
.expand-text-btn {
    background: none;
    border: none;
    color: #007aff;
    cursor: pointer;
    font-size: 14px;
    padding: 0;
    margin: 4px 0 0 0;
    align-self: flex-start;
}
.ai-text {
    background: #f7f8fa;
    border-radius: 8px;
    padding: 8px 12px;
    margin-top: 2px;
    color: #222;
    font-size: 15px;
    max-width: 90vw;
    word-break: break-word;
}
.expand-text-btn-float {
    position: absolute;
    right: 1px;
    bottom: -28px;
    background: none;
    border: none;
    color: #007aff;
    cursor: pointer;
    font-size: 14px;
    padding: 0 4px;
    z-index: 2;
    opacity: 0.85;
    transition: opacity 0.2s;
    min-width: 60px;
    text-align: center;
}
.expand-text-btn-float:hover {
    opacity: 1;
}
.voice-extra-row {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    margin-top: 2px;
    margin-bottom: 2px;
    min-width: 260px;
    max-width: 80vw;
}
.expand-text-btn-row {
    background: none;
    border: none;
    color: #007aff;
    cursor: pointer;
    font-size: 13px;
    padding: 0 4px;
    margin-bottom: 2px;
    align-self: flex-end;
    opacity: 0.85;
    transition: opacity 0.2s;
}
.expand-text-btn-row:hover {
    opacity: 1;
}
.ai-text {
    background: #f7f8fa;
    border-radius: 8px;
    padding: 8px 12px;
    margin-top: 2px;
    color: #222;
    font-size: 15px;
    max-width: 90vw;
    word-break: break-word;
    align-self: flex-end;
}
.expand-btn-row {
    display: flex;
    justify-content: flex-end;
    max-width: 80vw;
}
.expand-text-btn {
    background: none;
    border: none;
    color: #007aff;
    cursor: pointer;
    font-size: 14px;
    padding: 0;
    margin: 4px 0 0 0;
    align-self: flex-start;
}
.ai-text-bubble {
    background: #f7f8fa;
    border-radius: 16px;
    padding: 10px 16px;
    margin: 6px 0 6px 0;
    color: #222;
    font-size: 15px;
    max-width: 400px;
    word-break: break-word;
    align-self: flex-start;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04);
}
.expand-text-btn-inline {
    background: none;
    border: none;
    color: #007aff;
    cursor: pointer;
    font-size: 14px;
    padding: 0;
    margin: 6px 0 0 0;
    align-self: flex-start;
}
.ai-text-inline {
    background: #f7f8fa;
    border-radius: 8px;
    padding: 8px 12px;
    margin-top: 8px;
    color: #222;
    font-size: 15px;
    max-width: 100%;
    word-break: break-word;
    line-height: 1.6;
    border: 1px solid #e5e5e5;
}
.ai-text-separate {
    margin-top: 12px;
    margin-bottom: 4px;
    background: #f0f0f0;
    color: #1a1a1a;
    font-size: 16px;
    line-height: 1.6;
    box-shadow: 0 1px 3px rgba(0,0,0,0.04);
    border-radius: 12px;
    padding: 8px 12px;
    max-width: 80vw;
    word-break: break-word;
}

/* 新增：加载更多历史消息提示样式 */
.loading-more-indicator {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 12px 16px;
    background: #f7f8fa;
    border-radius: 18px;
    max-width: 200px;
    align-self: center;
    margin: 10px auto;
    font-size: 14px;
    color: #666;
    border: 1px solid #e5e5e5;
}

.loading-more-indicator .loading-dots span {
    animation: blink 1.2s infinite;
    font-size: 16px;
    margin: 0 1px;
    color: #007aff;
}

.loading-more-indicator .loading-dots span:nth-child(2) {
    animation-delay: 0.2s;
}

.loading-more-indicator .loading-dots span:nth-child(3) {
    animation-delay: 0.4s;
}

/* 🔥 新增：系统消息样式 - 页面居中 */
.system-message.refresh-required {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    z-index: 1000;
}

.refresh-button {
    background: #007bff;
    color: white;
    border: none;
    border-radius: 6px;
    padding: 10px 20px;
    font-size: 14px;
    cursor: pointer;
    margin-bottom: 12px;
    transition: background-color 0.2s;
}

.refresh-button:hover {
    background: #0056b3;
}

.refresh-text {
    color: #666;
    font-size: 13px;
    margin: 0;
}

/* 页面中间刷新按钮样式 */
.center-refresh-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10000;
}

.center-refresh-container {
    background: white;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 20px 30px;
    position: relative;
    min-width: 150px;
    text-align: center;
}

.center-refresh-tip {
    margin: 0 0 10px 0;
    color: #666;
    font-size: 13px;
}

.center-refresh-button {
    background: #f5f5f5;
    color: #333;
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 8px 20px;
    font-size: 14px;
    font-weight: normal;
    cursor: pointer;
    transition: background-color 0.2s;
}

.center-refresh-button:hover {
    background: #e5e5e5;
}

.center-refresh-button:active {
    background: #d5d5d5;
}

.center-refresh-close {
    position: absolute;
    top: 5px;
    right: 5px;
    background: transparent;
    border: none;
    font-size: 20px;
    color: #999;
    cursor: pointer;
    width: 24px;
    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 2px;
    transition: background 0.2s;
}

.center-refresh-close:hover {
    background: #f0f0f0e0;
    color: #666;
}

/* 移动端适配 */
@media (max-width: 768px) {
    .center-refresh-container {
        padding: 20px 30px;
        margin: 20px;
    }
    
    .center-refresh-button {
        padding: 10px 20px;
        font-size: 14px;
    }
}

/* 移动端适配 */
@media (max-width: 768px) {
    .refresh-button {
        padding: 8px 16px;
        font-size: 13px;
    }
    
    .refresh-text {
        font-size: 12px;
    }

    
    
}






















/* PC端BUG提交Dialog样式 */
.pc-bug-form {
    padding: 20px;
}

.time-fields {
    display: flex;
    gap: 20px;
    margin-bottom: 20px;
}

.rich-editor {
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    min-height: 300px;
    max-height: 500px;
    overflow-y: auto;
    background: white;
    margin-top: 20px;
}

.rich-text-area {
    padding: 15px;
    min-height: 280px;
    outline: none;
    line-height: 1.6;
    font-size: 14px;
    color: #333;
    background: white;
}

/* 统一粘贴图片的样式 */
.rich-text-area img {
    max-width: 400px;
    max-height: 300px;
    width: auto;
    height: auto;
    margin: 10px 10px 10px 0;
    display: inline-block;
    vertical-align: top;
    object-fit: contain;
    border-radius: 4px;
    border: 1px solid #e0e0e0;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.rich-text-area:focus {
    border-color: #409eff;
}

.rich-text-area:empty:before {
    content: attr(placeholder);
    color: #999;
    font-style: italic;
}




.dialog-footer {
    text-align: right;
}

.dialog-footer .el-button {
    margin-left: 10px;
}

/* 移动端Bug提交表单样式 */
.mobile-bug-form {
    padding: 20px;
}

.mobile-bug-form .field-label {
    display: block;
    margin-bottom: 8px;
    font-size: 15px;
    font-weight: 500;
    color: #333;
}

.mobile-bug-form .time-inputs {
    display: flex;
    gap: 10px;
    margin-bottom: 20px;
}

.mobile-bug-form .date-input,
.mobile-bug-form .time-input {
    flex: 1;
    padding: 10px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    font-size: 14px;
    background-color: #f8f9fa;
}

.mobile-bug-form .screenshot-field {
    margin-bottom: 20px;
}

.mobile-bug-form .file-input {
    width: 100%;
    padding: 10px;
    border: 1px dashed #dcdfe6;
    border-radius: 6px;
    background-color: #f8f9fa;
    font-size: 14px;
}

.mobile-bug-form .image-preview {
    position: relative;
    margin-top: 10px;
    display: inline-block;
}

.mobile-bug-form .image-preview img {
    max-width: 60px;
    max-height: 60px;
    width: auto;
    height: auto;
    border-radius: 6px;
    border: 1px solid #dcdfe6;
    object-fit: contain;
    display: block;
}

.mobile-bug-form .remove-image-btn {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #ff3b30;
    color: white;
    border: none;
    font-size: 18px;
    line-height: 1;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mobile-bug-form .description-field {
    margin-bottom: 20px;
}

.mobile-bug-form .description-textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #dcdfe6;
    border-radius: 6px;
    min-height: 80px;
    resize: vertical;
    font-size: 14px;
    background-color: #f8f9fa;
    font-family: inherit;
}

















.realtime-asr-text-display {
    position: fixed;
    bottom: 120px;  /* 在录音弹窗下方 调整上下间距 */  
    left: 50%;
    transform: translateX(-50%);
    width: 90%;
    max-width: 400px;
    z-index: 10000;
}


.realtime-asr-text-display {
    /* 应该在recording-modal-content内部 */
    width: 75%;
    margin-top: 1px;
}

.asr-text-container {
    /* 白色对话框样式 */
    background: #fff;
    border: 1px solid #e4e7ed;
    border-radius: 12px;
    padding: 22px 16px;
    /* 对话框形状 */
}
.asr-text-container {
    background: #fffffff5;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 35px 36px;
    box-shadow: 0 10px 8px rgba(0,0,0,0.1);
    /* 对话框效果 */
}



/* PC端自定义tooltip - 显示在图标左侧 */
@media (min-width: 768px) {
    /* 功能图标按钮的tooltip */
    .feature-icon-btn {
        position: relative; /* 为 ::after 提供定位基准 */
    }
    
    .feature-icon-btn:hover::after {
        content: attr(title);
        position: absolute;
        right: calc(100% + 12px); /* 显示在按钮左侧，距离12px */
        top: 50%;
        transform: translateY(-50%); /* 垂直居中 */
        background: rgba(0, 0, 0, 0.85);
        color: #fff;
        padding: 6px 10px;
        border-radius: 6px;
        font-size: 13px;
        white-space: nowrap; /* 不换行 */
        pointer-events: none; /* 不阻挡鼠标事件 */
        z-index: 9999;
        opacity: 0;
        animation: tooltipFadeIn 0.2s ease-out forwards; /* 淡入动画 */
    }
    
    /* 隐藏原生tooltip */
    .feature-icon-btn:hover {
        pointer-events: auto;
    }
    
    /* tooltip淡入动画 */
    @keyframes tooltipFadeIn {
        from {
            opacity: 0;
            transform: translateY(-50%) translateX(5px);
        }
        to {
            opacity: 1;
            transform: translateY(-50%) translateX(0);
        }
    }
    
    /* 语言选择按钮的tooltip */
    .lang-icon-btn {
        position: relative;
    }
    
    .lang-icon-btn:hover::after {
        content: attr(title);
        position: absolute;
        right: calc(100% + 12px);
        top: 50%;
        transform: translateY(-50%);
        background: rgba(0, 0, 0, 0.85);
        color: #fff;
        padding: 6px 10px;
        border-radius: 6px;
        font-size: 13px;
        white-space: nowrap;
        pointer-events: none;
        z-index: 9999;
        opacity: 0;
        animation: tooltipFadeIn 0.2s ease-out forwards;
    }
}
.stop-square {
    width: 16px;
    height: 16px;
    background-color: #fff;
    border-radius: 2px;
}







/* AI反馈按钮区域 */
.ai-feedback-buttons {
    display: flex;
    gap: 12px;  /* 增加按钮间距 */
    margin-top: 12px;  /* 增加与文字的间距 */
    padding: 4px 0;
    align-items: center;
    justify-content: flex-end;  /* 改为右对齐 */
    position: relative;  /* 为点踩弹窗提供定位基准 */
}

/* 反馈元信息展示（feedback/fk/suggest） */
.ai-feedback-meta {
    margin: 6px 0 0 0;
    font-size: 12px;
    color: #777;
}

.feedback-btn {
    /* width: 28px;
    height: 28px; */
    border: none;
    border-radius: 50%;
    background: #f5f5f5;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    font-size: 30px;
}

.feedback-btn:hover {
    background: #e0e0e0;
    transform: scale(1.1);
}

/* 移动端禁用hover效果 */
@media (max-width: 480px) {
    .feedback-btn:hover {
        background: #f5f5f5;
        transform: none;
    }
    
    .feedback-btn.active:hover {
        background: #e5e5e5;
        transform: none;
    }
    
    .feedback-btn.active.like-btn:hover {
        background: #30b04d; /* 绿色hover - 稍微深一点的绿色 */
        transform: none;
    }
    
    .feedback-btn.active.dislike-btn:hover {
        background: #e6342a; /* 红色hover - 稍微深一点的红色 */
        transform: none;
    }
}

.feedback-btn.active {
    background: #e5e5e5;
}

.feedback-btn.active.like-btn {
    background: #34c759; /* 绿色 - 笑脸激活状态 */
}

.feedback-btn.active.dislike-btn {
    background: #ff3b30; /* 红色 - 哭脸激活状态 */
}

.feedback-btn span {
    display: block;
    line-height: 1;
}

.ai-feedback-buttons .feedback-icon {
    width: 18px !important;
    height: 18px !important;
    max-width: 18px !important;
    max-height: 18px !important;
    display: block !important;
    object-fit: contain !important;
}

.tts-btn {
    background: #f5f5f5;
}

.tts-btn:hover {
    background: #e0e0e0;
}
























.more-btn {
    background: #f5f5f5;
}

.more-btn:hover {
    background: #e0e0e0;
}

/* 点踩评价弹窗样式  中间 */
/* .dislike-feedback-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
    background: rgba(0, 0, 0, 0.25);
    z-index: 2000;
    box-sizing: border-box;
}

.dislike-popup-content {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
    padding: 20px 18px;
    border: 1px solid rgba(0, 0, 0, 0.05);
    width: min(420px, 90vw);
    max-height: min(80vh, 520px);
    overflow-y: auto;
    box-sizing: border-box;
} */
 /* 点踩评价弹窗样式   评价下面 */
/* .dislike-feedback-popup {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    z-index: 9999;
    min-width: 320px;
    max-width: 400px;
}

.dislike-popup-content {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    padding: 16px;
    border: 1px solid #e0e0e0;
} */
/* 向上 */
.dislike-feedback-popup {
    position: absolute;
    right: 0;
    z-index: 1000;
    min-width: 320px;
    max-width: 400px;
    
}

.dislike-popup-content {
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 -4px 20px rgba(0, 0, 0, 0.15); 
    padding: 16px;
    border: 1px solid #e0e0e0;
}  



.dislike-popup-title {
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 12px;
}

.dislike-options {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    margin-bottom: 12px;
}

.dislike-option-btn {
    padding: 10px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fff;
    cursor: pointer;
    font-size: 13px;
    color: #333;
    transition: all 0.2s;
    text-align: center;
}

.dislike-option-btn:hover {
    background: #f5f5f5;
    border-color: #007aff;
}

.dislike-option-btn.active {
    background: #e6f7ff;
    border-color: #007aff;
    color: #007aff;
    font-weight: 600;
}

.dislike-textarea-wrapper {
    margin-bottom: 12px;
}

.dislike-textarea {
    width: 100%;
    padding: 10px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 13px;
    resize: vertical;
    min-height: 70px;
    font-family: inherit;
    box-sizing: border-box;
}

.dislike-textarea:focus {
    outline: none;
    border-color: #007aff;
}

.dislike-textarea-counter {
    text-align: right;
    font-size: 12px;
    color: #999;
    margin-top: 4px;
    padding-right: 2px;
}

.dislike-popup-footer {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
}

.dislike-cancel-btn,
.dislike-submit-btn {
    padding: 8px 16px;
    border-radius: 6px;
    font-size: 13px;
    cursor: pointer;
    border: none;
    transition: all 0.2s;
}

.dislike-cancel-btn {
    background: #f5f5f5;
    color: #333;
}

.dislike-cancel-btn:hover {
    background: #e0e0e0;
}

.dislike-submit-btn {
    background: #007aff;
    color: #fff;
}

.dislike-submit-btn:hover {
    background: #0056d6;
}

/* 反馈弹窗样式 */
.feedback-dialog .el-dialog {
    width: 500px; /* PC端默认宽度 */
}

.feedback-dialog-content {
    padding: 20px 0;
}

.feedback-options {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 20px;
}

.feedback-option-btn {
    padding: 12px 16px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: white;
    cursor: pointer;
    transition: all 0.2s ease;
    font-size: 14px;
    color: #333;
    font-weight: 500;
    text-align: center;
    min-height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.feedback-option-btn:hover {
    background: #f5f5f5;
    border-color: #007aff;
}

.feedback-option-btn.active {
    background: #e6f7ff;
    border-color: #007aff;
    color: #007aff;
    font-weight: 600;
}

.feedback-custom-input {
    margin-top: 20px;
}

.feedback-textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    font-size: 14px;
    resize: vertical;
    min-height: 80px;
    font-family: inherit;
}

.feedback-textarea:focus {
    outline: none;
    border-color: #007aff;
}

/* PC端适配 */
@media (min-width: 481px) {
    .feedback-dialog-content {
        padding: 25px 0;
    }
    
    .feedback-options {
        gap: 15px;
        margin-bottom: 25px;
    }
    
    .feedback-option-btn {
        padding: 16px 20px;
        font-size: 16px;
        border-radius: 8px;
        transition: all 0.3s ease;
    }
    
    .feedback-option-btn:hover {
        background: #f0f8ff;
        border-color: #409eff;
        transform: translateY(-1px);
    }
    
    .feedback-textarea {
        min-height: 120px;
        font-size: 15px;
        padding: 15px;
        border-radius: 8px;
    }
    
    .feedback-dialog .el-dialog__header {
        padding: 20px 25px 15px !important;
        font-size: 18px;
        font-weight: 600;
    }
    
    .feedback-dialog .el-dialog__body {
        padding: 0 25px !important;
    }
    
    .feedback-dialog .el-dialog__footer {
        padding: 15px 25px 20px !important;
    }
    
    .feedback-dialog .el-button {
        padding: 10px 20px;
        font-size: 15px;
        border-radius: 6px;
    }
}

/* 反馈弹窗移动端适配 */
@media (max-width: 580px) {
    .feedback-dialog .el-dialog {
        width: 100% !important;
        max-width: none !important;
        margin: 0 !important;
        height: 100vh !important;
        border-radius: 0 !important;
    }
    
    .feedback-dialog-content {
        padding: 0;
        height: auto;
        display: block;
    }
    
    .feedback-options {
        gap: 10px;
        margin-bottom: 15px;
        grid-template-columns: repeat(2, 1fr); /* 移动端2列布局 */
    }
    
    .feedback-option-btn {
        padding: 14px 12px;
        font-size: 14px;
        border-radius: 8px;
        min-height: 48px;
        text-align: center;
        line-height: 1.3;
    }
    
    .feedback-custom-input {
        margin-top: 15px;
    }
    
    .feedback-textarea {
        padding: 16px;
        min-height: 100px;
        font-size: 16px;
        border-radius: 8px;
        resize: vertical;
    }
    
    /* 弹窗标题和按钮样式 */
    .feedback-dialog .el-dialog__header {
        padding: 20px 20px 15px !important;
        border-bottom: 1px solid #f0f0f0;
    }
    
    .feedback-dialog .el-dialog__body {
        padding: 20px !important;
    }
    
    .feedback-dialog .el-dialog__footer {
        padding: 15px 20px 20px !important;
        border-top: 1px solid #f0f0f0;
    }
    
    .feedback-dialog .el-button {
        padding: 12px 24px;
        font-size: 15px;
        border-radius: 8px;
        min-width: 80px;
    }
}

/* 移动端适配 */
@media (max-width: 480px) {
    .ai-feedback-buttons {
        gap: 11px;  /* 移动端也增加间距 */
    }
    
    .feedback-btn {
        /* width: 30px;
        height: 30px; */
        font-size: 23px;
    }
    /* 移动端评价图片大小 */
    .ai-feedback-buttons .feedback-icon {
        width: 25px !important;
        height: 25px !important;
        max-width: 25px !important;
        max-height: 25px !important;
    }
    
    .feedback-btn.active {
        background: #e5e5e5 !important;
    }
    
    .feedback-btn.active.like-btn {
        background: #34c759 !important; /* 绿色 - 笑脸激活状态 */
    }
    
    .feedback-btn.active.dislike-btn {
        background: #ff3b30 !important; /* 红色 - 哭脸激活状态 */
    }
    
    .feedback-options {
        grid-template-columns: repeat(2, 1fr);
    }
    
    .feedback-option-btn {
        padding: 10px 12px;
        font-size: 13px;
    }
}
</style>